<template>
  <div class="material-book-container">
    <img :src="showMaterialBookContent ? rightBtn : leftBtn" alt="物料书" class="material-book-btn" @click="showBook">
    <!-- <div class="material-book-btn" @click="showBook">物<br/>料<br/>书<br/>{{ showMaterialBookContent ? '&gt;' : '&lt;' }}</div> -->
    <div class="material-book-content" v-if="showMaterialBookContent">
      <div class="material-book-title">物料书关联页</div>
      <template v-if="materialFileAllList.length > 0">
        <div class="material-book-tip">如关联页不准确，可下载完整版查阅</div>
        <div style="margin-bottom: 10px;" v-for="materialFile in materialFileAllList" :key="materialFile.id">
          <span style="font-size: 14px; color: #fff;margin-right: 10px;">{{ materialFile.name }}</span>
          <v-btn variant="text" size="small" @click="previewMaterialBook(materialFile.url)" style="background:rgba(0, 0, 0, 0.4);padding: 0 2px;">
            <v-icon style="margin-right: 2px;">mdi-download</v-icon>
            下载
          </v-btn>
        </div>
      </template>
      <template v-if="materialFileList.length > 0">
        <div class="material-book-list">
          <template v-for="materialFile in materialFileList" :key="materialFile.id">
            <div class="material-book-list">
              <template v-for="materialFile in materialFileList" :key="materialFile.id">
                <div class="material-images-container">
                  <div class="image-preview-list">
                    <div class="image-preview-item" style="width: 100%;height: auto;">
                      <img :src="materialFile.url" alt="">
                      <div class="image-actions"  @click="handleMaterialImagePreview(materialFileList, index, imageIndex, false)">
                        <v-icon 
                          icon="mdi-eye" 
                          size="20"
                          @click.stop="handleMaterialImagePreview(materialFileList, index, imageIndex, false)"
                        ></v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
      <div v-else style="text-align: center;color: #fff;margin-top: 10px;">
        <div v-if="Number(materialFileStatus) === 0">物料书解析中</div>
        <div v-else>暂无相关物料书关联页</div>
      </div>
    </div>
  </div>
  <div class="material-list-page">
    <div class="material-list-container">
      <v-card class="form-card">
        <!-- <v-card-title class="text-h6">产品估价</v-card-title> -->
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <!-- 产品信息  :class="{ 'fixed-top': isProductInfoFixed }"-->
            <!-- <div style="height: 138px;">width: 1400px;</div> fixed-topheight: 158px; -->
            <div class="product-info-section" ref="productInfoSection" style="padding: 0;">
              <!-- <div class="section-title">产品信息</div> -->
              <div class="form-section material-list-section">
                <!-- <div class="d-flex justify-end pa-2"></div> -->
                <div class="table-container product-table-container">
                  <v-table class="product-table" hover>
                    <!-- <thead>
                      <tr>
                        <th v-for="header in productHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.minWidth }">
                          {{ header.title }}
                        </th>
                      </tr>
                    </thead> -->
                    <tbody>
                      <tr 
                        :style="{ 
                          position: 'relative',
                          height: isRowZoomed(index) ? '300px' : 'auto'
                        }"
                      >
                        <td v-for="header in productHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: header.minWidth }">
                          <template v-if="header.key === 'imageUrls'">
                              <div
                                style="width: 140px; height: 140px;"
                                :class="[
                                  'product-images-container',
                                  isRowZoomed(index) ? 'preview-image-zoomed' : ''
                                ]"
                              >
                              <div class="image-preview-list" v-if="productInfo.productImageUrls && productInfo.productImageUrls.length > 0">
                                <template v-for="(image, imageIndex) in productInfo.productImageUrls" :key="imageIndex">
                                  <div class="image-preview-item" v-if="imageIndex === getCurrentImageIndex(index)" >
                                    <v-img
                                      :src="getImagePreviewUrl(image)"
                                      cotain
                                      class="preview-image"
                                      @click="handleMaterialImagePreview(productInfo.productImageUrls, 0, imageIndex, false, 'product')"
                                    ></v-img>
                                    <div class="image-actions">
                                      <v-icon 
                                        icon="mdi-eye" 
                                        size="20"
                                        @click.stop="handleMaterialImagePreview(productInfo.productImageUrls, 0, imageIndex, false, 'product')"
                                      ></v-icon>
                                    </div>
                                    <!-- <div class="image-count-preview">
                                      <img class="image-count-icon" src="@/assets/picicon.png" alt="">
                                      {{ '共' + productInfo.productImageUrls.length + '张' }}
                                    </div> -->
                                    <!-- 图片切换控制按钮 -->
                                    <div class="image-navigation" :style="isRowZoomed(index) ? {scale: '1', left: '50%', transform: 'translateX(-50%)',width: '180px'} : {scale: '0.7', left: '-20px', right: '0',width: '180px'}">
                                      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
                                      <v-btn
                                        v-if="productInfo.productImageUrls.length > 1"
                                        icon="mdi-chevron-left"
                                        size="small"
                                        variant="text"
                                        color="white"
                                        class="nav-btn prev-btn"
                                        @click.stop="prevImage(index)"
                                        :disabled="getCurrentImageIndex(index) === 0"
                                      ></v-btn>
                                      
                                      <!-- 放大缩小按钮 -->
                                      <div class="zoom-controls">
                                        <v-btn
                                          icon="mdi-magnify-plus"
                                          size="small"
                                          variant="text"
                                          color="white"
                                          class="zoom-btn"
                                          @click.stop="zoomIn(index)"
                                          :disabled="isRowZoomed(index)"
                                          title="放大"
                                          style="margin-right: 10px;"
                                        ></v-btn>
                                        <v-btn
                                          icon="mdi-magnify-minus"
                                          size="small"
                                          variant="text"
                                          color="white"
                                          class="zoom-btn"
                                          @click.stop="zoomOut(index)"
                                          :disabled="!isRowZoomed(index)"
                                          title="缩小"
                                        ></v-btn>
                                      </div>
                                      
                                      <!-- <span class="image-counter">{{ getCurrentImageIndex(index) + 1 }} / {{ item.productImageUrls.length }}</span> -->
                                      <v-btn
                                        v-if="productInfo.productImageUrls.length > 1"
                                        icon="mdi-chevron-right"
                                        size="small"
                                        variant="text"
                                        color="white"
                                        class="nav-btn next-btn"
                                        @click.stop="nextImage(index)"
                                        :disabled="getCurrentImageIndex(index) === productInfo.productImageUrls.length - 1"
                                      ></v-btn>
                                    </div>  
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <div v-else class="no-img" style="line-height: 100px;">
                                暂无产品图
                              </div>
                            </div>
                          </template>
                          <template v-else-if="header.key === 'info'">
                              <!-- <div class="product-info-item">{{ productInfo.code }}</div> -->
                              <div class="product-info-item">{{ productInfo.syscode }}</div>
                              <div class="product-info-item">{{ productInfo.name }}</div>
                              <div class="product-info-item count-item">数量:{{ productInfo.count }}</div>
                          </template>
                          <template v-else-if="header.key === 'description'">
                            <v-textarea
                              label="估价备注"
                              persistent-placeholder
                              v-model="productInfo.priceRemark"
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              auto-grow
                              resize
                              :readonly="isEdit !== 'estimate' || !isCanEdit"
                              :class="isEdit !== 'estimate' || !isCanEdit ? 'v-field--readonly auto-grow-textarea description scroll-textarea position-relative' : 'auto-grow-textarea description scroll-textarea position-relative'"
                              style="overflow-y: auto;max-height: 120px;"
                              @blur="updateProductMaterialSummary"
                            >
                            <template v-slot:append>
                              <img 
                                src="@/assets/desTip.png" 
                                alt="描述" 
                                style="width: 32px; height: 16px; cursor: pointer; top: 16px;position: absolute;left: 4px;z-index: 1000;" 
                                @click="showMaterialDescriptionMerge(productInfo.description)"
                              />
                            </template>
                          </v-textarea>
                          </template>
                          <template v-else-if="header.key === 'size'">
                            <v-text-field
                              label="W"
                              persistent-placeholder
                              v-model="productInfo.width"
                              type="number"
                              variant="outlined"
                              density="compact"
                              hide-details
                              min="0"
                              readonly
                              class="v-field--readonly text-right size-input"
                            ></v-text-field>
                            <!-- :readonly="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit"
                              :class="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit ? 'v-field--readonly text-right size-input' : 'text-right size-input'"
                              @input="e => handleNumberInput(e, productInfo, 'width', index)" -->
                            <v-text-field
                              label="D"
                              persistent-placeholder
                              v-model="productInfo.depth"
                              type="number"
                              variant="outlined"
                              density="compact"
                              hide-details
                              min="0"
                              readonly
                              class="v-field--readonly text-right size-input"
                            ></v-text-field>
                            <!-- :readonly="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit"
                              :class="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit ? 'v-field--readonly text-right size-input' : 'text-right size-input'"
                              @input="e => handleNumberInput(e, productInfo, 'depth', index)" -->
                            <v-text-field
                              label="H"
                              persistent-placeholder
                              v-model="productInfo.height"
                              type="number"
                              variant="outlined"
                              density="compact"
                              hide-details
                              min="0"
                              style="margin-bottom: 0px!important;"
                              readonly
                              class="v-field--readonly text-right size-input"
                            ></v-text-field>
                            <!-- :readonly="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit"
                              :class="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || !isCanEdit ? 'v-field--readonly text-right size-input' : 'text-right size-input'"
                              @input="e => handleNumberInput(e, productInfo, 'height', index)" -->
                          </template>
                          <template v-else-if="header.key === 'evaluate'">
                            <div class="price-input-group priceLeft top-input">
                              <div class="position-relative" style="display: inline-block;">
                                <!-- <div class="local-amount-display">
                                  {{ formatNumber(productInfo.priceLocal) }}
                                </div> -->
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="isEdit === 'materialControl' || (statusPricing !== 3 && isEdit !== 'estimate') ? '/' : formatNumber(productInfo.price)"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="单价预估"
                                  readonly
                                  class="v-field--readonly total-amount-field mb-1 text-right"
                                >
                                </v-text-field>
                              </div>
                            </div>
                            <div class="price-input-group priceLeft">
                              <div class="position-relative" style="display: inline-block;">
                                <!-- <div class="local-amount-display" v-if="selectedProvince == '海外' && productInfo.totalLocal !== 0 && isEdit != 'materialControl'">
                                  ${{ formatNumber(productInfo.totalLocal) }}
                                </div> -->
                                <v-text-field
                                  :model-value="isEdit === 'materialControl' || (statusPricing !== 3 && isEdit !== 'estimate') ? '/' : formatNumber(productInfo.total)"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="总额预估"
                                  readonly
                                  class="v-field--readonly total-amount-field mb-1 text-right"
                                >
                                </v-text-field>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="header.key === 'evaluateDetail'">
                            <div class="clear-fix" v-if="(statusPricing === 3 && isEdit !== 'materialControl') || isEdit === 'estimate'">
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.baseModifyTime">
                                  料单{{ productInfo.materialSummary.base }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.baseModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="基材"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.paintModifyTime">
                                  料单{{ productInfo.materialSummary.paint }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.paintModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="油漆"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.differenceModifyTime">
                                  料单{{ productInfo.materialSummary.difference }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.differenceModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="差价"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >     
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.smallHardwareModifyTime">
                                  料单{{ productInfo.materialSummary.smallHardware }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.smallHardwareModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="小五金"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.glassModifyTime">
                                  料单{{ productInfo.materialSummary.glass }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.glassModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="玻璃"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.stoneModifyTime">
                                  料单{{ productInfo.materialSummary.stone }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.stoneModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="石材"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.fabricModifyTime">
                                  料单{{ productInfo.materialSummary.fabric }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.fabricModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="面料"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.purchasePartsModifyTime">
                                  料单{{ productInfo.materialSummary.purchaseParts }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.purchasePartsModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="外购件"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <div class="has-normal-input" v-if="productInfo.materialSummary.bigHardwareFeeModifyTime">
                                  料单{{ productInfo.materialSummary.bigHardwareFee }}
                                </div>
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="大五金"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input right-0 top-input">
                                <v-text-field
                                label="调整系数"
                                persistent-placeholder
                                v-model="productInfo.materialSummary.adjustment"
                                type="number"
                                variant="outlined"
                                density="compact"
                                hide-details
                                class="total-amount-field mb-1 text-right"
                                :readonly="isEdit !== 'estimate' || !isCanEdit"
                                :class="{ 'v-field--readonly': isEdit !== 'estimate' || !isCanEdit }"
                                @blur="updateProductMaterialSummary"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input">
                                <v-text-field
                                  label="面料用量"
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.fabricUsage"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.installationFee"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="安装费"
                                  class="total-amount-field mb-1 text-right"
                                  :readonly="isEdit !== 'estimate' || !isCanEdit"
                                  :class="{ 'v-field--readonly': isEdit !== 'estimate' || !isCanEdit }"
                                  @blur="updateProductMaterialSummary"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.freightFee"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="运费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                <img 
                                  v-if="isEdit === 'estimate' && isCanEdit"
                                  @click="handleCalculateTip('freightFee')"
                                  src="@/assets/calcTip.png" 
                                  alt="公式" 
                                  class="calc-tip"
                                />
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.laborFee"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="人工"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                <img 
                                  v-if="isEdit === 'estimate' && isCanEdit"
                                  @click="handleCalculateTip('laborFee')"
                                  src="@/assets/calcTip.png" 
                                  alt="公式" 
                                  class="calc-tip"
                                />
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.manufacturingFee"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="制费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                <img 
                                  v-if="isEdit === 'estimate' && isCanEdit"
                                  @click="handleCalculateTip('manufacturingFee')"
                                  src="@/assets/calcTip.png" 
                                  alt="公式" 
                                  class="calc-tip"
                                />
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.profit"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="利润"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >  
                                <img 
                                  v-if="isEdit === 'estimate' && isCanEdit"
                                  @click="handleCalculateTip('profit')"
                                  src="@/assets/calcTip.png" 
                                  alt="公式" 
                                  class="calc-tip"
                                /> 
                                </v-text-field>
                              </div>
                              <div class="float-left big-input right-0">
                                <v-text-field
                                  persistent-placeholder
                                  v-model="productInfo.materialSummary.taxFee"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="税费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >
                                <img 
                                  v-if="isEdit === 'estimate' && isCanEdit"
                                  @click="handleCalculateTip('taxFee')"
                                  src="@/assets/calcTip.png" 
                                  alt="公式" 
                                  class="calc-tip"
                                />  
                                </v-text-field>
                              </div>
                            </div>
                            <div class="clear-fix" v-else>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="基材"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="油漆"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="差价"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="小五金"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="玻璃"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="石材"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>  
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="面料"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="外购件"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="大五金"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input position-relative top-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="调整系数"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input">
                                <v-text-field
                                  label="面料用量"
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left small-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="安装费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="运费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >  
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="人工"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="制费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left big-input">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="利润"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                              <div class="float-left big-input right-0">
                                <v-text-field
                                  persistent-placeholder
                                  :model-value="'/'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  label="税费"
                                  readonly
                                  class="total-amount-field mb-1 text-right v-field--readonly"
                                >   
                                </v-text-field>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="header.key === 'actions'">
                            <div class="align-center">
                              <div class="seeRecord" @click="loading ? '' : handleEstimate(index)">物料清单</div>
                              <v-btn
                                color="primary"
                                size="small"
                                variant="flat"
                                @click="handleDrawings(index)"
                              >
                              图纸
                              </v-btn>
                              <v-btn
                                color="error"
                                variant="tonal"
                                @click="handleModifyLog(index, item.id)"
                              >
                              修改日志
                              </v-btn>
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
            
            <!-- 物料清单 -->
            <!-- <div class="section-title">物料清单</div> -->
            <div class="form-section material-list-section">
              <!-- <div class="d-flex justify-end pa-2"> -->
                <!-- <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  variant="tonal"
                  @click="addMaterialItem"
                  density="compact"
                >
                  添加物料
                </v-btn> -->
              <!-- </div> -->
              <div class="product-table-container" ref="materialTableContainer">
                <v-table class="product-table material-table " hover fixed-header :style="{ maxHeight: `calc(100vh - 350px)` }">
                  <!-- <thead style="position: fixed; top: 220px; z-index: 5000;background-color: rgb(43, 45, 51) !important;width: 1345px;"> -->
                  <thead>
                    <tr>
                      <th v-for="header in materialHeaders" :key="header.key" :class="['text-' + header.align]" :style="{ minWidth: `${Number(header.minWidth) + 1}px` }">
                        {{ header.title }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="materialList.length === 0">
                      <td colspan="100%" class="text-center">
                        暂无物料数据
                      </td>
                    </tr>
                    <tr 
                      v-for="(item, index) in materialList" 
                      :key="index" 
                      :style="{ 
                        height: isMaterialRowZoomed(index) ? '300px' : 'auto',
                        backgroundImage: Number(item.isDelete) === 1 ? 'url(' + delBg + ')' : 'transparent'
                      }"
                      class="del-tr"
                    >
                    <!-- <template v-if="item.isTurn">
                      <img src="@/assets/delBg.png" alt="turn" style="width: 100%;height: 100%;">
                    </template> -->
                    <!-- <tr v-for="(item, index) in materialList" :key="index"> -->
                      <td v-for="header in materialHeaders" :key="header.key" :style="{ minWidth: header.minWidth + 'px' }">
                        <template v-if="header.key === 'name'"><!-- && isAddBySelf-->
                          <template v-if="(isEdit === 'edit' || isEdit === 'estimate')">
                            <div class="d-flex align-center name-input" style="padding-top: 10px;margin-left: 6px;">
                              <v-textarea
                                label="物料名称"
                                persistent-placeholder
                                variant="outlined"
                                density="compact"
                                hide-details
                                rows="1"
                                auto-grow
                                resize
                                v-model="item.name"
                                readonly
                                class="v-field--readonly"
                                :append-inner-icon="item.isTurn || !isCanEdit ? '' : 'mdi-magnify'"
                                :class="{ 'icon-white': !item.isTurn || !isCanEdit }"
                                @click="!item.isTurn && isCanEdit ? showMaterialSuggestions(index) : null"
                                @input="debouncedAutoSaveMaterial(index)"
                              ></v-textarea>
                              <!-- <v-btn
                                v-if="isCanEdit"
                                icon="mdi-magnify"
                                size="small"
                                variant="text"
                                class="ml-0"
                                :disabled="item.isTurn"
                                @click="showMaterialSuggestions(index)"
                              ></v-btn> -->
                            </div>
                            <!-- <div style="padding-top: 10px;">
                              <v-text-field style="margin-left: 6px;"
                                label="规格"
                                persistent-placeholder
                                variant="outlined"
                                density="compact"
                                hide-details
                                rows="1"
                                auto-grow
                                resize
                                v-model="item.specification"
                                :readonly="item.isTurn || !isCanEdit"
                                :class="{ 'v-field--readonly': item.isTurn || !isCanEdit }"
                                @input="inputMaterialSpecification(index)"
                              ></v-text-field>
                            </div> -->
                            <div style="font-size: 12px; color: #8F9093;text-align: left;margin-left: 6px;">
                              规格：{{ item.specification }}<br>
                              <!-- 单位：{{ item.materialUnit }}<br> -->
                              <!-- 系统编号：{{ item.code }}<br> -->
                            </div>
                          </template>
                          <!-- <v-text-field
                            v-model="item.name"
                            variant="outlined"
                            density="compact"
                            hide-details
                            readonly
                            @focus="showMaterialSuggestions(index)"
                          ></v-text-field> -->
                          <div style="padding-top: 6px;margin-left: 6px;" v-else-if="(isEdit === 'edit' || isEdit === 'estimate' || isEdit === 'materialControl' ) && !isAddBySelf">
                            <v-textarea v-if="isEdit === 'edit' || isEdit === 'estimate' || isEdit === 'materialControl'"
                              label="物料名称"
                              persistent-placeholder
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              auto-grow
                              resize
                              v-model="item.name"
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="showMaterialSuggestions(index)"
                              @input="debouncedAutoSaveMaterial(index)"
                              style="margin-bottom: 10px;"
                            ></v-textarea>
                            <!-- <v-text-field
                              label="规格"
                              persistent-placeholder
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              auto-grow
                              resize
                              v-model="item.specification"
                              :readonly="item.isTurn"
                              :class="{ 'v-field--readonly': item.isTurn }"
                              @input="inputMaterialSpecification(index)"
                            ></v-text-field> -->
                            <div style="font-size: 12px; color: #8F9093;text-align: left;">
                              规格：{{ item.specification }}<br>
                              <!-- 单位：{{ item.materialUnit }}<br> -->
                              <!-- 系统编号：{{ item.code }}<br> -->
                            </div>
                            <!-- <v-text-field
                              label="编号"
                              persistent-placeholder
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              auto-grow
                              resize
                              v-model="item.code"
                              @input="autoSave"
                              style="margin-bottom: 10px;"
                            ></v-text-field>
                            <v-text-field
                              label="规格"
                              persistent-placeholder
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              auto-grow
                              resize
                              v-model="item.specification"
                              @input="autoSave"
                            ></v-text-field> -->
                          </div>
                          <div v-else style="font-size: 12px; color: #8F9093;text-align: left;">
                            <div style="font-size: 14px;color: #fff;padding-left: 4px;">物料名称：{{ item.name }}</div>
                            规格：{{ item.specification }}<br>
                            <!-- 单位：{{ item.materialUnit }}<br> -->
                            系统编号：{{ item.code }}<br>
                          </div>
                        </template>
                        <!-- <template v-else-if="header.key === 'supplier'">
                          <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                            {{ item.supplier }}
                          </div>
                          <v-textarea v-else
                            v-model="item.supplier"
                            variant="outlined"
                            density="compact"
                            hide-details
                            rows="1"
                            auto-grow
                            resize
                            @input="autoSave"
                          ></v-textarea>
                        </template> -->
                        <template v-else-if="header.key === 'materialDescription'">
                          <div style="text-align: left!important;" v-if="isEdit === 'see' || isEdit === 'materialControl'">
                            {{ item.materialDescription || '/' }}
                          </div>
                          <div style="padding-top: 10px;margin-bottom: 10px;" v-else>
                            <v-textarea
                              label="业务描述"
                              persistent-placeholder
                              v-model="item.materialDescription"
                              variant="outlined"
                              density="compact"
                              hide-details
                              rows="1"
                              maxlength="500"
                              no-resize
                              class="auto-grow-textarea height-description"
                              :readonly="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || item.isTurn || !isCanEdit"
                              :class="{ 'v-field--readonly': isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || item.isTurn || !isCanEdit }"
                              @input="handleTextareaInput($event, index)"
                            ></v-textarea>
                          </div>
                        </template>
                        <template v-else-if="header.key === 'salesmanRemark'">
                          <v-textarea
                            v-model="item.salesmanRemark"
                            variant="outlined"
                            density="compact"
                            hide-details
                            rows="1"
                            maxlength="500"
                            auto-grow
                            no-resize
                            :readonly="isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || item.isTurn || !isCanEdit"
                            :class="{ 'v-field--readonly': isEdit === 'see' || isEdit === 'materialControl' || isEdit === 'estimate' || item.isTurn || !isCanEdit }"
                            class="auto-grow-textarea"
                            @input="handleTextareaInput($event, index)"
                          ></v-textarea>
                        </template>
                        <template v-else-if="header.key === 'type'">
                          <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                            {{ item.type }}
                          </div>
                          <v-select v-else
                            v-model="item.type"
                            disabled
                            class="v-field--readonly"
                            item-title="title"
                            item-value="value"
                            variant="outlined"
                            density="compact"
                            hide-details
                            @update:model-value="handleChangeType(index)"
                            :readonly="item.isTurn || !isCanEdit"
                            :class="{ 'v-field--readonly': item.isTurn || !isCanEdit }"
                          ></v-select>
                        </template>
                            <!-- :items="item.bigClass ? getMaterialTypeOptions(item.bigClass) : [{ title: '请先选大类', value: '', disabled: true }]" -->
                        <template v-else-if="header.key === 'bigClass'">
                          <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                            {{ item.bigClass }}
                          </div>
                          <v-select v-else
                            v-model="item.bigClass"
                            disabled
                            class="v-field--readonly"
                            :items="bigClassOptions"
                            item-title="title"
                            item-value="value"
                            variant="outlined"
                            density="compact"
                            hide-details
                            @update:model-value="handleChangeBigClass(index)"
                            :readonly="item.isTurn || !isCanEdit"
                            :class="{ 'v-field--readonly': item.isTurn || !isCanEdit }"
                          ></v-select>
                        </template>
                        <!-- <template v-else-if="header.key === 'bigClass'">
                          <div>{{ item.bigClass }}</div>
                        </template>
                        <template v-else-if="header.key === 'type'">
                          <div>{{ item.type }}</div>
                          <v-select
                            v-model="item.type"
                            :items="materialTypes"
                            variant="outlined"
                            density="compact"
                            hide-details
                            readonly
                            class="v-field--readonly"
                          ></v-select>
                        </template> -->
                        <template v-else-if="header.key === 'image'">
                          <div class="material-images-container" style="width: 80px; height: 80px;">
                            <div
                                :class="[
                                  'product-images-container',
                                  isMaterialRowZoomed(index) ? 'preview-image-zoomed' : ''
                                ]"
                                style="width: 80px; height: 80px; margin: 0 auto;"
                              >
                              <MaterialImagePreview
                                :image-urls="item.images || []"
                                :parent-index="index"
                                image-type="material"
                                :current-image-index="getCurrentMaterialImageIndex(index)"
                                :is-zoomed="isMaterialRowZoomed(index)"
                                :can-delete="isEdit !== 'see' && !item.isTurn && isCanEdit"
                                @update:current-image-index="(imageIndex) => updateMaterialImageIndex(index, imageIndex)"
                                @zoom-in="() => zoomMaterialIn(index)"
                                @zoom-out="() => zoomMaterialOut(index)"
                                @image-preview="handleMaterialImagePreview(item.images, index, getCurrentMaterialImageIndex(index), isEdit !== 'see', 'wuliao')"
                                @image-upload="handleMaterialImageUpload"
                                @upload-success="handleMaterialUploadSuccess"
                              />
                            </div>
                          </div>
                        </template>
                        <template v-else-if="header.key === 'price'">
                          <div style="padding: 15px 0;">
                            <v-text-field
                              label="单价估价"
                              persistent-placeholder
                              v-model="item.price"
                              type="number"
                              variant="outlined"
                              density="compact"
                              hide-details
                              :class="isEdit !== 'estimate' || item.isTurn || !isCanEdit ? 'v-field--readonly text-right' : 'text-right'"
                              :readonly="isEdit !== 'estimate' || item.isTurn || !isCanEdit"
                              @input="e => calculateTotal(e, index, 'price')"
                              @blur="debouncedAutoSaveMaterial(index)"
                            ></v-text-field>
                          </div>
                        </template>
                        <template v-else-if="header.key === 'materialCustomerNo'">
                          <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                            {{ item.materialCustomerNo }}
                          </div>
                          <v-textarea v-else
                            v-model="item.materialCustomerNo"
                            variant="outlined"
                            density="compact"
                            hide-details
                            rows="1"
                            maxlength="500"
                            auto-grow
                            no-resize
                            class="auto-grow-textarea"
                            :readonly="item.isTurn || !isCanEdit"
                            :class="{ 'v-field--readonly': item.isTurn || !isCanEdit }"
                            @input="handleTextareaInput($event, index)"
                          ></v-textarea>
                        </template>
                        <template v-else-if="header.key === 'count'">
                          <div>
                            <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                              {{ item.count }}
                            </div>
                            <!-- :readonly="isEdit === 'see' || isEdit === 'materialControl'" -->
                            <v-text-field v-else
                              v-model="item.count"
                              persistent-placeholder
                              type="number"
                              variant="outlined"
                              density="compact"
                              hide-details
                              class="text-right"
                              :class="{ 'v-field--readonly': (isEdit !== 'estimate' && isEdit !== 'edit') || item.isTurn || !isCanEdit }"
                              :readonly="(isEdit !== 'estimate' && isEdit !== 'edit') || item.isTurn || !isCanEdit"
                              @input="e => calculateTotal(e, index, 'count')"
                            ></v-text-field>
                            
                            <!-- @blur="debouncedAutoSaveMaterial(index)" -->
                          <!-- </template> -->
                          <!-- <template v-else-if="header.key === 'materialUnit'"> -->
                            <!-- <v-text-field v-if="isEdit === 'edit' || isEdit === 'estimate'"
                              v-model="item.materialUnit" variant="outlined" density="compact" hide-details
                            ></v-text-field> -->
                            <!-- <div v-if="isEdit === 'see' || isEdit === 'materialControl'">
                              {{ item.materialUnit }}
                            </div>
                            <v-select v-else
                              v-model="item.materialUnit"
                              :items="materialUnitOptions"
                              item-title="title"
                              item-value="value"
                              variant="outlined"
                              density="compact"
                              hide-details
                              label="单位"
                              style="margin-top: 10px;"
                              persistent-placeholder
                              :readonly="item.isTurn || !isCanEdit"
                              :class="{ 'v-field--readonly': item.isTurn || !isCanEdit }"
                              @update:model-value="handleChangeMaterialUnit(index)"
                            ></v-select> -->
                          </div>
                        </template>
                        <!-- <template v-else-if="header.key === 'materialUnit'">
                          <div>{{ item.materialUnit }}</div> -->
                          <!-- <v-text-field
                            v-model="item.materialUnit"
                            variant="outlined"
                            density="compact"
                            hide-details
                            readonly
                            class="v-field--readonly"
                          ></v-text-field> -->
                        <!-- </template> -->
                        <template v-else-if="header.key === 'total'">
                          <div>{{ item.total }}</div>
                          <!-- <v-text-field
                            :model-value="formatNumber(item.total)"
                            readonly
                            class="v-field--readonly text-right"
                            variant="outlined"
                            density="compact"
                            hide-details
                          ></v-text-field> -->
                        </template>
                        <template v-else-if="header.key === 'actions'">
                          <!-- <div class="seeRecord" style="margin-bottom: 6px;" @click="triggerImageUpload(index)">添加物料图</div>
                          <input
                              :ref="el => setFileInput(el, index)"
                              type="file"
                              accept="image/*"
                              multiple
                              class="hidden-input"
                              @change="handleMaterialImageUpload($event, index)"
                            /> -->
                            <v-btn
                              class="outsourceBtn"
                              @click="handleScreenshotImportMaterial(index, item.id)"
                            >
                              截图导入
                            </v-btn>
                          <v-btn
                            color="error"
                            variant="tonal"
                            @click="removeOutMaterialItem(index)"
                            v-if="item.isTurn"
                          >
                          划线
                          </v-btn>
                          <v-btn
                            color="error"
                            variant="tonal"
                            @click="removeMaterialItem(index)"
                            v-else
                          >
                          删除
                          </v-btn>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                
                <!-- 物料分页组件 -->
                <div v-if="materialList.length > 0" class="d-flex justify-space-between align-center pa-4">
                  <div class="text-body-2 text-grey">
                    共 {{ pagination.total }} 条记录，当前显示第 {{ pagination.page }} 页
                  </div>
                  <div class="d-flex align-center">
                    <v-pagination
                      v-model="pagination.page"
                      :length="totalPages"
                      :total-visible="7"
                      class="ml-4"
                      @update:model-value="handlePageChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <!-- 按钮区域 -->
        <div class="form-actions" v-if="(isEdit === 'edit' || isEdit === 'estimate' || isEdit === 'materialControl' ) && isCanEdit">
          <!-- <v-btn
            color="primary"
            @click="handleSubmit"
            :loading="loading"
            :disabled="!valid"
          >
            提交估价
          </v-btn> -->
          <!-- <v-checkbox
            v-if="isEdit === 'estimate'"
            v-model="productInfo.pricingFinish"
            @change="handleCheckAll"
            class="estimate-checkbox"
          /> -->
          <!-- <v-checkbox
            v-if="isEdit === 'estimate'"
            v-model="productInfo.pricingStatus"
            @change="handleCheckAll"
            class="estimate-checkbox"
          /> -->
          <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="correlateMaterialItem"
          >
            引用汇总
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="addMaterialItem"
          >
            添加物料
          </v-btn>
          <!-- <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="handleScreenshotImport"
          >
            截图导入
          </v-btn> -->
          <v-btn v-if="isEdit === 'estimate'"
            color="primary"
            variant="flat"
            class="ml-4"
            @click="copyProductMaterial"
          >
            复制物料
          </v-btn>
          <!-- <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="importMaterial"
          >
            导入物料
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            class="ml-4"
            @click="downloadMaterial"
          >
            下载物料模板
          </v-btn> -->
          <!-- <v-btn
            color="primary"
            variant="flat"
            @click="handleSaveAll"
            class="ml-4"
          >
            保存
          </v-btn> -->
        </div>
        <!-- 截图导入物料 -->
        <UploadExcelImgDialog
          v-model="uploadImgDialogOpen"
          mode="new"
          type="image"
          @upload="handleScreenshotImportSuccess"
        />
        <UploadExcelImgDialog
          v-model="uploadMaterialImgDialog"
          mode="new"
          type="image"
          @upload="handleScreenshotImportMaterialSuccess"
        />
        <!-- 导入excel -->
        <v-dialog v-model="importExcelDialogOpen" max-width="500">
          <ImportExcel
            v-if="isEdit !== 'see' && isEdit !== 'materialControl'"
            accept=".xls,.xlsx"
            icon="mdi-file-document"
            :type="importExcelTypeKind"
            @uploadExcel="handleImportExcel"
            @importStart="handleImportStart"
            @close="importExcelDialogOpen = false"
          />
        </v-dialog>

        <!-- 引用汇总 -->
        <v-dialog
          v-model="showCorrelateDialog"
          max-width="500"
          :scrim="false"
        >
        <!-- transition="dialog-bottom-transition" -->
          <v-card class="material-suggestions-dialog yinyonghuizong">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>引用汇总</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showCorrelateDialog = false"
              />
            </v-card-title>
            <v-card-text>
              <v-list class="material-list" ref="correlateMaterialListRef" style="max-height: 500px;">
                <!-- 添加全选功能和选择计数 -->
                <!-- <div style="color: #fff; padding: 8px; background: rgba(255,255,255,0.1); margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
                  <div>
                    已选择: {{ correlateMaterialList.filter(m => m.isSelected).length }} / {{ correlateMaterialList.length }}
                  </div>
                  <v-btn
                    size="small"
                    variant="flat"
                    color="primary"
                    @click="toggleSelectAll"
                  >
                    {{ isAllSelected ? '取消全选' : '全选' }}
                  </v-btn>
                </div> -->
                <template v-if="correlateMaterialList.length > 0">
                  <v-list-item
                    v-for="(material,index) in correlateMaterialList"
                    :key="index"
                    @click="handleCorrelateMaterialRowClick(material, index)"
                    class="material-suggestion-item"
                    style="padding: 0;"
                  >
                    <div style="display: flex; justify-content: space-between; align-items: center;width: 86%;">
                      <div style="width: 48%;">
                        <v-list-item-title style="margin-bottom: 0px;">{{ material.materialName }}</v-list-item-title>
                        <v-list-item-subtitle v-if="material.materialCode">
                          系统编号: {{ material.materialCode }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.specDesc">
                          规格: {{ material.specDesc }}
                        </v-list-item-subtitle>
                      </div>
                      <div style="width: 20%;">
                        <v-list-item-subtitle v-if="material.bigClass">
                          大类: {{ material.bigClass }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.materialType">
                          小类: {{ material.materialType }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.materialPrice">
                          单价: {{ material.materialPrice }}
                        </v-list-item-subtitle>
                      </div>
                      <div style="background-color: rgba(0, 0, 0, 0.5);height: 60px;width: 60px;display: flex;align-items: center;justify-content: center;">
                        <img 
                          v-if="material.materialImageUrls && material.materialImageUrls.length > 0"
                          :src="material.materialImageUrls[0]?.url"
                          style="max-height: 60px;max-width: 60px;object-fit: cover;"
                          alt="物料图" 
                          class="material-image"
                        >
                        <div v-else class="no-img" style="width: 60px;height: 60px;line-height: 60px;">
                          <!-- 暂无物料图 -->
                        </div>
                      </div>
                    </div>
                    <div>
                      <v-checkbox 
                        v-model="material.isSelected" 
                        @click.stop
                        @change="updateSelectCount"
                      />
                    </div>
                  </v-list-item>
                  <div class="d-flex correlate-btn">
                    <v-btn
                      color="error"
                      variant="tonal"
                      @click="handleCorrelateMaterialCancel"
                    >
                      取消
                    </v-btn>
                    <v-btn
                      color="primary"
                      variant="flat"
                      :disabled="isUseCorrelateMaterial"
                      @click="handleCorrelateMaterial(correlateMaterialList)"
                    >
                      确定
                    </v-btn>
                  </div>
                </template>
                <template v-if="correlateMaterialList.length === 0">
                  <!-- 添加空状态提示 -->
                  <v-list-item class="text-center">
                    <v-list-item-title style="color: #fff;">暂无引用汇总数据</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 添加物料搜索对话框 -->
        <v-dialog
          v-model="showMaterialDialog"
          max-width="500"
          :scrim="false"
        >
        <!-- transition="dialog-bottom-transition" -->
          <v-card class="material-suggestions-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>选择物料</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showMaterialDialog = false"
              />
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="searchKeyword"
                label="搜索物料"
                persistent-placeholder
                placeholder="搜索物料"
                variant="outlined"
                density="compact"
                hide-details
                class="mb-4"
                prepend-inner-icon="mdi-magnify"
                clearable
                :autofocus="showMaterialDialog"
                @update:model-value="handleSearch"
              />
              <v-list class="material-list" style="padding-bottom: 0;" ref="materialListRef" @scroll="handleScroll">
                <template v-if="searchKeyword">
                  <template v-if="materialOptions.length > 0">
                    <v-list-item
                      v-for="material in materialOptions"
                      :key="material.materialName"
                      @click="handleMaterialSelect(material)"
                      class="material-suggestion-item"
                    >
                      <div>
                        <v-list-item-title>{{ material.materialName }}</v-list-item-title>
                        <v-list-item-subtitle v-if="material.materialCode">
                          系统编号: {{ material.materialCode }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.specDesc">
                          规格: {{ material.specDesc }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.bigClass">
                          大类: {{ material.bigClass }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.materialType">
                          小类: {{ material.materialType }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="material.materialPrice">
                          单价: {{ material.materialPrice }}
                        </v-list-item-subtitle>
                      </div>
                      <!-- <div>
                        <img 
                          v-if="material.materialImageUrls"
                          :src="(() => {
                            try {
                              const urls = JSON.parse(material.materialImageUrls)
                              return urls[0]?.url || ''
                            } catch (error) {
                              console.error('解析图片URL失败:', error)
                              return ''
                            }
                          })()"
                          style="width: 80px;"
                          alt="物料图" 
                          class="material-image"
                        >
                      </div> -->
                    </v-list-item>
                  </template>
                  <v-list-item v-if="loadingMore" class="text-center">
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-list-item>
                  <v-list-item v-if="!loadingMore && materialOptions.length === 0" class="text-center">
                    <v-list-item-title style="color: #fff;">暂无匹配物料</v-list-item-title>
                    <!-- <v-card-actions v-if="!loadingMore && materialOptions.length === 0 && searchKeyword"> -->
                      <!-- <v-spacer></v-spacer> -->
                    <div v-if="!loadingMore && materialOptions.length === 0 && searchKeyword && isAddBySelf" style="margin-top: 10px;padding-bottom: 4px;">
                      <v-btn
                        style="margin-right: 10px;"
                        color="primary"
                        variant="flat"
                        @click="handleAddMaterial(WULIsearchKeyword)"
                      >
                        手动添加
                      </v-btn>
                      <!-- <v-btn
                        color="primary"
                        variant="flat"
                        @click="importMaterial"
                      >
                        表格导入
                      </v-btn> -->
                    </div>
                    <!-- </v-card-actions> -->
                  </v-list-item>
                </template>
                <v-list-item v-if="addResultContent !== ''">
                  <v-list-item-title style="color: #fff;text-align: center;">{{ addResultContent }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="addResultErrorContent !== ''">
                  <v-list-item-title style="color: rgb(255,82,82);text-align: center;">{{ addResultErrorContent }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 添加自定义物料 -->
        <v-dialog v-model="showAddCustomMaterialDialog" max-width="850" persistent>
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>添加物料</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showAddCustomMaterialDialog = false,customMaterialName = '',customMaterialSpecDesc = '',customMaterialBigClass = '',customMaterialType = '',customMaterialPrice = ''"
              />
            </v-card-title>
            <v-card-text style="display: flex;gap: 10px;align-items: center;">
              <div>
                <img 
                  v-if="customMaterialImageUrls && customMaterialImageUrls.length > 0"
                  :src="customMaterialImageUrls[0]?.url"
                  style="width: 80px;"
                  alt="物料图" 
                  class="material-image"
                >
                <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;cursor: pointer;" @click.stop="handleNewImageUpload">
                  <img src="@/assets/uploadIcon.png" alt="上传" class="img-icon-one" title="上传图片" />
                </div>
              </div>
              <v-textarea style="width: 200px;" auto-grow resize v-model="customMaterialName" rows="1" label="物料名称" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea> 
              <v-textarea style="width: 200px;" auto-grow resize v-model="customMaterialSpecDesc" rows="1" label="规格" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea>
              <v-select
                label="大类"
                persistent-placeholder
                style="width: 100px;"
                v-model="customMaterialBigClass"
                :items="bigClassOptions"
                item-title="title"
                item-value="value"
                variant="outlined"
                density="compact"
                hide-details
                @update:model-value="handleChangeCustomBigClass()"
              ></v-select>
              <v-select
                label="小类"
                persistent-placeholder
                style="width: 140px;"
                v-model="customMaterialType"
                :items="customMaterialBigClass ? getMaterialTypeOptions(customMaterialBigClass) : [{ title: '请先选大类', value: '', disabled: true }]"
                item-title="title"
                item-value="value"
                variant="outlined"
                density="compact"
                hide-details
              ></v-select>
              <!-- <v-text-field style="width: 80px;" v-model="customMaterialPrice" label="单价" persistent-placeholder variant="outlined" density="compact" hide-details /> -->
            </v-card-text>
            <v-card-actions>
              <div class="d-flex correlate-btn">
                <v-btn color="error" variant="tonal" @click="showAddCustomMaterialDialog = false">取消</v-btn>
                <v-btn color="primary" variant="flat" @click="handleAddMaterialToBank">确定</v-btn>
                <!-- @click="handleUseInputAsMaterial" -->
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- 复制产品物料对话框 -->
        <v-dialog
          v-model="showCopyProductMaterialDialog"
          max-width="500"
          :scrim="false"
        >
        <!-- transition="dialog-bottom-transition" -->
          <v-card class="material-suggestions-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <span>复制物料清单</span>
                <div class="ml-4 d-flex align-center">
                  <img 
                    :src="recommendationType === 'recent' ? '/src/assets/recent.png' : '/src/assets/similar.png'"
                    alt="切换推荐类型"
                    class="recommendation-toggle-btn"
                    @click="handleRecommendationTypeChange(recommendationType === 'recent' ? 'similar' : 'recent')"
                  />
                </div>
              </div>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showCopyProductMaterialDialog = false,isSimilarImage = true"
              />
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="copyProductMaterialSearchKeyword"
                label="搜索产品"
                persistent-placeholder
                placeholder="搜索产品 (关键词/编号)"
                variant="outlined"
                density="compact"
                hide-details
                class="mb-4"
                prepend-inner-icon="mdi-magnify"
                clearable
                @update:model-value="handleCopyProductMaterialSearch"
              />
              <v-list class="material-list" style="padding-bottom: 0;padding-top: 0px;" ref="copyProductMaterialListRef" @scroll="!isSimilarImage ? handleCopyProductMaterialScroll : ''">
                <!-- 显示推荐数据（最近或相似） - 当没有搜索关键词时显示 -->
                <template v-if="!copyProductMaterialSearchKeyword && recommendationType === 'recent' && recentProductMaterialList.length > 0">
                  <!-- <div style="color: #fff;margin-bottom: 10px;">最近使用的产品物料</div> -->
                  <v-list-item
                    v-for="product in recentProductMaterialList"
                    :key="product.id"
                    class="material-suggestion-item"
                  >
                    <div class="d-flex align-center" style="width: 400px;">
                      <img 
                        v-if="product.imageUrls && JSON.parse(product.imageUrls).length > 0"
                        :src="(() => {
                          try {
                            const urls = JSON.parse(product.imageUrls)
                            return urls[0]?.url || ''
                          } catch (error) {
                            console.error('解析图片URL失败:', error)
                            return ''
                          }
                        })()"
                        style="width: 80px;height: 80px;margin-right: 4px;object-fit: cover;"
                        alt="产品图" 
                        class="material-image"
                      >
                      <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;margin-right: 4px;">
                        暂无产品图
                      </div>
                      <div style="width: 150px">
                        <v-list-item-subtitle v-if="product.syscode">{{ product.syscode }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.name">{{ product.name }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.nameShort">{{ product.nameShort }}</v-list-item-subtitle>
                      </div>
                    </div>
                    <div style="width: 100px;">
                      <v-list-item-subtitle v-if="product.width">W:{{ product.width }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.depth">D:{{ product.depth }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.height">H:{{ product.height }}</v-list-item-subtitle>
                    </div>
                    <div style="width: 200px;">
                      <v-btn
                        class="seeMaterial"
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSee(product.id)"
                      >
                        查看
                      </v-btn>
                      <v-btn
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSelect(product.id)"
                      >
                        复制
                      </v-btn>
                    </div>
                  </v-list-item>
                </template>
                <template v-else-if="!copyProductMaterialSearchKeyword && recommendationType === 'similar' && suggestProductMaterialList.length > 0">
                  <!-- <div style="color: #fff;margin-bottom: 10px;">相似产品物料推荐</div> -->
                  <v-list-item
                    v-for="product in suggestProductMaterialList"
                    :key="product.id"
                    class="material-suggestion-item"
                  >
                    <div class="d-flex align-center" style="width: 400px;">
                      <img 
                        v-if="product.imageUrls && JSON.parse(product.imageUrls).length > 0"
                        :src="(() => {
                          try {
                            const urls = JSON.parse(product.imageUrls)
                            return urls[0]?.url || ''
                          } catch (error) {
                            console.error('解析图片URL失败:', error)
                            return ''
                          }
                        })()"
                        style="width: 80px;height: 80px;margin-right: 4px;object-fit: cover;"
                        alt="产品图" 
                        class="material-image"
                      >
                      <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;margin-right: 4px;">
                        暂无产品图
                      </div>
                      <div style="width: 150px">
                        <v-list-item-subtitle v-if="product.syscode">{{ product.syscode }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.name">{{ product.name }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.nameShort">{{ product.nameShort }}</v-list-item-subtitle>
                      </div>
                    </div>
                    <div style="width: 100px;">
                      <v-list-item-subtitle v-if="product.width">W:{{ product.width }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.depth">D:{{ product.depth }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.height">H:{{ product.height }}</v-list-item-subtitle>
                    </div>
                    <div style="width: 200px;">
                      <v-btn
                        class="seeMaterial"
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSee(product.id)"
                      >
                        查看
                      </v-btn>
                      <v-btn
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSelect(product.id)"
                      >
                        复制
                      </v-btn>
                    </div>
                  </v-list-item>
                </template>
                <!-- 显示搜索结果 -->
                <template v-if="copyProductMaterialList.length > 0">
                  <v-list-item
                    v-for="product in copyProductMaterialList"
                    :key="product.id"
                    class="material-suggestion-item"
                  >
                    <div class="d-flex align-center" style="width: 400px;">
                      <img 
                        v-if="product.imageUrls && JSON.parse(product.imageUrls).length > 0"
                        :src="(() => {
                          try {
                            const urls = JSON.parse(product.imageUrls)
                            return urls[0]?.url || ''
                          } catch (error) {
                            console.error('解析图片URL失败:', error)
                            return ''
                          }
                        })()"
                        style="width: 80px;height: 80px;margin-right: 4px;object-fit: cover;"
                        alt="产品图" 
                        class="material-image"
                      >
                      <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;margin-right: 4px;">
                        暂无产品图
                      </div>
                      <div style="width: 150px">
                        <v-list-item-subtitle v-if="product.syscode">{{ product.syscode }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.name">{{ product.name }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="product.nameShort">{{ product.nameShort }}</v-list-item-subtitle>
                      </div>
                      <!-- <v-list-item-title>{{ product.materialName }}</v-list-item-title> -->
                    </div>
                    <div style="width: 100px;">
                      <v-list-item-subtitle v-if="product.width">W:{{ product.width }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.depth">D:{{ product.depth }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="product.height">H:{{ product.height }}</v-list-item-subtitle>
                    </div>
                    <div style="width: 200px;">
                      <v-btn
                        class="seeMaterial"
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSee(product.id)"
                      >
                        查看
                      </v-btn>
                      <v-btn
                        size="small"
                        color="primary"
                        variant="flat"
                        @click="handleCopyProductMaterialSelect(product.id)"
                      >
                        复制
                      </v-btn>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="copyProductMaterialLoadingMore" class="text-center">
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-list-item>
                  <v-list-item v-if="!copyProductMaterialLoadingMore && copyProductMaterialList.length === 0" class="text-center">
                    <v-list-item-title style="color: #fff;">暂无匹配产品物料</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                variant="text"
                @click="handleUseInputAsMaterial"
              >
                使用"{{ searchKeyword }}"作为物料名称
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <!-- 预览产品物料 -->
        <v-dialog
          v-model="showPreviewProductMaterialDialog"
          max-width="1000"
          persistent
        >
        <v-card class="material-suggestions-dialog">
          <v-card-title class="d-flex justify-space-between align-center">
              <span>{{previewProductMaterial.name}}的物料清单</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showPreviewProductMaterialDialog = false"
              />
            </v-card-title>
            <v-card-text class="product-table-container">
              <v-table class="material-list-table" style="border: 1px solid #36383D;">
                <thead style="background-color: #36383D;">
                  <tr>
                    <th style="min-width: 80px;">物料图</th>
                    <th style="min-width: 150px;">物料</th>
                    <!-- <th style="min-width: 150px;">业务描述</th> -->
                    <th style="min-width: 70px;">大类</th>
                    <th style="min-width: 70px;">小类</th>
                    <th style="min-width: 70px;">数量</th>
                    <th style="min-width: 70px;">
                      <div>单价</div>
                      <div class="small-title">单价估价</div>
                    </th>
                    <th style="min-width: 70px;">单位</th>
                    <th style="min-width: 70px;">总价</th>
                  </tr>
                </thead>
                <tbody v-if="previewProductMaterial.materialList && previewProductMaterial.materialList.length > 0">
                  <tr v-for="material in previewProductMaterial.materialList" :key="material.id">
                    <td>
                      <div>
                        <img 
                          v-if="material.materialImageUrls && JSON.parse(material.materialImageUrls).length > 0 && material.materialImageUrls.includes('http')"
                          :src="(() => {
                            try {
                              const urls = JSON.parse(material.materialImageUrls)
                              return urls[0]?.url || ''
                            } catch (error) {
                              console.error('解析图片URL失败:', error)
                              return ''
                            }
                          })()"
                          style="width: 80px;margin: 0 auto;"
                          alt="物料图" 
                          class="material-image"
                        >
                        <div v-else class="no-img" style="width: 80px;height: 80px;line-height: 80px;">
                          暂无物料图
                        </div>
                      </div>
                    </td>
                    <td style="text-align: left!important;">
                      <div>{{ material.materialName }}</div>
                      <div>系统编号：{{ material.materialCode || '/' }}</div>
                      <div>规格：{{ material.specDesc || '/' }}</div>
                    </td>
                    <!-- <td style="text-align: left!important;">{{ material.materialDescription }}</td> -->
                    <td>{{ material.bigClass || '/' }}</td>
                    <td>{{ material.materialType || '/' }}</td>
                    <td>{{ material.count }}</td>
                    <td>{{ material.materialPrice }}</td>
                    <td>{{ material.materialUnit || '/' }}</td>
                    <td>{{ material.materialTotal }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="10" class="text-center">暂无物料</td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- 添加图片预览对话框 -->
        <ImagePreviewDialog
          v-model="showPreview"
          :image-url="previewImage[0] || ''"
          :image-list="previewImage"
          :initial-index="selectedIndex"
          :current-material-index="currentMaterialIndex"
          :is-delete="isDelete"
          @delete="handleDeleteImage"
          @close="handleClosePreview"
        />
        
        <!-- 删除确认对话框 -->
        <v-dialog
          v-model="showDeleteConfirm"
          max-width="400"
          persistent
        >
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex align-center">
              <span>确认删除</span>
            </v-card-title>
            <v-card-text>
              <p>确定要删除这个物料项吗？</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                variant="tonal"
                @click="showDeleteConfirm = false,doAddSameMaterial = false"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="confirmDeleteMaterial"
                :loading="deleteLoading"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 移除物料确认对话框 -->
        <v-dialog
          v-model="showRemoveConfirm"
          max-width="400"
          persistent
        >
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex align-center">
              <span>确认移除</span>
            </v-card-title>
            <v-card-text>
              <p>确定要移除这个物料项吗？</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                variant="tonal"
                @click="showRemoveConfirm = false,doAddSameMaterial = false"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="confirmRomoveDeleteMaterial"
                :loading="deleteLoading"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 添加的物料该合同下的其他产品也有 -->
        <v-dialog
          v-model="showCtractSameMaterialDialog"
          max-width="400"
          persistent
        >
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex align-center">
              <span>提示</span>
            </v-card-title>
            <v-card-text>
              <p>其他产品已添加该材料，使用价格{{ tempPrice }}吗?</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                variant="tonal"
                @click="showCtractSameMaterialDialog = false,showTipDialog = false"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="handleSameMaterialSelect(tempMaterialCode)"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <!-- 添加的物料有重复 -->
        <v-dialog
          v-model="showTipDialog"
          max-width="400"
          persistent
        >
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex align-center">
              <span>提示</span>
            </v-card-title>
            <v-card-text>
              <p>添加的物料已存在，系统会合并重复项。是否确认继续添加？</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                variant="tonal"
                @click="showTipDialog = false,doAddMaterial = false"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="handleTempMaterialSelect(tempMaterialCode)"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 产品描述详情 -->
        <v-dialog v-model="isShowMaterialDescriptionMerge" max-width="1000" persistent>
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>产品描述详情</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="isShowMaterialDescriptionMerge = false,materialDescriptionMerge = ''"
              />
            </v-card-title>
            <v-card-text>
              <div class="material-description-merge" style="text-align: left!important;max-width: 1200px;">
                <pre style="white-space: pre-wrap;">{{ materialDescriptionMerge }}</pre>
              </div>
              <div class="d-flex justify-end">
                <v-btn color="primary" variant="flat" @click="isShowMaterialDescriptionMerge = false,materialDescriptionMerge = ''">关闭</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 计算提示对话框 -->
        <v-dialog
          v-model="showCalculateDialog"
          max-width="1300"
          persistent
        >
          <v-card class="calculate-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>{{ calculateDialogTitle }}</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="showCalculateDialog = false"
              />
            </v-card-title>
            <v-card-text style="overflow: auto;">
              <div class="formula-section">
                <div class="formula-title">计算公式：</div>
                <div class="formula-content">{{ currentFormula }}</div>
              </div>
              <!-- 运费计算 (W+50)*(D+50)*(H+50）/1000000000*120*调整系数 -->
              <div class="calc-section" v-if="currentCalculateType === 'freightFee'">
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.widthModify"
                  label="W"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="text-right calc-input"
                /> 
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.freightFeeWAdd"
                  label="W增加"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                /> <div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.heightModify"
                  label="H"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="text-right calc-input"
                /> 
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.freightFeeHAdd"
                  label="H增加"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                /> <div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.depthModify"
                  label="D"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="text-right calc-input"
                /> 
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.freightFeeDAdd"
                  label="D增加"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                /> <div class="calc-item">)</div><div class="calc-item">/</div>  
                <div class="calc-item">1000000000</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.freightFeeTax"
                  label="运费系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                /> 
                <!-- <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.adjustment"
                  label="调整系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly calc-input-readonly"
                />  -->
              </div>
              <!-- 人工费计算 [（基材+油漆）*0.35+数值]*调整系数-->
              <div class="calc-section" v-if="currentCalculateType === 'laborFee'">
                <div class="calc-item">[</div><div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                /><div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.laborFeeTax"
                  label="人工费率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.laborFeeAdd"
                  label="人工附加费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly calc-special-input' : 'text-right calc-input calc-special-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">]</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.adjustment"
                  label="调整系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly calc-input-readonly"
                />
              </div>
              <!-- 制费计算（（基材+油漆）*基材制费率+（差价+小五金+玻璃+石材+面料+外购件+大五金）*制费率）*调整系数 -->
              <div class="calc-section" v-if="currentCalculateType === 'manufacturingFee'">
                <div class="calc-item">[</div><div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                /><div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.manufacturingFeeTax"
                  label="基材制费率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly calc-special-input' : 'text-right calc-input calc-special-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">+</div>  
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.differenceModify"
                  label="差价"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.smallHardwareModify"
                  label="小五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.glassModify"
                  label="玻璃"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.stoneModify"
                  label="石材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.fabricModify"
                  label="面料"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.purchasePartsModify"
                  label="外购件"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>  
                <v-text-field
                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                  label="大五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.manufacturingFeeAdd"
                  label="辅材制费率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact" 
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly calc-special-input' : 'text-right calc-input calc-special-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">]</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.adjustment"
                  label="调整系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly calc-input-readonly"
                />
              </div>
              <!-- 利润计算（（基材+油漆）*基材利润率+（差价+小五金+玻璃+石材+面料+外购件+大五金）*利润率）*调整系数 -->
              <div class="calc-section" v-if="currentCalculateType === 'profit'">
                <div class="calc-item">[</div><div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">）</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.profitTax"
                  label="基材利润率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly calc-special-input' : 'text-right calc-input calc-special-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">+</div>
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.differenceModify"
                  label="差价"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.smallHardwareModify"
                  label="小五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.glassModify"
                  label="玻璃"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.stoneModify"
                  label="石材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.fabricModify"
                  label="面料"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.purchasePartsModify"
                  label="外购件"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>  
                <v-text-field
                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                  label="大五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.profitAdd"
                  label="辅材利润率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact" 
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly calc-input-readonly calc-special-input' : 'text-right calc-input calc-special-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <div class="calc-item">]</div>
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.profitAdjustment"
                  label="利润调整值"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="text-right calc-input v-field--readonly calc-input-readonly calc-special-input"
                />
                <!-- <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.adjustment"
                  label="调整系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly calc-input-readonly"
                /> -->
              </div>
              <!-- 税费计算（基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金+人工+制费+利润）*税率*调整系数 -->
              <div class="calc-section" v-if="currentCalculateType === 'taxFee'">
                <div class="calc-item">(</div><v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.differenceModify"
                  label="差价"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.smallHardwareModify"
                  label="小五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.glassModify"
                  label="玻璃"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.stoneModify"
                  label="石材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.fabricModify"
                  label="面料"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.purchasePartsModify"
                  label="外购件"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                  label="大五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                /> 
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.laborFee"
                  label="人工"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.manufacturingFee"
                  label="制费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.profit"
                  label="利润"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">)</div>
                <div class="calc-item">*</div>
                <v-text-field
                  v-model="productInfo.materialSummary.taxFeeTax"
                  label="税率"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  :class="isEdit !== 'estimate' ? 'text-right calc-input v-field--readonly' : 'text-right calc-input'"
                  :readonly="isEdit !== 'estimate'"
                />
                <!-- <div class="calc-item">*</div>  
                <v-text-field
                  v-model="productInfo.materialSummary.adjustment"
                  label="调整系数"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly calc-input-readonly"
                /> -->
              </div>
              <!-- 成本估价计算 基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金+运费+安装费+人工+制费+利润+税费 -->
              <div class="calc-section" v-if="currentCalculateType === 'cost'">
                <v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly" 
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.differenceModify"
                  label="差价"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.smallHardwareModify"
                  label="小五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.glassModify"
                  label="玻璃"
                  persistent-placeholder
                  type="number"
                  variant="outlined"  
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.stoneModify"
                  label="石材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.fabricModify"
                  label="面料"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.purchasePartsModify"
                  label="外购件"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                  label="大五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.freightFee"
                  label="运费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.installationFee"
                  label="安装费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly  
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.laborFee"
                  label="人工"  
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.manufacturingFee"
                  label="制费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.profit"
                  label="利润"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.taxFee"
                  label="税费"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />  
              </div>  
              <!-- 材料估价计算 基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金 -->
              <div class="calc-section" v-if="currentCalculateType === 'materialTotal'">
                <v-text-field
                  v-model="productInfo.materialSummary.baseModify"
                  label="基材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.paintModify"
                  label="油漆"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.differenceModify"
                  label="差价"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.smallHardwareModify"
                  label="小五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.glassModify"
                  label="玻璃"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.stoneModify"
                  label="石材"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.fabricModify"
                  label="面料"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.purchasePartsModify"
                  label="外购件"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
                <div class="calc-item">+</div>
                <v-text-field
                  v-model="productInfo.materialSummary.bigHardwareFeeModify"
                  label="大五金"
                  persistent-placeholder
                  type="number"
                  variant="outlined"
                  density="compact"
                  hide-details
                  readonly
                  class="text-right calc-input v-field--readonly"
                />
              </div>
              <!-- <div class="result-section">
                <div class="result-title">原结果：</div>
                <div class="result-value calc-item">{{ calculatedResult }}</div>
              </div> -->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="isEdit === 'estimate'"
                color="primary"
                variant="flat"
                @click="applyCalculation"
              >
                确定
              </v-btn>
              <v-btn
                color="error"
                variant="tonal"
                @click="showCalculateDialog = false"
              >
                取消
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 上传对话框 -->
        <UploadImgDialog
          v-model="showUploadDialog"
          mode="new"
          :type="uploadType"
          @upload="handleNewImageUploadSuccess"
        />

        <!-- 公共Loading组件 -->
        <div v-if="showCommonLoading" class="common-loading-overlay">
          <div class="common-loading-container">
            <div class="common-loading-spinner"></div>
            <p class="common-loading-text">{{ commonLoadingText || '加载中...' }}</p>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onUnmounted, onMounted, computed, nextTick, watch } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { useRouter, useRoute } from 'vue-router'
import { contractApi, uploadApi } from '@/services/api'
import { id } from 'vuetify/lib/locale/index.mjs'
import { bigClassOptions, getMaterialTypeOptions, materialUnitOptions } from '@/constants/contract'
import MaterialImagePreview from '@/components/MaterialImagePreview.vue'
import ImagePreviewDialog from '@/components/ImagePreviewDialog.vue'
import UploadImgDialog from '@/components/UploadImg.vue'
import ImportExcel from '@/components/ImportMaterialExcel.vue'
import UploadExcelImgDialog from '@/components/UploadExcelImg.vue'
import delBg from '@/assets/delBg.png'
import leftBtn from '@/assets/leftBtn.png'
import rightBtn from '@/assets/rightBtn.png'

interface MaterialItem {
  id?: number
  name: string
  code: string
  specification: string
  salesmanRemark: string
  // supplier: string
  materialDescription: string
  type: string
  image: File | null
  price: number
  count: number
  materialUnit: string, // 物料单位
  total: number
  images?: { url: string; name: string }[]
  materialCustomerNo?: string, // 客户号
}

interface ProductInfo {
  code: string
  pricingFinish: boolean,
  pricingStatus: boolean,
  description: string
  priceRemark: string
  remarks: string
  id?: number
  productOrderId?: number
  syscode?: string
  name?: string
  productShortName?: string
  shortName?: string
  productDescription?: string
  width?: number
  depth?: number
  height?: number
  count?: number
  materialUnit?: string, // 物料单位
  materialCustomerNo?: string, // 客户号
  remark?: string
  productImageUrls?: Array<{
    url: string
    name: string
  }>
  price?: number,
  total?: number,
  priceLocal?: number,
  totalLocal?: number,
  materialList?: [{
    id?: number, // 物料明细ID
    wuliaoId?: number, // 物料ID
    contractProductId?: number, // 商品ID
    materialId?: number, // 物料ID
    materialName?: string, // 物料名称
    materialCode?: string, // 物料编号
    specDesc?: string, // 规格描述
    materialType?: string, // 物料类型
    materialImageUrls?: [{
      url: string
      name: string
    }], // 物料图片URL
    materialPrice?: number, // 物料单价
    count?: number, // 用量
    materialTotal?: number, // 物料总额
    materialUnit?: string, // 物料单位
    materialCustomerNo?: string, // 客户号
    isDelete?: number, // 是否删除
    wuliaoStatus?: number, // 物控状态
    toWuliaoTime?: string, // 到物控时间,
    isTurn?: boolean, // 是否已转物控
  }],
  materialSummary: {
    id?: number,
    widthModify: number,
    heightModify: number,
    depthModify: number,
    base: number,
    paint: number,
    difference: number,
    smallHardware: number,
    glass: number,
    stone: number,
    fabric: number,
    purchaseParts: number,
    bigHardwareFee: number,
    freightFee: number,
    installationFee: number,
    laborFee: number,
    manufacturingFee: number,
    profit: number,
    taxFee: number,
    cost: number,
    fabricUsage: number,
    adjustment: number,
    freightFeeWAdd: number,
    freightFeeDAdd: number,
    freightFeeHAdd: number,
    freightFeeTax: number,
    laborFeeTax: number,
    laborFeeAdd: number,
    manufacturingFeeTax: number,
    manufacturingFeeAdd: number,
    profitTax: number,
    profitAdd: number,
    taxFeeTax: number,
    adjustment: number,
    baseMaterial: number,
    paintMaterial: number,
    baseModify: number,
    paintModify: number,
    differenceModify: number,
    smallHardwareModify: number,
    glassModify: number,
    stoneModify: number,
    fabricModify: number,
    purchasePartsModify: number,
    bigHardwareFeeModify: number,
    baseModifyTime: boolean,
    paintModifyTime: boolean,
    differenceModifyTime: boolean,
    smallHardwareModifyTime: boolean,
    glassModifyTime: boolean,
    stoneModifyTime: boolean,
    fabricModifyTime: boolean,
    purchasePartsModifyTime: boolean,
    bigHardwareFeeModifyTime: boolean
  }
}

// 添加引用汇总列表的接口定义
interface CorrelateMaterialItem {
  id: number
  materialType: string
  bigClass: string
  materialName: string
  materialCode: string
  specDesc: string
  materialPrice: number
  materialTotal: number
  materialCount: number
  materialPriceConfirmed: number
  wuliaoStatus: number
  materialImageUrls: { url: string; name: string }[]
  materialImageUrlsConfirmed: { url: string; name: string }[]
  wuliaoName: string
  wuliaoRemark: string
  materialNameConfirmed: string
  materialTypeConfirmed: string
  createTime: string
  wuliaoItem: {
    materialImageUrls: string
    wuliaoName: string
    wuliaoRemark: string
    createTime: string
    salesmanReviewStatus: number
  }
  salesmanRemark: string
  // supplier: string
  materialDescription: string
  salesmanReviewStatus: number
  isSelected: boolean // 添加选中状态
  materialUnit?: string // 添加物料单位
  materialCustomerNo?: string // 客户号
}

interface importExcelCount {
  count: number
  total: number
}

const router = useRouter()
const route = useRoute()
const { showSuccess, showError } = useSnackbar()
const form = ref()
const valid = ref(false)
const loading = ref(false)
const isEdit = ref<'edit' | 'estimate' | 'see' | 'materialControl' | 'new' | null>(null)
const tempMaterialCode = ref('')

const importExcelDialogOpen = ref(false)
const importExcelTypeKind = ref(1)
const importExcelCount = ref<importExcelCount>({
  count: 20,
  total: 99
})
const interval1 = ref(null)

const isUseCorrelateMaterial = ref(false)

const uploadImgDialogOpen = ref(false)
const showCommonLoading = ref(false)
const commonLoadingText = ref('')

const uploadMaterialImgDialog = ref(false)
const materialToUploadIndex = ref(-1)
const materialToUploadId = ref('')

// 导入动画状态
const showImportAnimation = ref(false)
const importAnimationText = ref()
const showImportAnimationMaterial = ref(false)
// 产品信息固定相关
const productInfoSection = ref<HTMLElement | null>(null)
const isProductInfoFixed = ref(false)
const productInfoOriginalTop = ref(0)

// 物料表格容器引用
const materialTableContainer = ref<HTMLElement | null>(null)

// 图片索引状态管理
const productImageIndexes = ref<{ [key: number]: number }>({})
const materialImageIndexes = ref<{ [key: number]: number }>({}) // 物料图片索引状态管理

// 放大缩小状态
const zoomLevel = ref(1) // 1: 正常, 2: 放大
const zoomedRows = ref<{ [key: number]: boolean }>({}) // 记录哪些行被放大了，兼容Safari
const materialZoomedRows = ref<{ [key: number]: boolean }>({}) // 记录哪些物料行被放大了
const materialZoomLevel = ref(1) // 1: 正常, 2: 放大

const isAddBySelf = ref(true)

const handleChangeCustomBigClass = () => {
  customMaterialType.value = null
}

const inputMaterialSpecification = (index: number) => {
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const handleChangeBigClass = (index: number) => {
  materialList.value[index].type = null
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const handleChangeType = (index: number) => {
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const handleChangeMaterialUnit = (index: number) => {
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const handleCheckAll = () => {
  console.log('checkAll', productInfo.value.pricingFinish)
  handleSaveAll('noMsg')
}
// 获取当前产品的图片索引
const getCurrentImageIndex = (productIndex: number): number => {
  return productImageIndexes.value[productIndex] || 0
}

interface MaterialFileItem {
  id?: number
  url: string
  name: string
}

const showMaterialBookContent = ref(false);
const materialFileList = ref<MaterialFileItem[]>([])
const materialFileStatus = ref(0)
const materialFileAllList = ref<MaterialFileItem[]>([])
const showBook = () => {
  showMaterialBookContent.value = !showMaterialBookContent.value;
}

const previewMaterialBook = (doc: any) => {
  window.open(doc, '_blank')
}

// 添加自定义物料
const showAddCustomMaterialDialog = ref(false)
const customMaterialImageUrls = ref<{ url: string; name: string }[]>([])
const customMaterialName = ref('')
const customMaterialSpecDesc = ref('')
const customMaterialBigClass = ref('')
const customMaterialType = ref('')
const customMaterialPrice = ref(null)
const showUploadDialog = ref(false)
const addResultContent = ref('')
const addResultErrorContent = ref('')

const editMaterialIndex = ref(-1)
const oldEditMaterialIndex = ref(-1)
// 切换到上一张图片
const prevImage = (productIndex: number) => {
  const currentIndex = getCurrentImageIndex(productIndex)
  if (currentIndex > 0) {
    productImageIndexes.value[productIndex] = currentIndex - 1
  }
}

// 切换到下一张图片
const nextImage = (productIndex: number) => {
  const currentIndex = getCurrentImageIndex(productIndex)
  const product = productInfo.value.productImageUrls
  if (product && product.length > 0 && currentIndex < product.length - 1) {
    productImageIndexes.value[productIndex] = currentIndex + 1
  }
}

// 重置产品图片索引
const resetProductImageIndex = (productIndex: number) => {
  productImageIndexes.value[productIndex] = 0
}

// 放大图片和行高
const zoomIn = (productIndex: number) => {
  zoomedRows.value[productIndex] = true
  zoomLevel.value = 2
}

// 缩小图片和行高
const zoomOut = (productIndex: number) => {
  delete zoomedRows.value[productIndex]
  zoomLevel.value = 1
}

// 检查行是否被放大
const isRowZoomed = (productIndex: number): boolean => {
  return !!zoomedRows.value[productIndex]
}

// 删除物料图片
const handleDeleteMaterialImage = (parentIndex: number, imageIndex: number) => {
  console.log('删除物料图片', parentIndex, imageIndex)
  // 调用通用的删除图片方法
  handleDeleteImage(parentIndex, imageIndex, 'wuliao')
}

// 物料图相关的放大缩小方法
const getCurrentMaterialImageIndex = (materialIndex: number): number => {
  return materialImageIndexes.value[materialIndex] || 0
}

const updateMaterialImageIndex = (materialIndex: number, imageIndex: number) => {
  materialImageIndexes.value[materialIndex] = imageIndex
}

// 放大物料图片和行高
const zoomMaterialIn = (materialIndex: number) => {
  materialZoomedRows.value[materialIndex] = true
  materialZoomLevel.value = 2
}

// 缩小物料图片和行高
const zoomMaterialOut = (materialIndex: number) => {
  delete materialZoomedRows.value[materialIndex]
  materialZoomLevel.value = 1
}

// 检查物料行是否被放大
const isMaterialRowZoomed = (materialIndex: number): boolean => {
  return !!materialZoomedRows.value[materialIndex]
}

// // 获取当前物料的图片索引
// const getCurrentMaterialImageIndex = (materialIndex: number): number => {
//   if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
//     console.warn('materialImageIndexes.value is undefined, reinitializing...');
//     materialImageIndexes.value = {};
//   }
//   return materialImageIndexes.value[materialIndex] || 0
// }

// 切换到上一张物料图片
const prevMaterialImage = (materialIndex: number) => {
  const currentIndex = getCurrentMaterialImageIndex(materialIndex)
  if (currentIndex > 0) {
    if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
      materialImageIndexes.value = {};
    }
    materialImageIndexes.value[materialIndex] = currentIndex - 1
  }
}

// 切换到下一张物料图片
const nextMaterialImage = (materialIndex: number) => {
  const currentIndex = getCurrentMaterialImageIndex(materialIndex)
  const material = materialList.value[materialIndex]
  if (material?.images && material.images.length > 0 && currentIndex < material.images.length - 1) {
    if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
      materialImageIndexes.value = {};
    }
    materialImageIndexes.value[materialIndex] = currentIndex + 1
  }
}

// 重置物料图片索引
const resetMaterialImageIndex = (materialIndex: number) => {
  if (!materialImageIndexes.value || typeof materialImageIndexes.value !== 'object') {
    materialImageIndexes.value = {};
  }
  materialImageIndexes.value[materialIndex] = 0
}

// 产品信息表头
const productHeaders = [
  { title: '产品图', key: 'imageUrls', align: 'center', minWidth: '140px' },
  { title: '产品信息', key: 'info', align: 'center', minWidth: '95px' },
  { title: '尺寸', key: 'size', align: 'center', minWidth: '60px' },
  { title: '估价', key: 'evaluate', align: 'center', minWidth: '90px' },
  { title: '估价明细', key: 'evaluateDetail', align: 'center', minWidth: '788px' },
  { title: '估价备注', key: 'description', align: 'center', minWidth: '165px' }
]

// 估价明细表头
const priceHeaders = [
  { title: '成本估价', key: 'cost', align: 'center', minWidth: '110px' },
  { title: '材料估价', key: 'materialTotal', align: 'center', minWidth: '110px' },
  { title: '调整系数', key: 'adjustment', align: 'center', minWidth: '70px' },
  { title: '基材', key: 'baseMaterial', align: 'center', minWidth: '70px' },
  { title: '油漆', key: 'paint', align: 'center', minWidth: '70px' },
  { title: '差价', key: 'difference', align: 'center', minWidth: '70px' },
  { title: '小五金', key: 'smallHardware', align: 'center', minWidth: '70px' },
  { title: '玻璃', key: 'glass', align: 'center', minWidth: '70px' },
  { title: '石材', key: 'stone', align: 'center', minWidth: '70px' },
  { title: '面料', key: 'fabric', align: 'center', minWidth: '70px' },
  { title: '外购件', key: 'purchase', align: 'center', minWidth: '70px' },
  { title: '大五金', key: 'bigHardware', align: 'center', minWidth: '70px' },
  { title: '运费', key: 'freight', align: 'center', minWidth: '110px' },
  { title: '安装费', key: 'installationFee', align: 'center', minWidth: '70px' },
  { title: '面料用量', key: 'fabricUsage', align: 'center', minWidth: '70px' },
  { title: '人工', key: 'labor', align: 'center', minWidth: '110px' },
  { title: '制费', key: 'labor', align: 'center', minWidth: '110px' },
  { title: '利润', key: 'profit', align: 'center', minWidth: '110px' },
  { title: '税费', key: 'tax', align: 'center', minWidth: '110px' }
]

// 物料清单表头
const materialHeaders = [
  { title: '物料', key: 'name', align: 'center', minWidth: '240' },
  { title: '大类', key: 'bigClass', align: 'center', minWidth: '90' },
  { title: '小类', key: 'type', align: 'center', minWidth: '105' },
  { title: '物料编号', key: 'materialCustomerNo', align: 'center', minWidth: '105' },
  { title: '单个用量', key: 'count', align: 'center', minWidth: '80' },
  { title: '单价', key: 'price', align: 'center', minWidth: '110' },
  // { title: '单位', key: 'materialUnit', align: 'center', minWidth: '80' },
  { title: '总价', key: 'total', align: 'center', minWidth: '90' },
  // { title: '供应商', key: 'supplier', align: 'center', minWidth: '90' },
  { title: '业务描述', key: 'materialDescription', align: 'center', minWidth: '255' },
  { title: '物料参考', key: 'image', align: 'center', minWidth: '100' },
  // { title: '业务备注', key: 'salesmanRemark', align: 'center', minWidth: '180' },
  { title: '操作', key: 'actions', align: 'center', minWidth: '110' }
]

// 物料类型选项
const materialTypes = [
  '木材',
  '金属',
  '塑料',
  '石材',
  '玻璃',
  '其他'
]

// 产品简称选项
const productShortNames = [
  '沙发',
  '茶几',
  '餐桌',
  '餐椅',
  '床',
  '衣柜',
  '书柜',
  '其他'
]

// 添加物料选择相关的响应式数据
const materialListRef = ref<HTMLElement | null>(null)
const searchKeyword = ref('')
const showMaterialDialog = ref(false)
const showMaterialUploadDialog = ref(false)
const currentUploadMaterialIndex = ref(-1)
const loadingMore = ref(false)
const page = ref(1)
const pageSize = ref(20)
const hasMore = ref(true)
const showCorrelateDialog = ref(false)
const correlateMaterialListRef = ref<HTMLElement | null>(null)
const correlateMaterialList = ref<CorrelateMaterialItem[]>([])
const showTipDialog = ref(false)
const doAddMaterial = ref(false)
const showCtractSameMaterialDialog = ref(false)
const doAddSameMaterial = ref(false)
const tempPrice = ref(0)
const showCopyProductMaterialDialog = ref(false)
const copyProductMaterialLoadingMore = ref(false)
const copyProductMaterialPage = ref(1)
const copyProductMaterialPageSize = ref(20)
const copyProductMaterialHasMore = ref(true)
// const copyProductMaterialList = ref<CorrelateMaterialItem[]>([])
const copyProductMaterialListRef = ref<HTMLElement | null>(null)
const copyProductMaterialSearchKeyword = ref('')
const isSimilarImage = ref(false)
// 推荐类型：'recent' 最近, 'similar' 相似
const recommendationType = ref<'recent' | 'similar'>('recent')
const copyProductMaterialList = ref<{
  id: number
  syscode: string
  name: string
  nameShort?: string
  width?: string
  depth?: string
  innerHeight?: number
  imageUrls?: string
}[]>([])

const suggestProductMaterialList = ref<{
  id: number
  syscode: string
  name: string
  nameShort?: string
  width?: string
  depth?: string
  innerHeight?: number
  imageUrls?: string
}[]>([])

// 最近推荐数据
const recentProductMaterialList = ref<{
  id: number
  syscode: string
  name: string
  nameShort?: string
  width?: string
  depth?: string
  innerHeight?: number
  imageUrls?: string
}[]>([])

const showPreviewProductMaterialDialog = ref(false)
const previewProductMaterial = ref<any>({})
// 物料列表数据
const materialList = ref<MaterialItem[]>([])
const materialOptions = ref<{
  materialName: string
  materialCode?: string
  specDesc?: string
  materialType?: string
  materialPrice?: number
  materialImageUrls?: string
  materialUnit?: string
  materialCustomerNo?: string
}[]>([])

// 物料分页数据
const pagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})

const contractId = ref(0)
const statusPricing = ref(0)
const isCanEdit = ref(true)
// 产品信息数据
const productInfo = ref<ProductInfo>({
  code: '',
  pricingFinish: false,
  pricingStatus: false,
  name: '',
  shortName: '',
  description: '',
  priceRemark: '',
  width: 0,
  depth: 0,
  height: 0,
  count: 0,
  remark: '',
  remarks: '',
  productOrderId: 0,
  productImageUrls: [],
  price: 0,
  total: 0,
  priceLocal: 0,
  totalLocal: 0,
  materialSummary: {
    id: 0,
    widthModify: 0,
    heightModify: 0,
    depthModify: 0,
    base: 0,
    paint: 0,
    difference: 0,
    smallHardware: 0,
    glass: 0,
    stone: 0,
    fabric: 0,
    purchaseParts: 0,
    bigHardwareFee: 0,
    freightFee: 0,
    freightFeeWAdd: 0,
    freightFeeDAdd: 0,
    freightFeeHAdd: 0,
    freightFeeTax: 0,
    installationFee: 0,
    laborFee: 0,
    laborFeeTax: 0,
    laborFeeAdd: 0,
    manufacturingFee: 0,
    manufacturingFeeTax: 0,
    manufacturingFeeAdd: 0,
    profit: 0,
    profitTax: 0,
    profitAdd: 0,
    taxFee: 0,
    taxFeeTax: 0,
    cost: 0,
    fabricUsage: 0,
    adjustment: 1,
    materialTotal: 0,
    baseModify: 0,
    paintModify: 0,
    differenceModify: 0,
    smallHardwareModify: 0,
    glassModify: 0,
    stoneModify: 0,
    fabricModify: 0,
    purchasePartsModify: 0,
    bigHardwareFeeModify: 0,
    profitAdjustment: 0
  }
})

const fileInput = ref<HTMLInputElement | null>(null)
const imagePreviewUrl = computed(() => {
  if (!productInfo.value.productImageUrls || !Array.isArray(productInfo.value.productImageUrls)) return ''
  return productInfo.value.productImageUrls[0]?.url || ''
})

// 自动保存功能 - 监听表单数据变化
let autoSaveTimer: number | null = null
const autoSaveDelay = 1000 // 1秒防抖延迟

// 保存上一次的数据用于比较
let lastMaterialList: any = null
let lastProductInfo: any = null

// 深度比较两个对象是否相等
const isDataChanged = (newData: any, oldData: any): boolean => {
  if (newData === oldData) return false
  if (!newData || !oldData) return true
  
  // 如果是数组，比较长度和内容
  if (Array.isArray(newData) && Array.isArray(oldData)) {
    if (newData.length !== oldData.length) return true
    return newData.some((item, index) => isDataChanged(item, oldData[index]))
  }
  
  // 如果是对象，比较所有属性
  if (typeof newData === 'object' && typeof oldData === 'object') {
    const newKeys = Object.keys(newData)
    const oldKeys = Object.keys(oldData)
    
    // 检查旧对象中存在的键是否有变化
    for (const key of oldKeys) {
      if (!newData.hasOwnProperty(key)) {
        // 如果新对象中缺少这个键，且旧值不为空，则认为有变化
        if (oldData[key] !== null && oldData[key] !== undefined && oldData[key] !== '') {
          return true
        }
      } else {
        // 如果键存在，比较值
        if (isDataChanged(newData[key], oldData[key])) {
          return true
        }
      }
    }
    
    // 检查新对象中新增的键，如果值为空则不算变化
    for (const key of newKeys) {
      if (!oldData.hasOwnProperty(key)) {
        // 新增的键，如果值不为空才认为有变化
        if (newData[key] !== null && newData[key] !== undefined && newData[key] !== '') {
          return true
        }
      }
    }
    
    return false
  }
  
  // 基本类型直接比较
  return newData !== oldData
}

// 获取需要比较的产品信息数据
const getProductInfoForComparison = () => {
  const { 
    code, 
    name, 
    shortName, 
    description, 
    priceRemark,
    width, 
    depth, 
    height, 
    count, 
    remark,
    productImageUrls
  } = productInfo.value
  
  return {
    code,
    name,
    shortName,
    description,
    priceRemark,
    width,
    depth,
    height,
    count,
    remark,
    productImageUrls
  }
}

// 获取需要比较的物料列表数据
const getMaterialListForComparison = () => {
  return materialList.value.map(item => ({
    wuliaoId: item.wuliaoId,
    bigClass: item.bigClass,
    name: item.name,
    code: item.code,
    specification: item.specification,
    salesmanRemark: item.salesmanRemark,
    materialDescription: item.materialDescription,
    // supplier: item.supplier,
    type: item.type,
    price: item.price,
    count: item.count,
    total: item.total,
    materialUnit: item.materialUnit,
    images: item.images,
    materialCustomerNo: item.materialCustomerNo
  }))
}

// 自动保存物料
const debouncedAutoSaveMaterial = (() => {
  let timers: { [key: number]: number | null } = {}
  
  return (index: number, type: string = '') => {
    // 清除该索引对应的旧定时器
    if (timers[index]) {
      clearTimeout(timers[index])
    }
    
    // 设置新的定时器
    timers[index] = setTimeout(() => {
      handleSaveMaterial(index)
      // handleSaveAll('noMsg')
      // productList.value[index].showRed = 1
      oldEditMaterialIndex.value = index
      timers[index] = null
    }, 1000)
  }
})()

// 自动保存函数
const autoSave = (msg: string) => {
  // 只有在编辑模式下才自动保存
  if (isEdit.value === 'edit' || isEdit.value === 'estimate' || isEdit.value === 'materialControl') {
    // 清除之前的定时器
    if (autoSaveTimer) {
      clearTimeout(autoSaveTimer)
    }
    // 设置新的定时器
    autoSaveTimer = setTimeout(() => {
      // 检查是否有有效的产品数据
      // if (productInfo.value.code) {
        // 获取当前数据
        const currentProductInfo = getProductInfoForComparison()
        const currentMaterialList = getMaterialListForComparison()
        
        // 检查数据是否发生变化
        // const productInfoChanged = !lastProductInfo || isDataChanged(currentProductInfo, lastProductInfo)
        const materialListChanged = !lastMaterialList || isDataChanged(currentMaterialList, lastMaterialList)
        
        // 只有在数据真正发生变化时才保存productInfoChanged || 
        if (materialListChanged) {
          // 更新上一次的数据
          // lastProductInfo = JSON.parse(JSON.stringify(currentProductInfo))
          lastMaterialList = JSON.parse(JSON.stringify(currentMaterialList))
          console.log('自动保存')
          // 调用保存方法
          handleSaveAll(msg? msg : 'noMsg')
        }
      // }
    }, autoSaveDelay)
  }
}

// 监听产品信息变化
// watch(() => productInfo.value, () => {
//   autoSave()
// }, { deep: true })

// // 监听物料列表变化
// watch(() => materialList.value, () => {
//   autoSave()
// }, { deep: true })

const updateProductMaterialSummary = async () => {
  const submitData = {
    id: productInfo.value.materialSummary.id,
    widthModify: productInfo.value.materialSummary.widthModify,
    heightModify: productInfo.value.materialSummary.heightModify,
    depthModify: productInfo.value.materialSummary.depthModify,
    freightFeeWAdd: productInfo.value.materialSummary.freightFeeWAdd,
    freightFeeDAdd: productInfo.value.materialSummary.freightFeeDAdd,
    freightFeeHAdd: productInfo.value.materialSummary.freightFeeHAdd,
    freightFeeTax: productInfo.value.materialSummary.freightFeeTax,
    installationFee: productInfo.value.materialSummary.installationFee,
    laborFeeTax: productInfo.value.materialSummary.laborFeeTax,
    laborFeeAdd: productInfo.value.materialSummary.laborFeeAdd,
    manufacturingFeeTax: productInfo.value.materialSummary.manufacturingFeeTax,
    manufacturingFeeAdd: productInfo.value.materialSummary.manufacturingFeeAdd,
    profitTax: productInfo.value.materialSummary.profitTax,
    profitAdd: productInfo.value.materialSummary.profitAdd,
    taxFeeTax: productInfo.value.materialSummary.taxFeeTax,
    adjustment: productInfo.value.materialSummary.adjustment,
    priceRemark: productInfo.value.priceRemark,
  }
  const res = await contractApi.updateProductMaterialSummary(submitData)
  try {
    if (res?.code === 0) {
      // showSuccess('更新价格信息成功')
      loadProductDetail()
    }
  } catch (error: any) {
    console.error('更新价格信息失败:', error)
    showError(error.message || '更新价格信息失败')
  }
}

const loadMaterialFile = async (conntractId: number,syscode: string) => {
  try {
    const res = await contractApi.getMaterialFileBySyscode({
      syscode: syscode,
      productOrderId: Number(conntractId)
    })
    console.log('res', res)
    if (res?.code === 0) {
      materialFileList.value = res.data.items
      materialFileStatus.value = res.data.status
    }else{
      showError(res?.message)
    }
  } catch (error) {
    
  }
}

// 加载物料书
const loadMaterialFileList = async (conntractId: number) => {
  try {
    const res = (await contractApi.getMaterialFile({
      id: Number(conntractId)
    }))
    if (res?.code === 0) {
      materialFileAllList.value = res.data
    }else{
      showError(res?.message)
    }
  } catch (error) {
    showError(error.message || error.msg)
  }
}

const loadTempProductDetail = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  const productCode = route.query.productCode
  const mode = route.query.mode
  try {
    loading.value = true
    const res = await contractApi.getProductDetail(Number(productCode))
    if (res.code === 0 && res?.data) {
      const data = res.data
      contractId.value = data.contract.id
      // statusPricing.value = data.contract.statusPricing
      statusPricing.value = data.pricingStatus
      // isCanEdit.value = Number(data.contract.statusFinance) > 0 ? false : true
      // 更新产品信息
      productInfo.value = {
        code: data.code || '',
        // pricingFinish: Number(data.pricingFinish) === 1 ? true : false,
        pricingStatus: Number(data.pricingStatus) === 3 ? true : false,
        productOrderId: data.productOrderId,
        name: data.name || '',
        shortName: data.nameShort || '',
        description: data.description || '',
        priceRemark: data.priceRemark || '',
        width: data.width || 0,
        depth: data.depth || 0,
        height: data.height || 0,
        count: data.count || 0,
        remarks: data.remark || '',
        price: data.price || 0,
        total: data.total || 0,
        priceLocal: data.priceLocal || 0,
        totalLocal: data.totalLocal || 0,
        id: data.id,
        syscode: data.syscode,
        productShortName: data.productShortName,
        productDescription: data.productDescription,
        remark: data.remark,
        productImageUrls: data.imageUrls ? JSON.parse(data.imageUrls) : [],
        materialList: data.materialList || [],
        materialSummary: {
          id: data.materialSummary.id,
          widthModify: data.materialSummary.widthModifyTime && data.materialSummary.widthModifyTime != '' && data.materialSummary.widthModifyTime !== null ? data.materialSummary.widthModify : data.width || 0,
          heightModify: data.materialSummary.heightModifyTime && data.materialSummary.heightModifyTime != '' && data.materialSummary.heightModifyTime !== null ? data.materialSummary.heightModify : data.height || 0,
          depthModify: data.materialSummary.depthModifyTime && data.materialSummary.depthModifyTime != '' && data.materialSummary.depthModifyTime !== null ? data.materialSummary.depthModify : data.depth || 0,
          base: data.materialSummary.base || 0,
          paint: data.materialSummary.paint || 0,
          difference: data.materialSummary.difference || 0,
          smallHardware: data.materialSummary.smallHardware || 0,
          glass: data.materialSummary.glass || 0,
          stone: data.materialSummary.stone || 0,
          fabric: data.materialSummary.fabric || 0,
          purchaseParts: data.materialSummary.purchaseParts || 0,
          bigHardwareFee: data.materialSummary.bigHardwareFee || 0,
          freightFee: data.materialSummary.freightFee || 0,
          installationFee: data.materialSummary.installationFee || 0,
          laborFee: data.materialSummary.laborFee || 0,
          manufacturingFee: data.materialSummary.manufacturingFee || 0,
          profit: data.materialSummary.profit || 0,
          taxFee: data.materialSummary.taxFee || 0,
          cost: data.materialSummary.cost || 0,
          fabricUsage: data.materialSummary.fabricUsage || 0,
          adjustment: data.materialSummary.adjustment || 1,
          freightFeeWAdd: data.materialSummary.freightFeeWAdd || 0,
          freightFeeDAdd: data.materialSummary.freightFeeDAdd || 0,
          freightFeeHAdd: data.materialSummary.freightFeeHAdd || 0,
          freightFeeTax: data.materialSummary.freightFeeTax || 0,
          laborFeeTax: data.materialSummary.laborFeeTax || 0,
          laborFeeAdd: data.materialSummary.laborFeeAdd || 0,
          manufacturingFeeTax: data.materialSummary.manufacturingFeeTax || 0,
          manufacturingFeeAdd: data.materialSummary.manufacturingFeeAdd || 0,
          profitTax: data.materialSummary.profitTax || 0,
          profitAdd: data.materialSummary.profitAdd || 0,
          taxFeeTax: data.materialSummary.taxFeeTax || 0,
          materialTotal: data.materialSummary.materialTotal || 0,
          profitAdjustment: data.materialSummary.profitAdjustment || 0,
          baseModify: data.materialSummary.baseModifyTime && data.materialSummary.baseModifyTime != '' && data.materialSummary.baseModifyTime > 0 ? data.materialSummary.baseModify : data.materialSummary.base,
          paintModify: data.materialSummary.paintModifyTime && data.materialSummary.paintModifyTime != '' && data.materialSummary.paintModifyTime > 0 ? data.materialSummary.paintModify : data.materialSummary.paint,
          differenceModify: data.materialSummary.differenceModifyTime && data.materialSummary.differenceModifyTime != '' && data.materialSummary.differenceModifyTime > 0 ? data.materialSummary.differenceModify : data.materialSummary.difference,
          smallHardwareModify: data.materialSummary.smallHardwareModifyTime && data.materialSummary.smallHardwareModifyTime != '' && data.materialSummary.smallHardwareModifyTime > 0 ? data.materialSummary.smallHardwareModify : data.materialSummary.smallHardware,
          glassModify: data.materialSummary.glassModifyTime && data.materialSummary.glassModifyTime != '' && data.materialSummary.glassModifyTime > 0 ? data.materialSummary.glassModify : data.materialSummary.glass,
          stoneModify: data.materialSummary.stoneModifyTime && data.materialSummary.stoneModifyTime != '' && data.materialSummary.stoneModifyTime > 0 ? data.materialSummary.stoneModify : data.materialSummary.stone,
          fabricModify: data.materialSummary.fabricModifyTime && data.materialSummary.fabricModifyTime != '' && data.materialSummary.fabricModifyTime > 0 ? data.materialSummary.fabricModify : data.materialSummary.fabric,
          purchasePartsModify: data.materialSummary.purchasePartsModifyTime && data.materialSummary.purchasePartsModifyTime != '' && data.materialSummary.purchasePartsModifyTime > 0 ? data.materialSummary.purchasePartsModify : data.materialSummary.purchaseParts,
          bigHardwareFeeModify: data.materialSummary.bigHardwareFeeModifyTime && data.materialSummary.bigHardwareFeeModifyTime != '' && data.materialSummary.bigHardwareFeeModifyTime > 0 ? data.materialSummary.bigHardwareFeeModify : data.materialSummary.bigHardwareFee,
          baseModifyTime: data.materialSummary.baseModifyTime && data.materialSummary.baseModifyTime != '' && data.materialSummary.baseModifyTime > 0 ? true : false,
          paintModifyTime: data.materialSummary.paintModifyTime && data.materialSummary.paintModifyTime != '' && data.materialSummary.paintModifyTime > 0 ? true : false,
          differenceModifyTime: data.materialSummary.differenceModifyTime && data.materialSummary.differenceModifyTime != '' && data.materialSummary.differenceModifyTime > 0 ? true : false,
          smallHardwareModifyTime: data.materialSummary.smallHardwareModifyTime && data.materialSummary.smallHardwareModifyTime != '' && data.materialSummary.smallHardwareModifyTime > 0 ? true : false,
          glassModifyTime: data.materialSummary.glassModifyTime && data.materialSummary.glassModifyTime != '' && data.materialSummary.glassModifyTime > 0 ? true : false,
          stoneModifyTime: data.materialSummary.stoneModifyTime && data.materialSummary.stoneModifyTime != '' && data.materialSummary.stoneModifyTime > 0 ? true : false,
          fabricModifyTime: data.materialSummary.fabricModifyTime && data.materialSummary.fabricModifyTime != '' && data.materialSummary.fabricModifyTime > 0 ? true : false,
          purchasePartsModifyTime: data.materialSummary.purchasePartsModifyTime && data.materialSummary.purchasePartsModifyTime != '' && data.materialSummary.purchasePartsModifyTime > 0 ? true : false,
          bigHardwareFeeModifyTime: data.materialSummary.bigHardwareFeeModifyTime && data.materialSummary.bigHardwareFeeModifyTime != '' && data.materialSummary.bigHardwareFeeModifyTime > 0 ? true : false
        }
      }
      // if (data.materialList && Array.isArray(data.materialList) && data.materialList.length > 0) {
      //   // if(materialList.value.length > data.materialList.length){
      //   //   showSuccess('存在相同物料，正在合并相同物料')
      //   //   materialList.value = data.materialList
      //   // }else{
      //     for (let i = 0; i < data.materialList.length; i++) {
      //       // materialList.value[i].id = data.materialList[i].id
      //       materialList.value[i].total = data.materialList[i].materialTotal
      //     }
      //   // }
      // }

      await nextTick()
      const textareas = document.querySelectorAll('textarea')
      textareas.forEach(textarea => {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
      })
      // 初始化上一次的数据，避免首次加载时触发自动保存
      lastProductInfo = JSON.parse(JSON.stringify(getProductInfoForComparison()))
      lastMaterialList = JSON.parse(JSON.stringify(getMaterialListForComparison()))
    } else {
      showError('获取产品详情失败')
    }
  } catch (error: any) {
    console.error('获取产品详情失败:', error)
    showError(error.message || '获取产品详情失败')
  } finally {
    loading.value = false
  }
}

// 获取产品详情
const loadProductDetail = async () => {
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  const productCode = route.query.productCode
  const mode = route.query.mode

  try {
    loading.value = true
    const res = await contractApi.getProductDetail(Number(productCode))
    if (res?.data) {
      const data = res.data
      contractId.value = data.contract.id
      // statusPricing.value = data.contract.statusPricing
      statusPricing.value = data.pricingStatus
      // isCanEdit.value = Number(data.contract.statusFinance) > 0 ? false : true
      isCanEdit.value = true
      await loadMaterialFile(data.contract.id,data.syscode)
      await loadMaterialFileList(data.contract.id)
      // 更新产品信息
      productInfo.value = {
        code: data.code || '',
        // pricingFinish: Number(data.pricingFinish) === 1 ? true : false,
        pricingStatus: Number(data.pricingStatus) === 3 ? true : false,
        productOrderId: data.productOrderId,
        name: data.name || '',
        shortName: data.nameShort || '',
        description: data.description || '',
        priceRemark: data.priceRemark || '',
        width: data.width || 0,
        depth: data.depth || 0,
        height: data.height || 0,
        count: data.count || 0,
        remarks: data.remark || '',
        price: data.price || 0,
        total: data.total || 0,
        priceLocal: data.priceLocal || 0,
        totalLocal: data.totalLocal || 0,
        id: data.id,
        syscode: data.syscode,
        productShortName: data.productShortName,
        productDescription: data.productDescription,
        remark: data.remark,
        productImageUrls: data.imageUrls ? JSON.parse(data.imageUrls) : [],
        materialList: data.materialList,
        materialSummary: {
          id: data.materialSummary.id,
          widthModify: data.materialSummary.widthModifyTime && data.materialSummary.widthModifyTime != '' && data.materialSummary.widthModifyTime !== null ? data.materialSummary.widthModify : data.width || 0,
          heightModify: data.materialSummary.heightModifyTime && data.materialSummary.heightModifyTime != '' && data.materialSummary.heightModifyTime !== null ? data.materialSummary.heightModify : data.height || 0,
          depthModify: data.materialSummary.depthModifyTime && data.materialSummary.depthModifyTime != '' && data.materialSummary.depthModifyTime !== null ? data.materialSummary.depthModify : data.depth || 0,
          base: data.materialSummary.base || 0,
          paint: data.materialSummary.paint || 0,
          difference: data.materialSummary.difference || 0,
          smallHardware: data.materialSummary.smallHardware || 0,
          glass: data.materialSummary.glass || 0,
          stone: data.materialSummary.stone || 0,
          fabric: data.materialSummary.fabric || 0,
          purchaseParts: data.materialSummary.purchaseParts || 0,
          bigHardwareFee: data.materialSummary.bigHardwareFee || 0,
          freightFee: data.materialSummary.freightFee || 0,
          installationFee: data.materialSummary.installationFee || 0,
          laborFee: data.materialSummary.laborFee || 0,
          manufacturingFee: data.materialSummary.manufacturingFee || 0,
          profit: data.materialSummary.profit || 0,
          taxFee: data.materialSummary.taxFee || 0,
          cost: data.materialSummary.cost || 0,
          fabricUsage: data.materialSummary.fabricUsage || 0,
          adjustment: data.materialSummary.adjustment || 1,
          freightFeeWAdd: data.materialSummary.freightFeeWAdd || 0,
          freightFeeDAdd: data.materialSummary.freightFeeDAdd || 0,
          freightFeeHAdd: data.materialSummary.freightFeeHAdd || 0,
          freightFeeTax: data.materialSummary.freightFeeTax || 0,
          laborFeeTax: data.materialSummary.laborFeeTax || 0,
          laborFeeAdd: data.materialSummary.laborFeeAdd || 0,
          manufacturingFeeTax: data.materialSummary.manufacturingFeeTax || 0,
          manufacturingFeeAdd: data.materialSummary.manufacturingFeeAdd || 0,
          profitTax: data.materialSummary.profitTax || 0,
          profitAdd: data.materialSummary.profitAdd || 0,
          taxFeeTax: data.materialSummary.taxFeeTax || 0,
          materialTotal: data.materialSummary.materialTotal || 0,
          profitAdjustment: data.materialSummary.profitAdjustment || 0,
          baseModify: data.materialSummary.baseModifyTime && data.materialSummary.baseModifyTime != '' && data.materialSummary.baseModifyTime > 0 ? data.materialSummary.baseModify : data.materialSummary.base,
          paintModify: data.materialSummary.paintModifyTime && data.materialSummary.paintModifyTime != '' && data.materialSummary.paintModifyTime > 0 ? data.materialSummary.paintModify : data.materialSummary.paint,
          differenceModify: data.materialSummary.differenceModifyTime && data.materialSummary.differenceModifyTime != '' && data.materialSummary.differenceModifyTime > 0 ? data.materialSummary.differenceModify : data.materialSummary.difference,
          smallHardwareModify: data.materialSummary.smallHardwareModifyTime && data.materialSummary.smallHardwareModifyTime != '' && data.materialSummary.smallHardwareModifyTime > 0 ? data.materialSummary.smallHardwareModify : data.materialSummary.smallHardware,
          glassModify: data.materialSummary.glassModifyTime && data.materialSummary.glassModifyTime != '' && data.materialSummary.glassModifyTime > 0 ? data.materialSummary.glassModify : data.materialSummary.glass,
          stoneModify: data.materialSummary.stoneModifyTime && data.materialSummary.stoneModifyTime != '' && data.materialSummary.stoneModifyTime > 0 ? data.materialSummary.stoneModify : data.materialSummary.stone,
          fabricModify: data.materialSummary.fabricModifyTime && data.materialSummary.fabricModifyTime != '' && data.materialSummary.fabricModifyTime > 0 ? data.materialSummary.fabricModify : data.materialSummary.fabric,
          purchasePartsModify: data.materialSummary.purchasePartsModifyTime && data.materialSummary.purchasePartsModifyTime != '' && data.materialSummary.purchasePartsModifyTime > 0 ? data.materialSummary.purchasePartsModify : data.materialSummary.purchaseParts,
          bigHardwareFeeModify: data.materialSummary.bigHardwareFeeModifyTime && data.materialSummary.bigHardwareFeeModifyTime != '' && data.materialSummary.bigHardwareFeeModifyTime > 0 ? data.materialSummary.bigHardwareFeeModify : data.materialSummary.bigHardwareFee,
          baseModifyTime: data.materialSummary.baseModifyTime && data.materialSummary.baseModifyTime != '' && data.materialSummary.baseModifyTime > 0 ? true : false,
          paintModifyTime: data.materialSummary.paintModifyTime && data.materialSummary.paintModifyTime != '' && data.materialSummary.paintModifyTime > 0 ? true : false,
          differenceModifyTime: data.materialSummary.differenceModifyTime && data.materialSummary.differenceModifyTime != '' && data.materialSummary.differenceModifyTime > 0 ? true : false,
          smallHardwareModifyTime: data.materialSummary.smallHardwareModifyTime && data.materialSummary.smallHardwareModifyTime != '' && data.materialSummary.smallHardwareModifyTime > 0 ? true : false,
          glassModifyTime: data.materialSummary.glassModifyTime && data.materialSummary.glassModifyTime != '' && data.materialSummary.glassModifyTime > 0 ? true : false,
          stoneModifyTime: data.materialSummary.stoneModifyTime && data.materialSummary.stoneModifyTime != '' && data.materialSummary.stoneModifyTime > 0 ? true : false,
          fabricModifyTime: data.materialSummary.fabricModifyTime && data.materialSummary.fabricModifyTime != '' && data.materialSummary.fabricModifyTime > 0 ? true : false,
          purchasePartsModifyTime: data.materialSummary.purchasePartsModifyTime && data.materialSummary.purchasePartsModifyTime != '' && data.materialSummary.purchasePartsModifyTime > 0 ? true : false,
          bigHardwareFeeModifyTime: data.materialSummary.bigHardwareFeeModifyTime && data.materialSummary.bigHardwareFeeModifyTime != '' && data.materialSummary.bigHardwareFeeModifyTime > 0 ? true : false
        }
      }
      // 设置浏览器标签页标题为产品名称（如果不为空）
      if (data.name && data.name.trim() !== '') {
        document.title = data.name
      }else{
        document.title = '估价'
      }
      // 处理物料清单数据
      // if (data.materialList && Array.isArray(data.materialList)) {
      //   materialList.value = data.materialList.map(item => {
      //     let images = []
      //     try {
      //       if (item.materialImageUrls) {
      //         images = JSON.parse(item.materialImageUrls)
      //       }
      //     } catch (error) {
      //       console.error('解析materialImageUrls失败:', error)
      //     }
          
      //     return {
      //       bigClass: item.bigClass || '',
      //       id: item.id || null,
      //       wuliaoId: item.wuliaoId || null,
      //       name: item.materialName || '',
      //       materialName: item.materialName || '',
      //       code: item.materialCode || '',
      //       specification: item.specDesc || '',
      //       salesmanRemark: item.salesmanRemark || '',
      //       materialDescription: item.materialDescription || '',
      //       // supplier: item.supplier || '',
      //       type: item.materialType || '',
      //       image: null,
      //       price: item.materialPrice || 0,
      //       count: item.count || 0,
      //       total: item.materialTotal || 0,
      //       images: images,
      //       materialUnit: item.materialUnit || '',
      //       isDelete: item.isDelete || 0,
      //       wuliaoStatus: item.wuliaoStatus || 0,
      //       toWuliaoTime: item.toWuliaoTime ? item.toWuliaoTime : '',
      //       isTurn: item.hasTo || false,
      //       materialCustomerNo: item.materialCustomerNo || '',
      //       // isTurn: item.toWuliaoTime !== '' && item.toWuliaoTime !== null && item.toWuliaoTime !== undefined ? true : false
      //     }
      //   })
      // } else {
      //   materialList.value = []
      // }
      if(isEdit.value === 'estimate'){
        copyProductMaterialByImage()
      }
      await nextTick()
      const textareas = document.querySelectorAll('textarea')
      textareas.forEach(textarea => {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
      })
      // 初始化上一次的数据，避免首次加载时触发自动保存
      lastProductInfo = JSON.parse(JSON.stringify(getProductInfoForComparison()))
      lastMaterialList = JSON.parse(JSON.stringify(getMaterialListForComparison()))
    } else {
      showError('获取产品详情失败')
    }
  } catch (error: any) {
    console.error('获取产品详情失败:', error)
    showError(error.message || error.msg)
  } finally {
    loading.value = false
  }
}

// 获取物料列表数据
const loadProductMaterialList = async (type?: string) => {
  console.log('loadProductMaterialList', type)
  if(!route.query.productCode || route.query.productCode === 'undefined' || route.query.productCode === 'null' || route.query.productCode === '' || route.query.productCode === null){
    return
  }
  
  const productCode = route.query.productCode
  const res = await contractApi.getProductMaterialList({ 
    id: productCode,
    page: pagination.value.page,
    pageSize: pagination.value.pageSize
  })
  
  if(res.code === 0 && res?.data){
    // 更新分页信息
    materialList.value = []
    if (res.data.total !== undefined) {
      pagination.value.total = res.data.total
    }
    
    if (res.data.records && Array.isArray(res.data.records)) {
        materialList.value = res.data.records.map(item => {
          let images = []
          try {
            if (item.materialImageUrls) {
              images = JSON.parse(item.materialImageUrls)
            }
          } catch (error) {
            console.error('解析materialImageUrls失败:', error)
          }
          
          return {
            bigClass: item.bigClass || '',
            id: item.id || null,
            wuliaoId: item.wuliaoId || null,
            name: item.materialName || '',
            materialName: item.materialName || '',
            code: item.materialCode || '',
            specification: item.specDesc || '',
            salesmanRemark: item.salesmanRemark || '',
            materialDescription: item.materialDescription || '',
            // supplier: item.supplier || '',
            type: item.materialType || '',
            image: null,
            price: item.materialPrice || 0,
            count: item.count || 0,
            total: item.materialTotal || 0,
            images: images,
            materialUnit: item.materialUnit || '',
            isDelete: item.isDelete || 0,
            wuliaoStatus: item.wuliaoStatus || 0,
            toWuliaoTime: item.toWuliaoTime ? item.toWuliaoTime : '',
            isTurn: item.hasTo || false,
            materialCustomerNo: item.materialCustomerNo || '',
          }
        })
        
        console.log('materialList',type)
        if(type === 'special'){
          console.log('跳转后新增一条')
          materialList.value.push({
            id: '',
            wuliaoId: '',
            name: '',
            code: '',
            specification: '',
            salesmanRemark: '',
            materialDescription: '',
            // supplier: '',
            bigClass: '',
            type: '',
            images: [],
            price: 0,
            count: 0,
            total: 0,
            materialUnit: '',
            isDelete: 0,
            wuliaoStatus: 0,
            toWuliaoTime: '',
            isTurn: false
          })
          pagination.value.total += 1
          // editMaterialIndex.value = materialList.value.length - 1
          handleSaveMaterial(materialList.value.length - 1, 'special')
          
          // 重置新产品的图片索引
          const newProductIndex = materialList.value.length - 1
          productImageIndexes.value[newProductIndex] = 0
        }
      } else {
        materialList.value = []
      }
  }
}

// 计算物料列表总页数
const totalPages = computed(() => Math.ceil(pagination.value.total / pagination.value.pageSize))

// 分页切换功能
const handlePageChange = (page: number) => {
  pagination.value.page = page
  console.log('物料分页变化', pagination.value.page)
  loadProductMaterialList()
}

// 每页数量切换功能
const handlePageSizeChange = (pageSize: number) => {
  pagination.value.pageSize = pageSize
  pagination.value.page = 1 // 重置到第一页
  loadProductMaterialList()
}

// 初始化
onMounted(async () => {
  // 页面进入时滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  
  isEdit.value = route.query.mode as 'edit' | 'estimate' | 'see' | 'materialControl' | 'new'
  // if (isEdit.value === 'edit' || isEdit.value === 'estimate') {

  // }else{
  //   materialHeaders.splice(-1, 1)
  // }
  loadProductMaterialList()
  await loadProductDetail()
  loadCorrelateMaterial()
  // 添加滚动监听，实现产品信息固定
  nextTick(() => {
    if (productInfoSection.value) {
      productInfoOriginalTop.value = productInfoSection.value.offsetTop
      // window.addEventListener('scroll', handleProductInfoScroll)
    }
  })
})

// 滚动处理函数
const handleProductInfoScroll = () => {
  if (productInfoSection.value) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const shouldFix = scrollTop >= productInfoOriginalTop.value
    
    if (shouldFix !== isProductInfoFixed.value) {
      isProductInfoFixed.value = shouldFix
    }
  }
}

// 清理滚动监听
onUnmounted(() => {
  // window.removeEventListener('scroll', handleProductInfoScroll)
})

// 添加物料项
const addMaterialItem = () => {
  if(materialList.value.length === pagination.value.pageSize && pagination.value.page === pagination.value.total / pagination.value.pageSize){
    console.log('先跳转再新增一条1')
    pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize) + 1
    // materialList.value = materialList.value.slice(pagination.value.pageSize, materialList.value.length)
    loadProductMaterialList('special')
  }else if(materialList.value.length === pagination.value.pageSize){
    console.log('先跳转再新增一条2')
    pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize)
    // materialList.value = materialList.value.slice(pagination.value.pageSize, materialList.value.length)
    loadProductMaterialList('special')
  }else{
    materialList.value.push({
      id: '',
      wuliaoId: '',
      name: '',
      code: '',
      specification: '',
      salesmanRemark: '',
      materialDescription: '',
      // supplier: '',
      bigClass: '',
      type: '',
      images: [],
      price: 0,
      count: 0,
      total: 0,
      materialUnit: '',
      isDelete: 0,
      wuliaoStatus: 0,
      toWuliaoTime: '',
      isTurn: false
    })
    // handleSaveAll('noMsg')
    // editMaterialIndex.value = materialList.value.length - 1
    handleSaveMaterial(materialList.value.length - 1, 'special')
    pagination.value.total += 1
    // 重置新产品的图片索引
    const newProductIndex = materialList.value.length - 1
    productImageIndexes.value[newProductIndex] = 0
  }
  // 自动滚动到页面底部
  // nextTick(() => {
  //   window.scrollTo({
  //     top: document.documentElement.scrollHeight,
  //     behavior: 'smooth'
  //   })
  // })
}

// 添加删除确认对话框的状态变量
const showDeleteConfirm = ref(false)
const showRemoveConfirm = ref(false)
const deleteLoading = ref(false)
const materialToDeleteIndex = ref(-1)

const isShowMaterialDescriptionMerge = ref(false)
const materialDescriptionMerge = ref('')
// 产品描述详情
const showMaterialDescriptionMerge = (description: string) => {
  console.log('产品描述详情', description)
  isShowMaterialDescriptionMerge.value = true
  materialDescriptionMerge.value = description
}

const removeOutMaterialItem = (index: number) => {
  if(materialList.value[index].isDelete === 1){
    showError('该物料已移除')
    return
  }
  if(isEdit.value === 'see'){
    showError('暂无权限移除物料')
    return
  }
  if(!isCanEdit.value){
    showError('已转财务,不可操作')
    return
  }
  materialToDeleteIndex.value = index
  showRemoveConfirm.value = true
}

// 删除物料项
const removeMaterialItem = (index: number) => {
  if(materialList.value[index].isDelete === 1){
    showError('该物料已移除')
    return
  }
  if(isEdit.value === 'see'){
    showError('暂无权限删除物料')
    return
  }
  if(!isCanEdit.value){
    showError('已转财务,不可操作')
    return
  }
  materialToDeleteIndex.value = index
  showDeleteConfirm.value = true
}

// 添加确认移除物料的方法
const confirmRomoveDeleteMaterial = async () => {
  try {
    deleteLoading.value = true
    const index = materialToDeleteIndex.value
    const res = await contractApi.deleteProductMaterial({
      productId: productInfo.value.id,
      materialId: materialList.value[index].id
    })
    if(res?.code === 0){
      showSuccess('物料移除成功')
      materialList.value[index].isDelete = 1
      // 刷新产品详情
      await loadProductDetail()
    }else{
      showError(res.message || error.msg)
    }
  } catch (error: any) {
    console.error('移除物料项失败:', error)
    showError(error.message || error.msg)
    deleteLoading.value = false
    showRemoveConfirm.value = false
    materialToDeleteIndex.value = -1
  } finally {
    deleteLoading.value = false
    showRemoveConfirm.value = false
    materialToDeleteIndex.value = -1
  }
}

const confirmDeleteMaterial = async () => {
  try {
    deleteLoading.value = true
    const index = materialToDeleteIndex.value
    const res = await contractApi.deleteProductMaterial({
      productId: productInfo.value.id,
      materialId: materialList.value[index].id
    })
    if(res?.code === 0){
      materialList.value.splice(index, 1)
      pagination.value.total = pagination.value.total - 1
      if(materialList.value.length === 0){
        pagination.value.page = pagination.value.page - 1
        pagination.value.pageSize = 20
        loadProductMaterialList()
      }
      showSuccess('物料删除成功')
      // 刷新产品详情
      await loadProductDetail()
    }else{
      showError(res.message || error.msg)
    }
  } catch (error: any) {
    console.error('删除物料项失败:', error)
    showError(error.message || error.msg)
    deleteLoading.value = false
    showDeleteConfirm.value = false
    materialToDeleteIndex.value = -1
  } finally {
    deleteLoading.value = false
    showDeleteConfirm.value = false
    materialToDeleteIndex.value = -1
  }
}
// 添加确认删除物料的方法
// const confirmDeleteMaterial = async () => {
//   try {
//     deleteLoading.value = true
//     const index = materialToDeleteIndex.value
    
//     // 如果有物料ID，调用删除API（如果API存在的话）
//     const materialItem = materialList.value[index]
//     // if(materialItem.toWuliaoTime !== '' && materialItem.toWuliaoTime !== null && materialItem.toWuliaoTime !== undefined){
//     //   showError('该物料正在物控中，无法删除')
//     //   showDeleteConfirm.value = false
//     //   return
//     // }
//     // 清理该物料项的所有图片预览URL
//     // if (materialItem?.images && Array.isArray(materialItem.images)) {
//     //   materialItem.images.forEach(image => {
//     //     if (image instanceof File) {
//     //       const url = getImagePreviewUrl(image)
//     //       if (url) {
//     //         URL.revokeObjectURL(url)
//     //       }
//     //     }
//     //   })
//     // }
    
//     // 从列表中删除该项
//     materialList.value.splice(index, 1)
//     showRemoveConfirm.value = false
//     materialToDeleteIndex.value = -1
//     handleSaveAll('物料删除成功')

//   } catch (error: any) {
//     console.error('删除物料项失败:', error)
//     showError(error.message || '删除物料项失败')
//   } finally {
//     deleteLoading.value = false
//   }
// }

// 计算总额
const calculateTotal = (event: Event, index: number, field: 'price' | 'count') => {
  const input = event.target as HTMLInputElement
  const value = input.value

  const item = materialList.value[index]
  // 物料总额两位小数
  item.total = Number((Number(item.price) * Number(item.count)).toFixed(2))

  if (field === 'count') {
    // 对于数量，只允许整数
    // const newValue = value.replace(/[^\d]/g, '')
    // if (newValue !== value) {
    //   item[field] = Number(newValue)
    // }
    // 三位小数
    const newValue = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.[\d]{3})./g, '$1')
    if (newValue !== value) {
      item[field] = Number(Number(newValue).toFixed(3))
    }
  } else {
    // 对于价格，允许两位小数
    const newValue = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\.[\d]{2})./g, '$1')
    if (newValue !== value) {
      item[field] = Number(Number(newValue).toFixed(2))
    }
  }
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const formatNumber = (num: number) => {
  if(num){
    return num.toLocaleString('en-US')
  } else{
    return '0'
  }
}

// 处理新增的物料图
const handleNewImageUpload = (event: Event, index: number) => {
  showUploadDialog.value = true
}

// 处理新增的物料图上传成功
const handleNewImageUploadSuccess = (urls: string[]) => {
  customMaterialImageUrls.value = urls.map(url => ({
    url,
    name: `物料图_${Date.now()}`
  }))
  showUploadDialog.value = false
}
// 处理物料图
const handleImageUpload = (event: Event, index: number) => {
  const input = event.target as HTMLInputElement
  if (input.files && input.files[0]) {
    materialList.value[index].image = input.files[0]
  }
}

// 触发文件选择
const triggerImageUpload = (index: number) => {
  const input = fileInputs.value[index]
  if (input) {
    input.click()
  }
}

// 处理产品物料图
const handleProductImageUpload = (event: Event) => {
  const input = event.target as HTMLInputElement
  if (input.files && input.files[0]) {
    const file = input.files[0]
    productInfo.value.image = file
    // 创建预览URL
    imagePreviewUrl.value = URL.createObjectURL(file)
  }
}

// 在组件卸载时清理预览URL
onUnmounted(() => {
  // 清理自动保存定时器
  if (autoSaveTimer) {
    clearTimeout(autoSaveTimer)
  }
  
  // 清理图片预览URL
  if (imagePreviewUrl.value) {
    URL.revokeObjectURL(imagePreviewUrl.value)
  }
  
  // 确保在组件卸载前清理所有图片预览URL
  materialList.value.forEach(item => {
    if (item.images && Array.isArray(item.images)) {
      item.images.forEach(image => {
        if (image instanceof File) {
          const url = getImagePreviewUrl(image)
          if (url) {
            URL.revokeObjectURL(url)
          }
        }
      })
    }
  })
})

// 设置文件输入引用
const setFileInput = (el: any, index: number) => {
  if (el instanceof HTMLInputElement) {
    fileInputs.value[index] = el
  }
}

// 针对单个物料的截图导入
const handleScreenshotImportMaterial = (index: number, id: string) => {
  uploadMaterialImgDialog.value = true
  materialToUploadIndex.value = index
  materialToUploadId.value = id
}

// 针对单个物料的截图导入成功
const handleScreenshotImportMaterialSuccess = async(urls: string[]) => {
  console.log('截图导入成功', urls)
  showCommonLoading.value = true
  commonLoadingText.value = '截图导入中...'
  try {
    const res = await contractApi.extractMaterialImage({
      id: materialToUploadId.value,
      imageUrl: urls[0]
    })
    if(res?.code === 0){
      let interval = setInterval(async () => {
        try {
          const res2 = await contractApi.extractMaterialImageStatus ({
            id: materialToUploadId.value
          })
          if(res2?.data?.status === 'success'){
            showSuccess('截图导入成功')
            showCommonLoading.value = false
            commonLoadingText.value = ''
            materialList.value[materialToUploadIndex.value].bigClass = res2?.data?.data[0].bigClass !== '' ? res2?.data?.data[0].bigClass : materialList.value[materialToUploadIndex.value].bigClass  
            materialList.value[materialToUploadIndex.value].type = res2?.data?.data[0].materialType !== '' ? res2?.data?.data[0].materialType : materialList.value[materialToUploadIndex.value].type
            materialList.value[materialToUploadIndex.value].materialCustomerNo = res2?.data?.data[0].materialCustomerNo !== '' ? res2?.data?.data[0].materialCustomerNo : materialList.value[materialToUploadIndex.value].materialCustomerNo
            materialList.value[materialToUploadIndex.value].materialUnit = res2?.data?.data[0].materialUnit !== '' ? res2?.data?.data[0].materialUnit : materialList.value[materialToUploadIndex.value].materialUnit
            materialList.value[materialToUploadIndex.value].materialDescription = res2?.data?.data[0].materialDescription !== '' ? res2?.data?.data[0].materialDescription : materialList.value[materialToUploadIndex.value].materialDescription
            materialList.value[materialToUploadIndex.value].name = res2?.data?.data[0].materialName !== '' ? res2?.data?.data[0].materialName : materialList.value[materialToUploadIndex.value].name
            materialList.value[materialToUploadIndex.value].images = res2?.data?.data[0].materialImageUrls !== '' ? res2?.data?.data[0].materialImageUrls : materialList.value[materialToUploadIndex.value].images
            materialList.value[materialToUploadIndex.value].specification = res2?.data?.data[0].specDesc !== '' ? res2?.data?.data[0].specDesc : materialList.value[materialToUploadIndex.value].specDesc
            materialList.value[materialToUploadIndex.value].id = materialToUploadId.value
            handleSaveMaterial(materialToUploadIndex.value)
            clearInterval(interval)
          }else if(res2?.data?.status === 'failed' || res2?.data?.status === 'timeout'){
            showError('截图导入失败')
            showCommonLoading.value = false
            commonLoadingText.value = ''
            clearInterval(interval)
          }
        } catch (error) {
          showError(error.msg)
          clearInterval(interval)
        }
      }, 5000)
    }else{
      showError(res?.message)
    }
  } catch (error) {
    showError(error.msg)
  } 
  // 重置状态
  uploadImgDialogOpen.value = false
}


// 处理截图导入
const handleScreenshotImport = () => {
  uploadImgDialogOpen.value = true
}

// 处理截图导入成功
const handleScreenshotImportSuccess = async(urls: string[]) => {
  console.log('截图导入成功', urls)
  showCommonLoading.value = true
  commonLoadingText.value = '截图导入中...'
  try {
    const res = await contractApi.extractMaterialImage({
      id: productInfo.value.id,
      imageUrl: urls[0]
    })
    if(res?.code === 0){
      let interval = setInterval(async () => {
        try {
          const res2 = await contractApi.extractMaterialImageStatus ({
            id: productInfo.value.id
          })
          if(res2?.data === 'success'){
            showSuccess('截图导入成功')
            showCommonLoading.value = false
            commonLoadingText.value = ''
            loadProductDetail()
            if(materialList.value.length === pagination.value.pageSize && pagination.value.page === pagination.value.total / pagination.value.pageSize){
              pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize) + 1
            }else{
              pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize)
            }
            loadProductMaterialList()
            clearInterval(interval)
          }else if(res2?.data === 'failed' || res2?.data === 'timeout'){
            showError('截图导入失败')
            showCommonLoading.value = false
            commonLoadingText.value = ''
            clearInterval(interval)
          }
        } catch (error) {
          showError(error.msg)
          clearInterval(interval)
        }
      }, 5000)
    }else{
      showError(res?.message)
    }
  } catch (error) {
    showError(error.msg)
  } 
  // 重置状态
  uploadImgDialogOpen.value = false
}

// 复制物料
const copyProductMaterial = () => {
  showCopyProductMaterialDialog.value = true
  copyProductMaterialSearchKeyword.value = ''
  copyProductMaterialList.value = []
  copyProductMaterialPage.value = 1
  copyProductMaterialHasMore.value = true
  copyProductMaterialLoadingMore.value = false
  // 默认显示最近推荐
  recommendationType.value = 'recent'
  // 加载最近推荐数据
  loadRecentProductMaterialList()
  console.log('复制产品物料')
}

// 处理推荐类型切换
const handleRecommendationTypeChange = (type: 'recent' | 'similar') => {
  recommendationType.value = type
  if (type === 'recent') {
    loadRecentProductMaterialList()
  } else if (type === 'similar') {
    copyProductMaterialByImage()
  }
}

// 获取最近使用的产品物料
const loadRecentProductMaterialList = async () => {
  try {
    const res = await contractApi.getSimilarImage({
      productOrderItemId: productInfo.value.id,
      pricingStatus: 3,
      type: 'recent' // 添加类型参数区分最近和相似
    })
    if (res?.code === 0) {
      recentProductMaterialList.value = res.data || []
    } else {
      recentProductMaterialList.value = []
    }
  } catch (error) {
    console.error('获取最近产品物料失败:', error)
    recentProductMaterialList.value = []
  }
}

// 根据产品图推荐复制物料
const copyProductMaterialByImage = async() => {
  try {
    const res = await contractApi.getSimilarImage({
      productOrderItemId: productInfo.value.id,
      pricingStatus: 3
    })
    if(res?.code === 0){
      if(res.data.length > 0){
        suggestProductMaterialList.value = res.data
        isSimilarImage.value = true
      }else{
        suggestProductMaterialList.value = []
        isSimilarImage.value = false
      }
    }
  } catch (error) {
    console.error('获取相似图片物料失败:', error)
  }
}
// 导入物料
const importMaterial = () => {
  addResultContent.value = ''
  addResultErrorContent.value = ''
  customMaterialName.value = ''
  customMaterialSpecDesc.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  searchKeyword.value = ''
  page.value = 1
  hasMore.value = true
  materialOptions.value = []
  importExcelDialogOpen.value = true
}

// 下载物料模板
const downloadMaterial = () => {
  const url = 'https://avalon-1304177540.cos.ap-shanghai.myqcloud.com/client/jiangfeng/excel/%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
  const a = document.createElement('a')
  a.href = url
  a.download = '物料模板.xlsx'
  a.click()
}
// 处理导入开始
const handleImportStart = () => {
  if(importExcelTypeKind.value === 0){
    // showImportAnimation.value = true
  }else if(importExcelTypeKind.value === 1){
    showImportAnimationMaterial.value = true
  }
  // 设置初始值为20
  // importExcelCount.value.count = 20
  // importAnimationText.value = `正在导入Excel，请勿重复操作，已导入${importExcelCount.value.count}%`
  
  interval1.value = setInterval(() => {
    // 确保count是有效的数字，避免NaN
    const currentCount = Number(importExcelCount.value.count) || 20
    // 3分钟 = 180秒，从20到100需要增加80，每秒增加 80/180 ≈ 0.444  2min 0.296
    const newCount = currentCount + 0.296
    importExcelCount.value.count = newCount
    // console.log('newCount', newCount)
    if(newCount < 99){
      importAnimationText.value = `正在导入Excel，请勿重复操作，已导入${newCount.toFixed(0)}%`
    }else{
      importAnimationText.value = `正在导入Excel，请勿重复操作，已导入99%`
      clearInterval(interval1.value)
    }
  }, 1000)
}

// 导入excel
const handleImportExcel = async (files: { url: string; name: string }[]) => {
  const excelUrl = files[0].url
  addResultContent.value = '正在导入物料...'
  try {
    const res = await contractApi.importPresetMaterialExcel ({
      // id: Number(contractId.value),
      url: excelUrl,
      // row: row,
      // type: type,
      // sheetIndexList: sheetIndexList
    })
    if(res?.code === 0){
      // 隐藏导入框
      importExcelDialogOpen.value = false

      addResultContent.value = res.data
      addResultErrorContent.value = ''
      // 开始检查导入状态
      // findImportProductStatus()
      
      // handleImportStart()
      // if(message){
      //   showSuccess(message) 
      // }else{
      //   showSuccess('文档上传成功') 
      // }
    }else if(res?.code === -1){
      showError(res.message)// 如果上传失败，隐藏动画
      addResultContent.value = ''
      addResultErrorContent.value = res.message
      // if(importExcelTypeKind.value === 0){
      //   showImportAnimation.value = false
      //   importExcelCount.value.count = 20
      // }else if(importExcelTypeKind.value === 1){
        showImportAnimationMaterial.value = false
        importExcelCount.value.count = 20
      // }
      clearInterval(interval1.value)
    }else{
      showError(res.message || '导入失败，请检查表格是否符合规范')
      addResultContent.value = ''
      addResultErrorContent.value = res.message
      // 如果上传失败，隐藏动画
      // if(importExcelTypeKind.value === 0){
      //   showImportAnimation.value = false
      //   importExcelCount.value.count = 20
      // }else if(importExcelTypeKind.value === 1){
        showImportAnimationMaterial.value = false
        importExcelCount.value.count = 20
      // }
      clearInterval(interval1.value)
    }
  } catch (err) {
    showError(err.message || '导入失败，请检查表格是否符合规范')
    addResultContent.value = ''
    addResultErrorContent.value = err.message
    // 如果上传失败，隐藏动画
    // if(importExcelTypeKind.value === 0){
    //   showImportAnimation.value = false
    //   importExcelCount.value.count = 20
    // }else if(importExcelTypeKind.value === 1){
      showImportAnimationMaterial.value = false
      importExcelCount.value.count = 20
    // }
    clearInterval(interval1.value)
  }
}

// 查询导入是否成功
const findImportProductStatus = async () => {
  // 启动定时器，每5秒检查一次导入状态
  const checkInterval = setInterval(async () => {
    try {
      const res = await contractApi.findImportProductStatus({
        id: Number(contractId.value)
      })
      console.log('检查导入状态:', res)
      if(Number(res?.data) === 1){
        // 导入完成，隐藏动画并清除定时器
        // if(importExcelTypeKind.value === 0){
        //   showImportAnimation.value = false
        //   importExcelCount.value.count = 20
        //   // importAnimationText.value = `正在导入Excel，请勿重复操作，已导入${newCount.toFixed(0)}%`
        //   importAnimationText.value = ''
        // }else if(importExcelTypeKind.value === 1){
          showImportAnimationMaterial.value = false
          importExcelCount.value.count = 20
          importAnimationText.value = ''
        // }
        clearInterval(checkInterval)
        clearInterval(interval1.value)
        // showSuccess('Excel导入成功') 
        // 重新加载合同数据
        // loadProductList()
        // loadWuliaoList()
      }else if(Number(res?.data) === 0){
        // 导入中，继续显示动画
        if(interval1.value){
          // clearInterval(interval1.value)
        }else{
          handleImportStart()
        }
        // if(importExcelTypeKind.value === 0){
        //   showImportAnimation.value = true
        // }else if(importExcelTypeKind.value === 1){
        //   showImportAnimationMaterial.value = true
        // }
      }else if(Number(res?.data) === 2){
        // 导入失败
        showError(res.message || '导入失败，请检查表格是否符合规范')
        // if(importExcelTypeKind.value === 0){
        //   showImportAnimation.value = false
        //   importExcelCount.value.count = 20
        //   importAnimationText.value = ''
        // }else if(importExcelTypeKind.value === 1){
          showImportAnimationMaterial.value = false
          importExcelCount.value.count = 20
          importAnimationText.value = ''
        // }
        clearInterval(checkInterval)
        clearInterval(interval1.value)
      }else{
        // if(importExcelTypeKind.value === 0){
        //   showImportAnimation.value = false
        //   importExcelCount.value.count = 20
        //   importAnimationText.value = ''
        // }else if(importExcelTypeKind.value === 1){
          showImportAnimationMaterial.value = false
          importExcelCount.value.count = 20
          importAnimationText.value = ''
        // }
        clearInterval(checkInterval)
        clearInterval(interval1.value)
        // showError(res.message || '导入失败，请检查表格是否符合规范')
      }
    } catch (err) {
      console.error('检查导入状态失败:', err)
      showError(err.message || '导入失败，请检查表格是否符合规范')
      // 如果检查失败，继续等待，不隐藏动画
    }
  }, 5000)
}

// 复制产品物料搜索
const handleCopyProductMaterialSearch = async () => {
  if (!copyProductMaterialSearchKeyword.value) {
    copyProductMaterialList.value = []
    isSimilarImage.value = true
    return
  }
  copyProductMaterialPage.value = 1
  copyProductMaterialHasMore.value = true
  copyProductMaterialLoadingMore.value = false
  copyProductMaterialList.value = []
  await loadCopyProductMaterialList()
}

// 加载复制产品物料列表
const loadCopyProductMaterialList = async () => {
  isSimilarImage.value = false
  if (copyProductMaterialLoadingMore.value || !copyProductMaterialHasMore.value || !copyProductMaterialSearchKeyword.value) return
  const res = await contractApi.searchProduct({ 
    page: copyProductMaterialPage.value, 
    pageSize: copyProductMaterialPageSize.value,
    keyword: copyProductMaterialSearchKeyword.value
  })
  if (res?.code === 0) {
    const newRecords = res.data.records || []
    if (copyProductMaterialPage.value === 1) {
      console.log('newRecords', newRecords)
      copyProductMaterialList.value = newRecords
    } else {
      copyProductMaterialList.value = [...copyProductMaterialList.value, ...newRecords]
    }
    copyProductMaterialHasMore.value = newRecords.length === copyProductMaterialPageSize.value
    if (copyProductMaterialHasMore.value) {
      copyProductMaterialPage.value++
    }
  }
  copyProductMaterialLoadingMore.value = false
}

// 显示物料选择对话框
const showMaterialSuggestions = (index: number) => {
  addResultContent.value = ''
  addResultErrorContent.value = ''
  currentMaterialIndex.value = index
  showMaterialDialog.value = true
  searchKeyword.value = ''
  page.value = 1
  hasMore.value = true
  materialOptions.value = []
  loadMaterialList()
}

// 处理物料搜索
const handleSearch = async () => {
  addResultContent.value = ''
  addResultErrorContent.value = ''
  if (!searchKeyword.value) {
    materialOptions.value = []
    return
  }
  page.value = 1
  hasMore.value = true
  loadingMore.value = false
  materialOptions.value = []
  await loadMaterialList()
}

// 加载物料列表
const loadMaterialList = async () => {
  if (loadingMore.value || !hasMore.value || !searchKeyword.value) return
  
  try {
    loadingMore.value = true
    const res = await contractApi.getProjectTypeList({ 
      page: page.value, 
      pageSize: pageSize.value,
      keyword: searchKeyword.value
    })
    if (res?.code === 0) {
      const newRecords = res.data.records || []
      if (page.value === 1) {
        materialOptions.value = newRecords
      } else {
        materialOptions.value = [...materialOptions.value, ...newRecords]
      }
      hasMore.value = newRecords.length === pageSize.value
      if (hasMore.value) {
        page.value++
      }
    }
  } catch (error) {
    console.error('获取物料列表失败:', error)
  } finally {
    loadingMore.value = false
  }
}

const handleTempMaterialSelect = (materialCode: string) => {
  doAddMaterial.value = true
  showTipDialog.value = false
  if (currentMaterialIndex.value > -1) {
    const selected = materialOptions.value.find(m => m.materialCode === materialCode)
    if (selected) {
      materialList.value[currentMaterialIndex.value].name = selected.materialName
      if (selected.materialCode) {
        materialList.value[currentMaterialIndex.value].code = selected.materialCode
      }
      if (selected.specDesc) {
        materialList.value[currentMaterialIndex.value].specification = selected.specDesc
      }
      if (selected.bigClass) {
        materialList.value[currentMaterialIndex.value].bigClass = selected.bigClass
      }
      if (selected.materialType) {
        materialList.value[currentMaterialIndex.value].type = selected.materialType
      }
      if (selected.materialPrice) {
        materialList.value[currentMaterialIndex.value].price = selected.materialPrice
      }
      if (selected.materialUnit) {
        materialList.value[currentMaterialIndex.value].materialUnit = selected.materialUnit
      }
      if (selected.materialImageUrls) {
        materialList.value[currentMaterialIndex.value].images = JSON.parse(selected.materialImageUrls)
      }
      handleSaveAll('special')
    }
  }
  showMaterialDialog.value = false
  searchKeyword.value = ''
  tempMaterialCode.value = ''
  // 重置分页相关数据
  page.value = 1
  hasMore.value = true
}

const handleSameMaterialSelect = (materialCode: string) => {
  showCtractSameMaterialDialog.value = false
  doAddSameMaterial.value = true
  if (currentMaterialIndex.value > -1) {
    const selected = materialOptions.value.find(m => m.materialCode === materialCode)
    if (selected) {
      materialList.value[currentMaterialIndex.value].name = selected.materialName
      if (selected.materialCode) {
        materialList.value[currentMaterialIndex.value].code = selected.materialCode
      }
      if (selected.specDesc) {
        materialList.value[currentMaterialIndex.value].specification = selected.specDesc
      }
      if (selected.bigClass) {
        materialList.value[currentMaterialIndex.value].bigClass = selected.bigClass
      }
      if (selected.materialType) {
        materialList.value[currentMaterialIndex.value].type = selected.materialType
      }
      materialList.value[currentMaterialIndex.value].price = tempPrice.value
      if (selected.materialUnit) {
        materialList.value[currentMaterialIndex.value].materialUnit = selected.materialUnit
      }
      if (selected.materialImageUrls) {
        materialList.value[currentMaterialIndex.value].images = JSON.parse(selected.materialImageUrls)
      }
      handleSaveAll('special')
    }
  }
  showMaterialDialog.value = false
  searchKeyword.value = ''
  tempMaterialCode.value = ''
  // 重置分页相关数据
  page.value = 1
  hasMore.value = true
}

const handleCopyProductMaterialSee = async (productId: string) => {
  showPreviewProductMaterialDialog.value = true
  previewProductMaterial.value = {}
  try{
    const res = await contractApi.getProductDetailWithMaterial(Number(productId))
    if(res?.code === 0){
      previewProductMaterial.value = res.data
    }
  }catch(error){
    console.error('获取产品物料失败:', error)
  }
}

// 处理复制产品物料选择
const handleCopyProductMaterialSelect = async (productId: string) => {
  console.log('复制产品物料选择', productId)
  
  // 立即关闭弹窗
  showCopyProductMaterialDialog.value = false
  copyProductMaterialList.value = []
  copyProductMaterialPage.value = 1
  copyProductMaterialHasMore.value = true
  copyProductMaterialLoadingMore.value = false
  copyProductMaterialSearchKeyword.value = ''
  
  // 异步执行复制操作
  try {
    const res = await contractApi.copyProductMaterial({
      fromProductOrderItemId: Number(productId),
      toProductOrderItemId: Number(route.query.productCode)
    })
    
    if(res?.code === 0){
      showSuccess('复制物料清单成功')
      loadProductDetail()
      if(materialList.value.length === pagination.value.pageSize && pagination.value.page === pagination.value.total / pagination.value.pageSize){
        pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize) + 1
      }else{
        pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize)
      }
      loadProductMaterialList()
    }else{
      showError(res?.message)
      console.log('复制物料清单失败', res)
    }
  } catch (error) {
    showError('复制物料清单失败')
    console.error('复制物料清单失败:', error)
  }
}

// 处理物料选择
const handleMaterialSelect = async (material: any) => {
  addResultContent.value = ''
  addResultErrorContent.value = ''
  tempMaterialCode.value = material.materialCode
  const selected = material
  // const selected = materialOptions.value.find(m => m.materialCode === material.materialCode)
  // try{
  //   const res = await contractApi.getContractMaterialPrice({
  //     materialCode: chooseMaterialCode,
  //     contractId: Number(contractId.value)
  //   })
  //   if(res?.code === 0){
  //     const data = res?.data
      // if(data && data !== selected.materialPrice){
      //   tempPrice.value = data
      //   showCtractSameMaterialDialog.value = true
      //   doAddSameMaterial.value = false
      // }else{
        showCtractSameMaterialDialog.value = false
        doAddSameMaterial.value = true
      // }
  //   }
  // }catch(error){
  //   console.error('获取物料价格失败:', error)
  // }

  // 根据name、specification、price 名称 规格 价格判断是否存在相同的物料
  // const existingIndex = materialList.value.findIndex(item => 
  //   item.name === selected.materialName && item.specification === selected.specDesc && item.price === selected.materialPrice
  // )
  // console.log('existingIndex', existingIndex)

  // if(existingIndex === -1){
    doAddMaterial.value = true
  // }else{
  //   showTipDialog.value = true
  //   doAddMaterial.value = false
  // }
  if (currentMaterialIndex.value > -1 && doAddMaterial.value && doAddSameMaterial.value) {
    // const selected = materialOptions.value.find(m => m.materialCode === chooseMaterialCode)
    if (selected) {
      materialList.value[currentMaterialIndex.value].name = selected.materialName
      if (selected.materialCode) {
        materialList.value[currentMaterialIndex.value].code = selected.materialCode
      }else{
        materialList.value[currentMaterialIndex.value].code = ''
      }
      if (selected.specDesc) {
        materialList.value[currentMaterialIndex.value].specification = selected.specDesc
      }else{
        materialList.value[currentMaterialIndex.value].specification = ''
      }
      if (selected.bigClass) {
        materialList.value[currentMaterialIndex.value].bigClass = selected.bigClass
      }else{
        materialList.value[currentMaterialIndex.value].bigClass = ''
      }
      if (selected.materialType) {
        materialList.value[currentMaterialIndex.value].type = selected.materialType
      }else{
        materialList.value[currentMaterialIndex.value].type = ''
      }
      // if(materialList.value[currentMaterialIndex.value].price === 0){
        // materialList.value[currentMaterialIndex.value].price = selected.materialPrice
      // }
      if(materialList.value[currentMaterialIndex.value].images.length === 0 || materialList.value[currentMaterialIndex.value].images === null || materialList.value[currentMaterialIndex.value].images === ''){
        if (selected.materialImageUrls) {
          materialList.value[currentMaterialIndex.value].images = JSON.parse(selected.materialImageUrls)
        }
      }
      if (selected.materialPrice) {
        materialList.value[currentMaterialIndex.value].price = selected.materialPrice
        materialList.value[currentMaterialIndex.value].total = selected.materialPrice * materialList.value[currentMaterialIndex.value].count
      }else{
        materialList.value[currentMaterialIndex.value].price = 0
        materialList.value[currentMaterialIndex.value].total = 0
      }
      if (selected.materialUnit) {
        materialList.value[currentMaterialIndex.value].materialUnit = selected.materialUnit
      }else{
        materialList.value[currentMaterialIndex.value].materialUnit = ''
      }
      // if (selected.materialImageUrls) {
      //   materialList.value[currentMaterialIndex.value].images = JSON.parse(selected.materialImageUrls)
      // }else{
      //   //materialList.value[currentMaterialIndex.value].images = []
      // }
      if(materialList.value[currentMaterialIndex.value].wuliaoId !== selected.id){
        materialList.value[currentMaterialIndex.value].wuliaoId = null
      }
      debouncedAutoSaveMaterial(currentMaterialIndex.value)
      // autoSave()
      // const timer = setTimeout(() => {
      //   const textareas = document.querySelectorAll('textarea')
      //   textareas.forEach(textarea => {
      //     const event = new Event('input')
      //     textarea.dispatchEvent(event)
      //     textarea.style.height = 'auto'
      //     textarea.style.height = textarea.scrollHeight + 'px'
      //   })
      //   clearTimeout(timer)
      // }, 100)
    }
  }
  showMaterialDialog.value = false
  searchKeyword.value = ''
  // 重置分页相关数据
  page.value = 1
  hasMore.value = true
}

// 增加自定义物料
const handleAddMaterial = (keyword: string) => {
  showMaterialDialog.value = false

  addResultContent.value = ''
  addResultErrorContent.value = ''
  showAddCustomMaterialDialog.value = true
  customMaterialName.value = ''
  customMaterialSpecDesc.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
}

// 添加物料到物料库
const handleAddMaterialToBank = async () => {
  if(customMaterialName.value == '' || customMaterialName.value == null){
    showError('物料名称不能为空')
    return
  }
  if(customMaterialBigClass.value == '' || customMaterialBigClass.value == null){
    showError('大类不能为空')
    return
  }
  if(customMaterialType.value == '' || customMaterialType.value == null){
    showError('小类不能为空')
    return
  }
  materialList.value[currentMaterialIndex.value].name = customMaterialName.value
  materialList.value[currentMaterialIndex.value].specification = customMaterialSpecDesc.value
  materialList.value[currentMaterialIndex.value].bigClass = customMaterialBigClass.value
  materialList.value[currentMaterialIndex.value].type = customMaterialType.value
  // materialList.value[currentMaterialIndex.value].price = customMaterialPrice.value
  materialList.value[currentMaterialIndex.value].price = 0
  materialList.value[currentMaterialIndex.value].code = ''
  materialList.value[currentMaterialIndex.value].wuliaoId = null
  materialList.value[currentMaterialIndex.value].images = customMaterialImageUrls.value
  debouncedAutoSaveMaterial(currentMaterialIndex.value)
  // try{
  //   const res = await contractApi.addPresetMaterial({
  //     materialName: customMaterialName.value,
  //     specDesc: customMaterialSpecDesc.value,
  //     bigClass: customMaterialBigClass.value,
  //     materialType: customMaterialType.value,
  //     materialPrice: customMaterialPrice.value,
  //     materialImageUrls: customMaterialImageUrls.value.length > 0 ? JSON.stringify(customMaterialImageUrls.value) : ''
  //   })
  //   if(res?.code === 0){
  //     addResultContent.value = '添加物料成功'
  //     addResultErrorContent.value = ''
  //     handleMaterialSelect(res.data)
  //   }else{
  //     addResultContent.value = ''
  //     addResultErrorContent.value = res?.message
  //   }
  // }catch(error){
  //   console.error('添加物料失败:', error)
  //   addResultContent.value = ''
  //   addResultErrorContent.value = error.message || error.msg
  // }
  showAddCustomMaterialDialog.value = false
  searchKeyword.value = ''
  // 重置分页相关数据
  page.value = 1
  hasMore.value = true
}

// 使用输入作为物料名称
const handleUseInputAsMaterial = () => {
  if(customMaterialName.value == '' || customMaterialName.value == null){
    showError('物料名称不能为空')
    return
  }
  if(customMaterialBigClass.value == '' || customMaterialBigClass.value == null){
    showError('大类不能为空')
    return
  }
  if(customMaterialType.value == '' || customMaterialType.value == null){
    showError('小类不能为空')
    return
  }
  if (currentMaterialIndex.value > -1) {
    materialList.value[currentMaterialIndex.value].name = customMaterialName.value
    materialList.value[currentMaterialIndex.value].specification = customMaterialSpecDesc.value
    materialList.value[currentMaterialIndex.value].bigClass = customMaterialBigClass.value
    materialList.value[currentMaterialIndex.value].type = customMaterialType.value
    materialList.value[currentMaterialIndex.value].price = customMaterialPrice.value
    materialList.value[currentMaterialIndex.value].code = ''
    materialList.value[currentMaterialIndex.value].wuliaoId = null
    materialList.value[currentMaterialIndex.value].images = customMaterialImageUrls.value
  }
  showAddCustomMaterialDialog.value = false
  showMaterialDialog.value = false
  searchKeyword.value = ''
  // 重置分页相关数据
  page.value = 1
  hasMore.value = true
}

// 复制产品物料滚动
const handleCopyProductMaterialScroll = (event: Event) => {
  const target = event.target as HTMLElement
  const { scrollTop, scrollHeight, clientHeight } = target
  if (scrollHeight - scrollTop - clientHeight < 20) {
    loadCopyProductMaterialList()
  }
}

// 添加滚动处理方法
const handleScroll = (event: Event) => {
  const target = event.target as HTMLElement
  const { scrollTop, scrollHeight, clientHeight } = target
  // 当滚动到距离底部20px时加载更多
  if (scrollHeight - scrollTop - clientHeight < 20) {
    loadMaterialList()
  }
}

// 添加预览相关的状态变量
const showPreview = ref(false)
const previewImage = ref<string[]>([])
const selectedIndex = ref(0)
const currentMaterialIndex = ref(0)
const isDelete = ref(false)

// 添加预览图片的方法
// const handleProductImagePreview = (image: { url: string; name: string }) => {
//   previewImage.value = image.url
//   showPreview.value = true
// }

// 关闭预览
const handleClosePreview = () => {
  showPreview.value = false
  previewImage.value = []
  currentMaterialIndex.value = 0
  selectedIndex.value = 0
}

// 删除物料图
const handleDeleteImage = (currentMaterialIndex: number, index: number) => {
  console.log('currentMaterialIndex', currentMaterialIndex,index)
  // 处理删除逻辑
  materialList.value[currentMaterialIndex].images.splice(index, 1)
  zoomMaterialOut(currentMaterialIndex)
  updateMaterialImageIndex(currentMaterialIndex, 0)
  // 如果删除的是当前选中的图片，需要调整selectedIndex
  if (index <= selectedIndex.value && selectedIndex.value > 0) {
    selectedIndex.value--
  }
}

// 处理物料图片预览
const handleMaterialImagePreview = (images: { url: string; name: string }[], materialIndex: number, index: number, canDelete: boolean) => {
  console.log('images', images, materialIndex, index, canDelete)
  const urls = images.map(image => image.url)
  previewImage.value = urls
  showPreview.value = true
  currentMaterialIndex.value = materialIndex
  selectedIndex.value = index
  isDelete.value = canDelete
}

// 在 script setup 部分添加 handleTextareaInput 方法
const handleTextareaInput = (event: Event, index: number) => {
  const target = event.target as HTMLTextAreaElement
  target.style.height = 'auto'
  target.style.height = target.scrollHeight + 'px'
  // editMaterialIndex.value = index
  debouncedAutoSaveMaterial(index)
}

const filteredMaterialList = computed(() => {
  console.log('searchKeyword', searchKeyword.value,materialOptions.value)
  if (!searchKeyword.value) return materialOptions.value
  
  const keyword = searchKeyword.value.toLowerCase()
  return materialOptions.value.filter(material => {
    try {
      // 检查物料名称（必填字段）
      const nameMatch = material.materialName.toLowerCase().includes(keyword)
      
      // 检查可选字段
      const codeMatch = material.materialCode?.toLowerCase().includes(keyword) || false
      const specMatch = material.specDesc?.toLowerCase().includes(keyword) || false
      const typeMatch = material.materialType?.toLowerCase().includes(keyword) || false
      const priceMatch = material.materialPrice?.toString().includes(keyword) || false
      
      // 检查图片URL
      let imageMatch = false
      if (material.materialImageUrls) {
        const imageUrls = JSON.parse(material.materialImageUrls)
        imageMatch = Array.isArray(imageUrls) && imageUrls.some(img => 
          img.url?.toLowerCase().includes(keyword) || 
          img.name?.toLowerCase().includes(keyword)
        )
      }
      
      return nameMatch || codeMatch || specMatch || typeMatch || priceMatch || imageMatch
    } catch (error) {
      console.error('过滤物料时出错:', error)
      return false
    }
  })
})

// 在script setup部分添加相关变量和方法
const fileInputs = ref<{ [key: number]: HTMLInputElement }>({})
const uploadLoading = ref(false)
const uploadProgress = ref(0)

// 获取图片预览URL
const getImagePreviewUrl = (file: string | File | { url: string; name: string }) => {
  if (!file) return ''
  try {
    if (typeof file === 'string') {
      return file
    }
    if (file instanceof File) {
      return URL.createObjectURL(file)
    }
    return file.url
  } catch (error) {
    console.error('创建图片预览URL失败:', error)
    return ''
  }
}

// 处理物料图片上传（来自MaterialImagePreview组件）
const handleMaterialImageUpload = async (parentIndex: number, imageIndex: number) => {
  // 这里可以处理来自 MaterialImagePreview 组件的上传事件
  console.log('物料图片上传事件:', parentIndex, imageIndex)
  // 可以在这里打开上传对话框或触发文件选择
  // 暂时使用现有的上传逻辑
  showMaterialUploadDialog.value = true
  currentUploadMaterialIndex.value = parentIndex
}

// 处理物料图片上传成功
const handleMaterialUploadSuccess = (urls: string[], parentIndex: number) => {
  // 这里可以处理上传成功后的逻辑
  console.log('物料图片上传成功:', urls, parentIndex)
  
  // 更新对应物料的图片列表
  if (materialList.value[parentIndex]) {
    materialList.value[parentIndex].images = materialList.value[parentIndex].images || []
    const newImages = urls.map((url, i) => ({
      url,
      name: `物料图_${Date.now()}_${i}`
    }))
    materialList.value[parentIndex].images.push(...newImages)
  }
  // editMaterialIndex.value = parentIndex
  debouncedAutoSaveMaterial(parentIndex)
  showSuccess('图片上传成功')
  showMaterialUploadDialog.value = false
  currentUploadMaterialIndex.value = -1
}

// 处理物料图片文件上传（原有方法，用于文件input）
const handleMaterialImageFileUpload = async (event: Event, index: number) => {
  const input = event.target as HTMLInputElement
  if (input?.files && input.files.length > 0) {
    try {
      const files = Array.from(input.files)
      // 只取第一张图片
      // const file = input.files[0]
      uploadLoading.value = true
      uploadProgress.value = 0

      // 使用uploadApi上传文件
      const urls = await uploadApi.uploadFiles(
        files,
        // [file],  // 单张
        (progress) => {
          uploadProgress.value = progress
        }
      )

      if (materialList.value[index]) {
        materialList.value[index].images = materialList.value[index].images || []
        const newImages = urls.map((url, i) => ({
          url,
          name: files[i].name
        }))
        materialList.value[index].images.push(...newImages)
      }


      // 更新物料图片列表,只保留一张图片
      // if (materialList.value[index]) {
      //   // 保持原有的数据结构,但只保留一张图片
      //   materialList.value[index].images = [{
      //     url: urls[0],
      //     name: files[0].name
      //   }]
      // }
      showSuccess('图片上传成功')
    } catch (error: any) {
      console.error('处理图片上传失败:', error)
      showError(error.message || '图片上传失败')
    } finally {
      uploadLoading.value = false
      // 清空input的value，这样相同文件可以重复选择
      input.value = ''
    }
  }
}

// 删除物料图片
const removeMaterialImage = (materialIndex: number, imageIndex: number) => {
  try {
    if (materialList.value[materialIndex]?.images?.[imageIndex]) {
      const image = materialList.value[materialIndex].images![imageIndex]
      if (typeof image === 'string') {
        // 如果是URL字符串，直接删除
        materialList.value[materialIndex].images!.splice(imageIndex, 1)
      } else if (image instanceof File) {
        // 如果是File对象，需要释放URL
        const url = getImagePreviewUrl(image)
        if (url) {
          URL.revokeObjectURL(url)
        }
        materialList.value[materialIndex].images!.splice(imageIndex, 1)
      } else {
        // 如果是JSON对象，直接删除
        materialList.value[materialIndex].images!.splice(imageIndex, 1)
      }
    }
  } catch (error) {
    console.error('删除图片失败:', error)
  }
}

// 引用汇总
const correlateMaterialItem = async () => {
  showCorrelateDialog.value = true
  isUseCorrelateMaterial.value = false
  loadCorrelateMaterial()
}

const loadCorrelateMaterial = async () => {
  const res = await contractApi.getWuliaoList({
    id: Number(contractId.value),
    orderBy: 'materialName',
    sort: 'desc',
    page: 1,
    pageSize:1000
  })
  if (res && (res as any).code === 0) {
    // 直接处理数据并赋值
    const rawList = (res as any).data.list || []
    
    // 过滤掉 materialList 中已存在的材料（根据名称、规格和价格判断）
    // 只过滤未删除的物料，已删除（划线）的物料可以再次引用
    const filteredList = rawList.filter((wuliao: any) => {
      return !materialList.value.some(material => {
        // 标准化字符串：null、undefined、空字符串都视为空字符串
        const normalizeString = (str: any) => {
          return str == null || str === '' ? '' : String(str).trim()
        }
        
        // 标准化价格：0、null、undefined、空字符串都视为0
        const normalizePrice = (price: any) => {
          return price == null || price === '' || price === 0 ? 0 : Number(price)
        }
        
        return normalizeString(material.name) === normalizeString(wuliao.materialName) && 
          normalizeString(material.specification) === normalizeString(wuliao.specDesc) && 
          normalizePrice(material.price) === normalizePrice(wuliao.materialPrice) &&
          Number(material.isDelete) !== 1  // 只过滤未删除的物料
      })
    })
    
    correlateMaterialList.value = filteredList.map((wuliao: any) => ({
      wuliaoId: wuliao.id,
      materialType: wuliao.materialType,
      bigClass: wuliao.bigClass,
      materialName: wuliao.materialName,
      materialCode: wuliao.materialCode,
      specDesc: wuliao.specDesc,
      materialPrice: wuliao.materialPrice,  
      materialTotal: wuliao.materialTotal || 0,
      materialCount: wuliao.materialCount || 0,
      materialPriceConfirmed: wuliao.materialPriceConfirmed,
      wuliaoStatus: Number(wuliao.wuliaoStatus),
      materialImageUrls: wuliao.materialImageUrls ? JSON.parse(wuliao.materialImageUrls) : [],
      materialImageUrlsConfirmed: wuliao.wuliaoItem?.materialImageUrls ? JSON.parse(wuliao.wuliaoItem.materialImageUrls) : [],
      wuliaoName: wuliao.wuliaoItem?.wuliaoName || '',
      wuliaoRemark: wuliao.wuliaoItem?.wuliaoRemark || '',
      materialNameConfirmed: wuliao.materialNameConfirmed || '',
      materialTypeConfirmed: wuliao.materialTypeConfirmed || '',
      createTime: wuliao.wuliaoItem?.createTime || '',
      wuliaoItem: wuliao.wuliaoItem || {},
      salesmanRemark: wuliao.salesmanRemark || '',
      materialDescription: wuliao.materialDescription || '',
      // supplier: wuliao.supplier || '',
      salesmanReviewStatus: wuliao.wuliaoItem?.salesmanReviewStatus || 0,
      isSelected: false, // 添加选中状态
      materialUnit: wuliao.materialUnit || '' // 添加物料单位
    }))
    console.log('引用汇总列表数据:', correlateMaterialList.value)
  } else {
    console.error('获取引用汇总列表失败:', res)
    correlateMaterialList.value = []
  }
  await nextTick()
  const textareas = document.querySelectorAll('textarea')
  textareas.forEach(textarea => {
    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  })
}

const handleCorrelateMaterialCancel = () => {
  showCorrelateDialog.value = false
  isUseCorrelateMaterial.value = false
  correlateMaterialList.value.forEach(material => {
    material.isSelected = false
  })
}

// 处理引用汇总选择
const handleCorrelateMaterial = async (selectedMaterials: CorrelateMaterialItem[]) => {
  // 获取选中的物料
  const selectedItems = selectedMaterials.filter(material => material.isSelected)
  
  if (selectedItems.length === 0) {
    showError('请至少选择一个物料')
    return
  }
  isUseCorrelateMaterial.value = true
  let addedCount = 0
  let updatedCount = 0
  
  // 将选中的物料添加到物料清单中
  
  for (const material of selectedItems) {
    const newMaterialItem: MaterialItem = {
      wuliaoId: material.wuliaoId || null,
      id: null,
      bigClass: material.bigClass || '',
      name: material.materialName || '',
      code: material.materialCode || '',
      specification: material.specDesc || '',
      salesmanRemark: material.salesmanRemark || '',
      materialDescription: material.materialDescription || '',
      // supplier: material.supplier || '',
      type: material.materialType || '',
      image: null,
      price: material.materialPrice || 0,
      count: 0,
      total: 0,
      // total: material.materialTotal || 0,
      materialUnit: material.materialUnit || '', // 从引用汇总中获取单位
      images: material.materialImageUrls || []
    }
    
    // 检查是否已存在相同的物料（根据名称、规格和价格判断）
    const existingIndex = materialList.value.findIndex(item => 
      item.name === newMaterialItem.name && item.specification === newMaterialItem.specification && item.price === newMaterialItem.price
    )
    // console.log(existingIndex)
    // if (existingIndex === -1) {
    //   // 如果不存在，则添加新物料
      materialList.value.push(newMaterialItem)
      // addedCount++
      // continue
    // } else {
    //   // 如果已存在，则更新现有物料的信息
    //   const existingItem = materialList.value[existingIndex]
    //   existingItem.specification = newMaterialItem.specification
    //   existingItem.name = newMaterialItem.name
    //   existingItem.salesmanRemark = newMaterialItem.salesmanRemark
    //   existingItem.materialDescription = newMaterialItem.materialDescription
    //   // existingItem.supplier = newMaterialItem.supplier
    //   existingItem.type = newMaterialItem.type
    //   existingItem.price = newMaterialItem.price
    //   existingItem.count = 0
    //   existingItem.total = newMaterialItem.total
    //   existingItem.images = newMaterialItem.images
    //   updatedCount++
    // }
  }
  
  // 关闭对话框
  showCorrelateDialog.value = false
  isUseCorrelateMaterial.value = false
  correlateMaterialList.value.forEach(material => {
    material.isSelected = false
  })
  // 显示成功消息
  // let message = ''
  // if (addedCount > 0 && updatedCount > 0) {
  //   message = `成功添加 ${addedCount} 个新物料，更新 ${updatedCount} 个现有物料`
  // } else if (addedCount > 0) {
  //   message = `成功添加 ${addedCount} 个物料到清单`
  // } else if (updatedCount > 0) {
  //   message = `成功更新 ${updatedCount} 个物料信息`
  // }
  // showSuccess(message)
  
  await nextTick()
  const textareas = document.querySelectorAll('textarea')
  textareas.forEach(textarea => {
    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  })
  // 自动保存
  handleSaveAll('yinyonghuizong')
}

// 保存物料
const handleSaveMaterial = async (index: number) => {
  console.log('保存物料', materialList.value[index],index)
  try {
    loading.value = true
    let submitData = {
      id: productInfo.value.id,
      materialList: [{
        wuliaoId: materialList.value[index].wuliaoId || '',
        bigClass: materialList.value[index].bigClass || '',
        id: materialList.value[index].id || '',
        materialName: materialList.value[index].name,
        materialCode: materialList.value[index].code,
        specDesc: materialList.value[index].specification,
        salesmanRemark: materialList.value[index].salesmanRemark,
        materialDescription: materialList.value[index].materialDescription,
        // supplier: materialList.value[editMaterialIndex.value].supplier,
        materialType: materialList.value[index].type,
        materialImageUrls: materialList.value[index].images ? JSON.stringify(materialList.value[index].images) : '',
        materialPrice: materialList.value[index].price,
        count: materialList.value[index].count,
        materialTotal: materialList.value[index].total,
        materialUnit: materialList.value[index].materialUnit,
        materialCustomerNo: materialList.value[index].materialCustomerNo
      }]
    }
    
    if(isEdit.value === 'estimate'){
      submitData.pricingStatus = productInfo.value.pricingStatus ? 3 : 2
    }
    // else{
    //   submitData.pricingStatus = 0
    // }
    const res = await contractApi.updateProductMaterial(submitData)
    if (res.code === 0) {
      var tempData = res?.data?.materialList
      for(var i = 0; i < tempData.length; i++){
        materialList.value[index].id = tempData[i].id
      }
      loadTempProductDetail()
      // var tempPriceData = res.data.materialSummary
      // productInfo.value.materialSummary = tempPriceData
      // 自动保存时不显示消息
    } else {
      showError(res?.message || '保存失败')
    }
  } catch (error: any) {
    console.error('保存失败:', error)
    showError(error.message || '保存失败')
  } finally {
    loading.value = false
  }
}
// 保存
const handleSaveAll = async (message: string = '') => {
  if (!form.value.validate()) return
  try {
    loading.value = true
    let submitData = {
      code: productInfo.value.code,
      // pricingFinish: productInfo.value.pricingFinish ? 1 : 0,
      id: productInfo.value.id,
      syscode: productInfo.value.syscode,
      name: productInfo.value.name,
      productShortName: productInfo.value.productShortName,
      shortName: productInfo.value.shortName,
      productDescription: productInfo.value.productDescription,
      width: productInfo.value.width,
      depth: productInfo.value.depth,
      height: productInfo.value.height,
      count: productInfo.value.count,
      remark: productInfo.value.remark,
      productImageUrls: JSON.stringify(productInfo.value.productImageUrls),
      materialList: materialList.value.map(item => ({
        wuliaoId: item.wuliaoId || null,
        bigClass: item.bigClass || '',
        id: item.id || null,
        materialName: item.name,
        materialCode: item.code,
        specDesc: item.specification,
        salesmanRemark: item.salesmanRemark,
        materialDescription: item.materialDescription,
        // supplier: item.supplier,
        materialType: item.type,
        materialImageUrls: item.images ? JSON.stringify(item.images) : '',
        materialPrice: item.price,
        count: item.count,
        materialTotal: item.total,
        materialUnit: item.materialUnit,
        materialCustomerNo: item.materialCustomerNo
      }))
    }
    
    if(isEdit.value === 'estimate'){
      submitData.pricingStatus = productInfo.value.pricingStatus ? 3 : 2
    }
    // else{
    //   submitData.pricingStatus = 0
    // }
    const res = await contractApi.updateProductMaterial(submitData)
    if (res.code === 0 && res?.data && res?.data?.materialList && res?.data?.materialList.length > 0) {
      if(message === 'noMsg'){
        var tempData = res?.data?.materialList
          for(var i = 0; i < tempData.length; i++){
            materialList.value[i].id = tempData[i].id
            console.log(materialList.value)
          }
          loadTempProductDetail()
        // var tempPriceData = res.data.materialSummary
        // productInfo.value.materialSummary = tempPriceData
        // 自动保存时不显示消息
      } else if(message === 'special'){
        loadProductDetail()
      } else if(message === 'yinyonghuizong'){
        isUseCorrelateMaterial.value = false
        loadTempProductDetail()
        if(materialList.value.length === pagination.value.pageSize && pagination.value.page === pagination.value.total / pagination.value.pageSize){
          pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize) + 1
        }else{
          pagination.value.page = Math.ceil(pagination.value.total / pagination.value.pageSize)
        }
        loadProductMaterialList()
      } else if(message === '物料移除成功'){
        showSuccess('物料移除成功')
        loadTempProductDetail()
      } else if(message === '物料删除成功'){

      }else{
        // loadProductDetail()
        // showSuccess(message)
      }
    } else {
      // showError('保存失败')
    }
  } catch (error: any) {
    console.error('保存失败:', error)
    showError(error.message || '保存失败')
  } finally {
    loading.value = false
  }
}

// 添加全选功能和选择计数
const isAllSelected = ref(false)
const updateSelectCount = () => {
  isAllSelected.value = correlateMaterialList.value.every(material => material.isSelected)
}

// 取消全选
const toggleSelectAll = () => {
  isAllSelected.value = !isAllSelected.value
  correlateMaterialList.value.forEach(material => {
    material.isSelected = isAllSelected.value
  })
}

// 计算提示对话框
const showCalculateDialog = ref(false)
const calculateDialogTitle = ref('')
const currentFormula = ref('')
const currentCalculateType = ref('') // 添加当前计算类型
const calculateVariables = ref<{
  freightFeeWAdd: number
  freightFeeDAdd: number
  freightFeeHAdd: number
  freightFeeTax: number
  laborFeeTax: number
  laborFeeAdd: number
  manufacturingFeeTax: number
  manufacturingFeeAdd: number
  difference: number
  smallHardware: number
  glass: number
  stone: number
  fabric: number
  purchaseParts: number
  bigHardwareFee: number
  profitTax: number
  profitAdd: number
  taxFeeTax: number
  adjustment: number
  baseMaterial: number
  paintMaterial: number
}>({
  freightFeeWAdd: 50,
  freightFeeDAdd: 50,
  freightFeeHAdd: 50,
  freightFeeTax: 120,
  laborFeeTax: 0.35,
  laborFeeAdd: 50,
  manufacturingFeeTax: 0.08,
  manufacturingFeeAdd: 0,
  profitTax: 0.2,
  profitAdd: 0,
  taxFeeTax: 0.13,
  adjustment: 1, // 添加调整系数
  baseMaterial: 0,
  paintMaterial: 0,
})
const calculatedResult = ref(0)
const showBaseMaterial = ref(false)
const showPaintMaterial = ref(false)
const showLaborFeeTax = ref(false)
const showLaborFeeAdd = ref(false)
const showAdjustmentCoefficient = ref(false)
// 应用计算结果
const applyCalculation = () => {
  // 根据当前计算类型应用结果到对应字段 基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金+运费+安装费+人工+制费+利润+税费
  switch (currentCalculateType.value) {
    case 'freightFee':
      productInfo.value.materialSummary.freightFee = calculatedResult.value
      productInfo.value.materialSummary.cost = (Number(productInfo.value.materialSummary.base) || 0) + (Number(productInfo.value.materialSummary.paint) || 0) + (Number(productInfo.value.materialSummary.difference) || 0) + (Number(productInfo.value.materialSummary.smallHardware) || 0) + (Number(productInfo.value.materialSummary.glass) || 0) + (Number(productInfo.value.materialSummary.stone) || 0) + (Number(productInfo.value.materialSummary.fabric) || 0) + (Number(productInfo.value.materialSummary.purchaseParts) || 0) + (Number(productInfo.value.materialSummary.bigHardwareFee) || 0) + (Number(productInfo.value.materialSummary.freightFee) || 0) + (Number(productInfo.value.materialSummary.installationFee) || 0) + (Number(productInfo.value.materialSummary.laborFee) || 0) + (Number(productInfo.value.materialSummary.manufacturingFee) || 0) + (Number(productInfo.value.materialSummary.profit) || 0) + (Number(productInfo.value.materialSummary.taxFee) || 0)
      updateProductMaterialSummary()
      break
    case 'laborFee':
      productInfo.value.materialSummary.laborFee = calculatedResult.value
      productInfo.value.materialSummary.cost = (Number(productInfo.value.materialSummary.base) || 0) + (Number(productInfo.value.materialSummary.paint) || 0) + (Number(productInfo.value.materialSummary.difference) || 0) + (Number(productInfo.value.materialSummary.smallHardware) || 0) + (Number(productInfo.value.materialSummary.glass) || 0) + (Number(productInfo.value.materialSummary.stone) || 0) + (Number(productInfo.value.materialSummary.fabric) || 0) + (Number(productInfo.value.materialSummary.purchaseParts) || 0) + (Number(productInfo.value.materialSummary.bigHardwareFee) || 0) + (Number(productInfo.value.materialSummary.freightFee) || 0) + (Number(productInfo.value.materialSummary.installationFee) || 0) + (Number(productInfo.value.materialSummary.laborFee) || 0) + (Number(productInfo.value.materialSummary.manufacturingFee) || 0) + (Number(productInfo.value.materialSummary.profit) || 0) + (Number(productInfo.value.materialSummary.taxFee) || 0)
      updateProductMaterialSummary()
      break
    case 'manufacturingFee':
      productInfo.value.materialSummary.manufacturingFee = calculatedResult.value
      productInfo.value.materialSummary.cost = (Number(productInfo.value.materialSummary.base) || 0) + (Number(productInfo.value.materialSummary.paint) || 0) + (Number(productInfo.value.materialSummary.difference) || 0) + (Number(productInfo.value.materialSummary.smallHardware) || 0) + (Number(productInfo.value.materialSummary.glass) || 0) + (Number(productInfo.value.materialSummary.stone) || 0) + (Number(productInfo.value.materialSummary.fabric) || 0) + (Number(productInfo.value.materialSummary.purchaseParts) || 0) + (Number(productInfo.value.materialSummary.bigHardwareFee) || 0) + (Number(productInfo.value.materialSummary.freightFee) || 0) + (Number(productInfo.value.materialSummary.installationFee) || 0) + (Number(productInfo.value.materialSummary.laborFee) || 0) + (Number(productInfo.value.materialSummary.manufacturingFee) || 0) + (Number(productInfo.value.materialSummary.profit) || 0) + (Number(productInfo.value.materialSummary.taxFee) || 0)
      updateProductMaterialSummary()
      break
    case 'profit':
      productInfo.value.materialSummary.profit = calculatedResult.value
      productInfo.value.materialSummary.cost = (Number(productInfo.value.materialSummary.base) || 0) + (Number(productInfo.value.materialSummary.paint) || 0) + (Number(productInfo.value.materialSummary.difference) || 0) + (Number(productInfo.value.materialSummary.smallHardware) || 0) + (Number(productInfo.value.materialSummary.glass) || 0) + (Number(productInfo.value.materialSummary.stone) || 0) + (Number(productInfo.value.materialSummary.fabric) || 0) + (Number(productInfo.value.materialSummary.purchaseParts) || 0) + (Number(productInfo.value.materialSummary.bigHardwareFee) || 0) + (Number(productInfo.value.materialSummary.freightFee) || 0) + (Number(productInfo.value.materialSummary.installationFee) || 0) + (Number(productInfo.value.materialSummary.laborFee) || 0) + (Number(productInfo.value.materialSummary.manufacturingFee) || 0) + (Number(productInfo.value.materialSummary.profit) || 0) + (Number(productInfo.value.materialSummary.taxFee) || 0)
      updateProductMaterialSummary()
      break
    case 'taxFee':
      productInfo.value.materialSummary.taxFee = calculatedResult.value
      productInfo.value.materialSummary.cost = (Number(productInfo.value.materialSummary.base) || 0) + (Number(productInfo.value.materialSummary.paint) || 0) + (Number(productInfo.value.materialSummary.difference) || 0) + (Number(productInfo.value.materialSummary.smallHardware) || 0) + (Number(productInfo.value.materialSummary.glass) || 0) + (Number(productInfo.value.materialSummary.stone) || 0) + (Number(productInfo.value.materialSummary.fabric) || 0) + (Number(productInfo.value.materialSummary.purchaseParts) || 0) + (Number(productInfo.value.materialSummary.bigHardwareFee) || 0) + (Number(productInfo.value.materialSummary.freightFee) || 0) + (Number(productInfo.value.materialSummary.installationFee) || 0) + (Number(productInfo.value.materialSummary.laborFee) || 0) + (Number(productInfo.value.materialSummary.manufacturingFee) || 0) + (Number(productInfo.value.materialSummary.profit) || 0) + (Number(productInfo.value.materialSummary.taxFee) || 0)
      updateProductMaterialSummary()
      break
    case 'cost':
      productInfo.value.materialSummary.cost = calculatedResult.value
      break
  }
  
  // showSuccess('计算结果已应用')
  showCalculateDialog.value = false
}

// 处理计算提示
const handleCalculateTip = (type: string) => {
  showCalculateDialog.value = true
  currentCalculateType.value = type // 设置当前计算类型
  
  // 根据类型设置不同的公式和变量
  switch (type) {
    case 'freightFee':
      calculateDialogTitle.value = '运费计算'
      currentFormula.value = '(W+W增加)×(D+D增加)×(H+H增加)/1000000000×运费系数'
      showBaseMaterial.value = true
      showPaintMaterial.value = true
      showLaborFeeTax.value = true
      showLaborFeeAdd.value = true
      showAdjustmentCoefficient.value = true
      calculatedResult.value = Number(productInfo.value.materialSummary.freightFee) || 0
      // 设置默认值，强制转换为Number类型
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
      }
      break
    case 'laborFee':
      calculateDialogTitle.value = '人工费计算'
      currentFormula.value = '[(基材+油漆)*人工费率+人工附加费]*调整系数'
      showBaseMaterial.value = true
      showPaintMaterial.value = true
      showLaborFeeTax.value = true
      showLaborFeeAdd.value = false
      showAdjustmentCoefficient.value = false
      calculatedResult.value = Number(productInfo.value.materialSummary.laborFee) || 0
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
      }
      break
    case 'manufacturingFee':
      calculateDialogTitle.value = '制费计算'
      currentFormula.value = '[(基材+油漆)*基材制费率+(差价+小五金+玻璃+石材+面料+外购件+大五金)*辅材制费率]*调整系数'
      showBaseMaterial.value = true
      showPaintMaterial.value = true
      showLaborFeeTax.value = true
      showLaborFeeAdd.value = false
      showAdjustmentCoefficient.value = false
      calculatedResult.value = Number(productInfo.value.materialSummary.manufacturingFee) || 0
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
      }
      break
    case 'profit':
      calculateDialogTitle.value = '利润计算'
      currentFormula.value = '[(基材+油漆)*基材利润率+(差价+小五金+玻璃+石材+面料+外购件+大五金)*利润率]+利润调整值'
      showBaseMaterial.value = true
      showPaintMaterial.value = true
      showLaborFeeTax.value = true
      showLaborFeeAdd.value = false
      showAdjustmentCoefficient.value = false
      calculatedResult.value = Number(productInfo.value.materialSummary.profit) || 0
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
      }
      break
    case 'taxFee':
      calculateDialogTitle.value = '税费计算'
      currentFormula.value = '(基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金+人工+制费+利润)*税率'
      showBaseMaterial.value = true
      showPaintMaterial.value = true
      showLaborFeeTax.value = true
      showLaborFeeAdd.value = false
      showAdjustmentCoefficient.value = false
      calculatedResult.value = Number(productInfo.value.materialSummary.taxFee) || 0
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
        freightFee: Number(productInfo.value.materialSummary.freightFee) || 0,
        installationFee: Number(productInfo.value.materialSummary.installationFee) || 0,
        laborFee: Number(productInfo.value.materialSummary.laborFee) || 0,
        manufacturingFee: Number(productInfo.value.materialSummary.manufacturingFee) || 0,
        profit: Number(productInfo.value.materialSummary.profit) || 0,
        taxFee: Number(productInfo.value.materialSummary.taxFee) || 0,
      }
      break
    case 'cost':
      calculateDialogTitle.value = '成本计算'
      currentFormula.value = '基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金+运费+安装费+人工+制费+利润+税费'
      calculatedResult.value = Number(productInfo.value.materialSummary.cost) || 0
      calculateVariables.value = {
        freightFeeWAdd: Number(productInfo.value.materialSummary.freightFeeWAdd) || 0, 
        freightFeeDAdd: Number(productInfo.value.materialSummary.freightFeeDAdd) || 0,
        freightFeeHAdd: Number(productInfo.value.materialSummary.freightFeeHAdd) || 0,
        freightFeeTax: Number(productInfo.value.materialSummary.freightFeeTax) || 0,
        adjustment: Number(productInfo.value.materialSummary.adjustment) || 1.0, // 默认调整系数
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,  
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
        laborFeeTax: Number(productInfo.value.materialSummary.laborFeeTax) || 0, // 默认人工费率
        laborFeeAdd: Number(productInfo.value.materialSummary.laborFeeAdd) || 0,
        manufacturingFeeTax: Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0,
        manufacturingFeeAdd: Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0,
        profitTax: Number(productInfo.value.materialSummary.profitTax) || 0,
        profitAdd: Number(productInfo.value.materialSummary.profitAdd) || 0,
        taxFeeTax: Number(productInfo.value.materialSummary.taxFeeTax) || 0,
        freightFee: Number(productInfo.value.materialSummary.freightFee) || 0,
        installationFee: Number(productInfo.value.materialSummary.installationFee) || 0,
        laborFee: Number(productInfo.value.materialSummary.laborFee) || 0,
        manufacturingFee: Number(productInfo.value.materialSummary.manufacturingFee) || 0,
        profit: Number(productInfo.value.materialSummary.profit) || 0,
        taxFee: Number(productInfo.value.materialSummary.taxFee) || 0,
      }
      break
    case 'materialTotal':
      calculateDialogTitle.value = '材料成本计算'
      currentFormula.value = '基材+油漆+差价+小五金+玻璃+石材+面料+外购件+大五金'
      calculatedResult.value = Number(productInfo.value.materialSummary.materialTotal) || 0
      calculateVariables.value = {
        baseMaterial: Number(productInfo.value.materialSummary.base) || 0,
        paintMaterial: Number(productInfo.value.materialSummary.paint) || 0,
        difference: Number(productInfo.value.materialSummary.difference) || 0,
        smallHardware: Number(productInfo.value.materialSummary.smallHardware) || 0,
        glass: Number(productInfo.value.materialSummary.glass) || 0,
        stone: Number(productInfo.value.materialSummary.stone) || 0,
        fabric: Number(productInfo.value.materialSummary.fabric) || 0,
        purchaseParts: Number(productInfo.value.materialSummary.purchaseParts) || 0,
        bigHardwareFee: Number(productInfo.value.materialSummary.bigHardwareFee) || 0,
      }
      break
    default:
      calculateDialogTitle.value = '计算提示'
      currentFormula.value = '请选择计算类型'
      showBaseMaterial.value = false
      showPaintMaterial.value = false
      showLaborFeeTax.value = false
      showLaborFeeAdd.value = false
      showAdjustmentCoefficient.value = false
  }
  
  // 计算初始结果
  // calculateResult()
}

// 计算结果显示
const calculateResult = () => {
  const { 
    freightFeeWAdd, freightFeeDAdd, freightFeeHAdd, freightFeeTax, adjustment,
    baseMaterial, paintMaterial, laborFeeTax, laborFeeAdd, difference, smallHardware, glass, stone, fabric, purchaseParts, bigHardwareFee,
    manufacturingFeeTax, manufacturingFeeAdd, profitTax, profitAdd, 
    taxFeeTax } = calculateVariables.value
  
  // 强制转换为Number类型
  const wAdd = Number(freightFeeWAdd) || 0
  const dAdd = Number(freightFeeDAdd) || 0
  const hAdd = Number(freightFeeHAdd) || 0
  const freightTax = Number(freightFeeTax) || 0
  const adj = Number(adjustment) || 1
  const base = Number(baseMaterial) || 0
  const paint = Number(paintMaterial) || 0
  const laborTax = Number(laborFeeTax) || 0
  const laborAdd = Number(laborFeeAdd) || 0
  const diff = Number(difference) || 0
  const small = Number(smallHardware) || 0
  const gls = Number(glass) || 0
  const stn = Number(stone) || 0
  const fbr = Number(fabric) || 0
  const purchase = Number(purchaseParts) || 0
  const bigHardware = Number(bigHardwareFee) || 0
  const manuTax = Number(manufacturingFeeTax) || 0
  const manuAdd = Number(manufacturingFeeAdd) || 0
  const profitTaxRate = Number(profitTax) || 0
  const profitAddRate = Number(profitAdd) || 0
  const taxRate = Number(taxFeeTax) || 0
  
  // 根据当前显示的计算类型计算结果
  if (currentCalculateType.value === 'freightFee') {
    // 运费计算
    const width = Number(productInfo.value.width) || 0
    const depth = Number(productInfo.value.depth) || 0
    const height = Number(productInfo.value.height) || 0    
    calculatedResult.value = (width + wAdd) * (depth + dAdd) * (height + hAdd) / 1000000000 * freightTax * adj
    console.log('运费计算结果:',typeof(width), depth, height, typeof(wAdd), dAdd, hAdd, freightTax, adj, (width + wAdd) * (depth + dAdd) * (height + hAdd) / 1000000000 * freightTax * adj,calculatedResult.value)
  } else if (currentCalculateType.value === 'laborFee') {
    // 人工费计算
    calculatedResult.value = ((base + paint) * laborTax + laborAdd) * adj
    console.log('人工费计算结果:', calculatedResult.value)
  } else if (currentCalculateType.value === 'manufacturingFee') {
    // 制费计算
    calculatedResult.value = ((base + paint) * manuTax + (diff + small + gls + stn + fbr + purchase + bigHardware) * manuAdd) * adj
    console.log('制费计算结果:', manuTax, manuAdd, calculatedResult.value)
  } else if (currentCalculateType.value === 'profit') {
    // 利润计算
    calculatedResult.value = ((base + paint) * profitTaxRate + (diff + small + gls + stn + fbr + purchase + bigHardware) * profitAddRate) * adj
    console.log('利润计算结果:', calculatedResult.value)
  } else if (currentCalculateType.value === 'taxFee') {
    // 税费计算
    // 先计算人工费和制费
    const laborFee = ((base + paint) * laborTax + laborAdd) * adj
    const manufacturingFee = ((base + paint) * manuTax + (diff + small + gls + stn + fbr + purchase + bigHardware) * manuAdd) * adj
    // 再计算利润
    const profitFee = ((base + paint) * profitTaxRate + (diff + small + gls + stn + fbr + purchase + bigHardware) * profitAddRate) * adj
    // 再计算成本
    calculatedResult.value = ((base + paint + diff + small + gls + stn + fbr + purchase + bigHardware + laborFee + manufacturingFee + profitFee) * taxRate )
    console.log('税费计算结果:', calculatedResult.value, base, paint, diff, small, gls, stn, fbr, purchase, bigHardware, laborFee, manufacturingFee, profitFee, taxRate, adj)
  } else if (currentCalculateType.value === 'cost') {
    // 成本计算
    const summary = productInfo.value.materialSummary
    calculatedResult.value = (Number(summary.base) || 0) + (Number(summary.paint) || 0) + (Number(summary.difference) || 0) + 
                           (Number(summary.smallHardware) || 0) + (Number(summary.glass) || 0) + (Number(summary.stone) || 0) + 
                           (Number(summary.fabric) || 0) + (Number(summary.purchaseParts) || 0) + (Number(summary.bigHardwareFee) || 0) + 
                           (Number(summary.freightFee) || 0) + (Number(summary.installationFee) || 0) + (Number(summary.laborFee) || 0) + 
                           (Number(summary.manufacturingFee) || 0) +  (Number(summary.profit) || 0) + (Number(summary.taxFee) || 0)
    console.log('成本计算结果:', productInfo.value.materialSummary.cost, calculatedResult.value)
  } else if (currentCalculateType.value === 'materialTotal') {
    // 材料成本计算
    const summary = productInfo.value.materialSummary
    calculatedResult.value = (Number(summary.base) || 0) + (Number(summary.paint) || 0) + (Number(summary.difference) || 0) + 
                           (Number(summary.smallHardware) || 0) + (Number(summary.glass) || 0) + (Number(summary.stone) || 0) + 
                           (Number(summary.fabric) || 0) + (Number(summary.purchaseParts) || 0) + (Number(summary.bigHardwareFee) || 0)
    console.log('材料成本计算结果:', calculatedResult.value)
  }
  // 保留两位小数
  calculatedResult.value = Number(calculatedResult.value.toFixed(2))
}


// 监听价格明细，计算值
// watch(() => [
//   productInfo.value.materialSummary.base,
//   productInfo.value.materialSummary.paint,
//   productInfo.value.materialSummary.manufacturingFeeTax,
//   productInfo.value.materialSummary.difference,
//   productInfo.value.materialSummary.smallHardware,
//   productInfo.value.materialSummary.glass,
//   productInfo.value.materialSummary.stone,
//   productInfo.value.materialSummary.fabric,
//   productInfo.value.materialSummary.purchaseParts,
//   productInfo.value.materialSummary.bigHardwareFee,
//   productInfo.value.materialSummary.manufacturingFeeAdd,
//   productInfo.value.materialSummary.adjustment,
//   productInfo.value.materialSummary.freightFeeWAdd,
//   productInfo.value.materialSummary.freightFeeDAdd,
//   productInfo.value.materialSummary.freightFeeHAdd,
//   productInfo.value.materialSummary.freightFeeTax,
//   productInfo.value.materialSummary.laborFeeTax,
//   productInfo.value.materialSummary.laborFeeAdd,
//   productInfo.value.materialSummary.profitTax,
//   productInfo.value.materialSummary.profitAdd,
//   productInfo.value.materialSummary.taxFeeTax,
// ], () => {
//   if (showCalculateDialog.value) {
//     // 更新计算变量，强制转换为Number类型
//     calculateVariables.value.baseMaterial = Number(productInfo.value.materialSummary.base) || 0
//     calculateVariables.value.paintMaterial = Number(productInfo.value.materialSummary.paint) || 0
//     calculateVariables.value.manufacturingFeeTax = Number(productInfo.value.materialSummary.manufacturingFeeTax) || 0
//     calculateVariables.value.difference = Number(productInfo.value.materialSummary.difference) || 0
//     calculateVariables.value.smallHardware = Number(productInfo.value.materialSummary.smallHardware) || 0
//     calculateVariables.value.glass = Number(productInfo.value.materialSummary.glass) || 0
//     calculateVariables.value.stone = Number(productInfo.value.materialSummary.stone) || 0
//     calculateVariables.value.fabric = Number(productInfo.value.materialSummary.fabric) || 0
//     calculateVariables.value.purchaseParts = Number(productInfo.value.materialSummary.purchaseParts) || 0
//     calculateVariables.value.bigHardwareFee = Number(productInfo.value.materialSummary.bigHardwareFee) || 0
//     calculateVariables.value.manufacturingFeeAdd = Number(productInfo.value.materialSummary.manufacturingFeeAdd) || 0
//     calculateVariables.value.laborFeeTax = Number(productInfo.value.materialSummary.laborFeeTax) || 0
//     calculateVariables.value.laborFeeAdd = Number(productInfo.value.materialSummary.laborFeeAdd) || 0
//     calculateVariables.value.profitTax = Number(productInfo.value.materialSummary.profitTax) || 0
//     calculateVariables.value.profitAdd = Number(productInfo.value.materialSummary.profitAdd) || 0
//     calculateVariables.value.taxFeeTax = Number(productInfo.value.materialSummary.taxFeeTax) || 0
//     calculateVariables.value.freightFeeWAdd = Number(productInfo.value.materialSummary.freightFeeWAdd) || 0
//     calculateVariables.value.freightFeeDAdd = Number(productInfo.value.materialSummary.freightFeeDAdd) || 0
//     calculateVariables.value.freightFeeHAdd = Number(productInfo.value.materialSummary.freightFeeHAdd) || 0
//     calculateVariables.value.freightFeeTax = Number(productInfo.value.materialSummary.freightFeeTax) || 0
//     calculateVariables.value.adjustment = Number(productInfo.value.materialSummary.adjustment) || 1.0
//     // productInfo.value.materialSummary.freightFee = (productInfo.value.materialSummary.width + productInfo.value.materialSummary.freightFeeWAdd) * (productInfo.value.materialSummary.depth + productInfo.value.materialSummary.freightFeeDAdd) * (productInfo.value.materialSummary.height + productInfo.value.materialSummary.freightFeeHAdd) / 1000000000 * productInfo.value.materialSummary.freightFeeTax * productInfo.value.materialSummary.adjustment
//     calculateResult()
//   }
// }, { deep: true })

// 处理引用汇总行点击事件
const handleCorrelateMaterialRowClick = (material: CorrelateMaterialItem, index: number) => {
  // 切换当前物料的选中状态
  material.isSelected = !material.isSelected
  // 更新选择计数
  updateSelectCount()
}
</script>

<style scoped>
.material-list-page {
  /* min-height: 100vh; */
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* padding: 16px; */
}

.material-list-container {
  width: 100%;
  max-width: 1400px;
  position: relative;
  top: -32px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
}

.material-table, .price-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
}

.material-table :deep(th), .price-table :deep(th) {
  /* background-color: rgba(255, 255, 255, 0.05) !important; */
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 12px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.material-table :deep(td), .price-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.material-table :deep(td) > *, .price-table :deep(td) > * {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 8px; */
  word-break: break-all;
  white-space: pre-wrap;
}

/* 备注和描述字段样式 */
.material-table :deep(td) .v-textarea, .price-table :deep(td) .v-textarea {
  /* min-height: 36px; */
}

.material-table :deep(td) .v-textarea .v-field__input, .price-table :deep(td) .v-textarea .v-field__input {
  /* min-height: 36px; */
  padding: 8px !important;
  margin-right: 8px;
}

.material-table :deep(div.remark), .price-table :deep(div.remark){
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  text-align: left;
  margin: 0 auto;
}
/* .auto-grow-textarea {
  width: 100%;
} */

.auto-grow-textarea :deep(.v-field__input) {
  min-height: 36px !important;
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  min-height: 36px !important;
}

.auto-grow-textarea :deep(.v-field__outline) {
  min-height: 36px !important;
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.form-section {
  margin-bottom: 24px;
}

.material-list-section{
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 3px solid #D2475D;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.product-image-section {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: 16px 0;
}

.image-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-right: 16px;
  padding-top: 8px;
  min-width: 80px;
}

.image-content {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.image-upload-area {
  width: 300px;
  height: 200px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-upload-area:hover {
  border-color: #1976D2;
  background-color: rgba(25, 118, 210, 0.05);
}

.image-upload-area .v-icon {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.image-upload-area span {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.image-preview {
  width: 300px;
  height: 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview:hover .image-actions {
  opacity: 1;
}

.image-actions .v-icon {
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  transition: color 0.3s ease;
}

.image-actions .v-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(43, 45, 51, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  /* display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12); */
}

.material-images-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 8px;
}

.material-image-upload {
  width: 120px;
  height: 120px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 auto;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
}


/* .image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
} */

.material-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.material-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.material-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.material-list {
  max-height: 500px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
  padding-bottom: 50px;
}

/* Firefox 滚动条样式 */
.material-table {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.material-suggestions-dialog {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.scroll-textarea {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.material-list::-webkit-scrollbar,
.material-table::-webkit-scrollbar,
.material-suggestions-dialog::-webkit-scrollbar,
.scroll-textarea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.material-list::-webkit-scrollbar-track,
.material-table::-webkit-scrollbar-track,
.material-suggestions-dialog::-webkit-scrollbar-track,
.scroll-textarea::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.material-list::-webkit-scrollbar-thumb,
.material-table::-webkit-scrollbar-thumb,
.material-suggestions-dialog::-webkit-scrollbar-thumb,
.scroll-textarea::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.material-list::-webkit-scrollbar-thumb:hover,
.material-table::-webkit-scrollbar-thumb:hover,
.material-suggestions-dialog::-webkit-scrollbar-thumb:hover,
.scroll-textarea::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.material-list::-webkit-scrollbar-thumb:active,
.material-table::-webkit-scrollbar-thumb:active,
.material-suggestions-dialog::-webkit-scrollbar-thumb:active,
.scroll-textarea::-webkit-scrollbar-thumb:active {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.3) 100%);
}

/* 滚动条角落样式 */
.material-list::-webkit-scrollbar-corner,
.material-table::-webkit-scrollbar-corner,
.material-suggestions-dialog::-webkit-scrollbar-corner,
.scroll-textarea::-webkit-scrollbar-corner {
  background: transparent;
}

.material-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 16px;
}
.material-suggestion-item :deep(.v-list-item__content) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.material-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.material-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
  white-space: inherit!important;
}

.material-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  white-space: inherit!important;
  -webkit-line-clamp: none!important;
}

.material-suggestions-dialog :deep(.v-text-field) {
  margin-bottom: 16px;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__outline) {
  /* color: rgba(255, 255, 255, 0.12) !important; */
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-btn:hover) {
  background-color: rgba(25, 118, 210, 0.1) !important;
}

.image-count {
  color: #fff;
  font-size: 14px;
  margin-left: 8px;
}

.image-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  gap: 16px;
  width: 100%;
}

.image-preview {
  width: 300px;
  height: 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview:hover .preview-image {
  transform: scale(1.05);
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview:hover .image-actions {
  opacity: 1;
}

.image-actions .v-icon {
  color: #fff;
  cursor: pointer;
  font-size: 24px;
}

.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.v-table__wrapper .v-field__input {
  width: 100% !important;
  padding: 6px 8px !important;
}

.product-table-container td{
  padding: 10px 0px !important;
  text-align: center;
}

.product-table-container tr{
  padding: 10px !important;
}

.product-table-container td:first-child{
  padding-left: 8px!important;
}

.form-actions .v-btn{
  min-width: 120px;
}

/* 只读字段样式 */
:deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-right :deep(input) {
  text-align: right!important;
}

/* 隐藏productQuote输入框的上下箭头 */
.product-table-container :deep(input[type="number"])::-webkit-inner-spin-button,
.product-table-container :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-container :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.material-suggestions-dialog :deep(.mdi-magnify),
.material-suggestions-dialog :deep(.mdi-magnify::before),
.material-suggestions-dialog :deep(.mdi-close::before),
.material-suggestions-dialog :deep(.mdi-close-circle),
.material-suggestions-dialog :deep(.mdi-close) {
  color: #fff!important;
}

/* .mdi-magnify::before,
.mdi-close-circle::before {
  color: #fff!important;
} */

.mdi-close:hover{
  color: #ff5252!important;
}

/* 
.material-table :deep(th:nth-child(10)),
.material-table :deep(td:nth-child(10)) {
  position: sticky!important;
  right: 0;
  background-color: #2B2D33 !important;
  z-index: 2;
  min-width: 160px;
  width: 160px;
}

.material-table :deep(th:nth-child(10)) {
  z-index: 3;
}

.material-table :deep(td:nth-child(10)) {
  background-color: #2B2D33 !important;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px;
} */

/* 删除确认对话框样式 */
.delete-confirm-dialog {
  background-color: #2B2D33 !important;
}

.delete-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.8);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-actions) {
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-btn) {
  color: #fff;
}

.delete-confirm-dialog :deep(.v-btn--variant-text) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.delete-confirm-dialog :deep(.v-btn--variant-text:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.v-table__wrapper .v-field__input {
  width: 100% !important;
  padding: 6px 8px !important;
}

.correlate-btn{
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #2B2D33;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}

.calculate-dialog {
  background-color: #2B2D33 !important;
}

.calculate-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.calculate-dialog :deep(.v-card-text) {
  padding: 24px;
}

.formula-section {
  margin-bottom: 24px;
}

.formula-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.formula-content {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  white-space: pre-wrap;
}

.variables-section {
  margin-bottom: 24px;
}

.variables-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.result-section {
  margin: 24px 0;
}

.result-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.result-value {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.calc-section{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* .calc-section .calc-input{
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
} */

.calc-section :deep(.v-text-field),
.calc-section :deep(.v-field) {
  width: 88px !important;
  min-width: 88px !important;
  max-width: 88px !important;
  /* padding-inline: revert!important;  */
}

.calc-section :deep(.v-field--readonly.v-text-field),
.calc-section :deep(.v-field--readonly .v-field),
.calc-section :deep(.v-field--readonly .v-field__input) {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  /* padding-inline: revert!important;  */
}

.calc-section :deep(.v-field--readonly.calc-input-readonly.v-text-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly .v-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly .v-field__input) {
  width: 90px !important;
  min-width: 90px !important;
  max-width: 90px !important;
  /* padding-inline: revert!important;  */
}


.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input.v-text-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input .v-field),
.calc-section :deep(.v-field--readonly.calc-input-readonly.calc-special-input .v-field__input),
.calc-section :deep(.calc-special-input.v-text-field),
.calc-section :deep(.calc-special-input .v-field),
.calc-section :deep(.calc-special-input .v-field__input) {
  width: 94px !important;
  min-width: 94px !important;
  max-width: 94px !important;
  /* padding-inline: revert!important;  */
}

.calc-item{
  font-size: 26px;
  font-weight: 500;
  color: #fff;
  /* margin: 0 8px; */
  line-height: 40px;
}

.title-textImg{
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-text img{
  cursor: pointer;
}

/* 隐藏计算对话框输入框的上下箭头 */
.calculate-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.calculate-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.calculate-dialog :deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.seeRecord{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 30px;
  border: 1px solid #FFFFFF;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.material-table td:last-child .v-btn {
  display: block;
  min-width: auto;
  /* padding: 0 12px; */
  height: 32px;
  font-size: 13px;
  margin: 6px auto 8px;
  width: 70%;
}

.name-input :deep(.mdi:before){
  font-size: 24px!important;
}

.material-table td > * {
  max-width: 100%;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.material-table td:last-child > * {
  margin-right: 0px!important;
  margin: 6px auto 8px auto!important;
}

/* 引用汇总对话框复选框样式 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-icon) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input .v-icon) {
  color: #fff !important;
}

/* 未选中状态的边框 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input:not(.v-selection-control--dirty) .v-icon) {
  /* color: #fff !important; */
  /* border: 2px solid #fff !important; */
  border-radius: 2px;
}

/* 选中状态的背景色 */
.material-suggestions-dialog :deep(.v-checkbox .v-selection-control__wrapper .v-selection-control__input.v-selection-control--dirty .v-icon) {
  background-color: #fff !important;
  color: #2B2D33 !important;
  border: 1px solid #fff !important;
  border-radius: 2px;
}

.price-table :deep(th){
  padding: 0!important;
}


.product-info-item{
  text-align: left;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  line-height: 1.25;
  margin-top: 6px;
  font-size: 12px;
}
.count-item{
  width: fit-content;
  max-width: inherit!important;
  text-align: center;
  padding: 4px 6px;
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  color: #fff;
  margin-top: 6px;
}

.float-left{
  /* float: left; */
  margin-bottom: 12px;
}

.product-table-container {
  position: relative;
  z-index: 150;
}
.small-input :deep(.v-input){
  width: 70px!important;
  margin-right: 8px;
}

.small-input :deep(.v-field--variant-outlined .v-label.v-field-label--floating){
  font-size: 11px!important;
  display: inline-block;
  transform: translateY(-60%)!important;
}

.has-normal-input{
  position: absolute;
  bottom: 1px;
  right: 8px;
  padding: 2px 4px;
  font-size: 9px;
  color: #C3C4C5 !important;
}

.big-input :deep(.v-input){
  width: 116px!important;
  margin-right: 9px;
}

.right-0 :deep(.v-input){
  margin-right: 0px!important;
}

.calc-tip{
  width: 32px; 
  height: 16px; 
  margin-right: 0px; 
  cursor: pointer;
  margin-left: 4px;
}

.product-table-container :deep(.v-field--prepended) {
  --v-field-padding-start: 4px!important;
  padding-inline-start: 4px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input),
.material-control-table :deep(input),
.material-control-table :deep(.v-field__input){
  font-size: 12px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input){
  padding: 0 4px!important;
}
/* 隐藏quote输入框的上下箭头 */
:deep(input[type="number"])::-webkit-inner-spin-button,
:deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type="number"]) {
  -moz-appearance: textfield;
}
.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}
.contract-new-container {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-table-card {
  margin-top: 8px;
  width: 100%;
  overflow-x: auto;
}

.material-table :deep(th) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
}

.material-table {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  /* padding: 8px; */
}

.material-control-table :deep(td) > *{
  word-break: break-all;
  white-space: pre-wrap;
}

.product-table :deep(.v-field__input) {
  padding: 0 8px;
}

.product-table-card {
  margin-top: 8px;
  width: 100%;
}


.table-container {
  width: 100%;
  /* max-height: 70vh; */
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 8px; /* 为顶部滚动条预留空间 */
  /* padding-right: 8px; */
  /* 将滚动条放在顶部 */
  /* direction: rtl; */
}

/* .table-container > * {
  direction: ltr;
} */

.product-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  /* max-height: 68vh; */
  /* overflow: auto; */
}

.product-table :deep(th) {
  /* background-color: rgba(255, 255, 255, 0.05) !important; */
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 12px 8px;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* 修改操作列固定在右侧的样式 */
/* .product-table-container :deep(th:nth-child(14)), */
/* .product-table-container :deep(td:nth-child(14)), */
/* .material-control-table :deep(th:nth-child(14)),
.material-control-table :deep(td:nth-child(14)) {
  position: sticky!important;
  right: 0;
  background-color: #2B2D33 !important;
  z-index: 2;
  min-width: 160px;
  width: 160px;
} */

/* .product-table-container :deep(th:nth-child(14)),
.material-control-table :deep(th:nth-child(14)) {
  z-index: 3;
} */

/* .product-table-container :deep(td:nth-child(14)),
.material-control-table :deep(td:nth-child(14)) {
  background-color: #2B2D33 !important;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px;
} */

.material-control-table .text-right :deep(input) {
  text-align: right!important;
}

.product-table-container tr td{
  text-align: center!important;
}
.product-table-container :deep(.v-chip){
  height: 40px!important;
  width: 70px!important;
  line-height: 40px!important;
  text-align: center!important;
  margin: 0 auto!important;
  padding: 0!important;
  display: inline-block!important;
}

.material-control-table :deep(div.remark){
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 95%;
  white-space: pre-wrap;
  text-align: left;
  margin: 0 auto;
  font-size: 12px!important;
}

/* 修改操作按钮容器的样式 */
.product-table :deep(td:last-child) .d-flex {
  position: sticky;
  right: 0;
  background-color: #2B2D33;
  padding: 0 8px;
  width: 100%;
  justify-content: center;
  gap: 8px;
}

/* 修改操作按钮的样式 */
.product-table :deep(td:last-child) .v-btn {
  display: block;
  min-width: auto;
  /* padding: 0 12px; */
  height: 32px;
  font-size: 13px;
  margin: 6px auto 8px;;
  width: 70%;
}

.product-table :deep(td) {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
  transition: background-color 0.3s ease;
}

/* 确保表格内容不会溢出 */
.product-table :deep(td) > * {
  max-width: 100%;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  margin-right: 8px;
}

.product-table td:last-child > div{
  margin-right: 0;
}

.priceRight {
  margin-right: 0px;
}

/* 表格中设置上下间距可显示label */
/* .product-table-container td{
  padding: 15px 0 !important;
} */

.product-table-container td:first-child{
  padding: 0!important;
}

/* 备注和描述字段样式 */
.product-table :deep(td) .v-textarea {
  /* min-height: 36px; */
  height: auto!important;
}

.product-table :deep(td) .v-textarea .v-field__input {
  /* min-height: 36px; */
  padding: 10px 4px !important;
  margin-right: 8px;
}

.product-table :deep(td) .v-textarea.materialDescription .v-field__input {
  height: auto!important;
  /* padding: 10px 4px 10px 38px !important; */
  /* position: relative; */
}

.auto-grow-textarea {
  /* width: 100%; */
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.preview-image-zoomed{
  max-width: 300px!important;
  width: 300px!important;
  height: 300px!important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1500;
  /* background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
}

.preview-image-zoomed .image-preview-item{
  width: 300px!important;
  height: 300px!important;
}

/* .product-image-upload {
  width: 120px;
  height: 120px;
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 auto;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
} */

.image-preview-item {
  width: 140px;
  height: 140px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.image-preview-item .image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-actions {
  opacity: 1;
}

.image-preview-item .image-actions .v-icon {
  color: #fff;
  cursor: pointer;
}

.image-preview-item .image-actions .v-icon:hover {
  color: #ff5252;
}

.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

/* 只读字段样式 */
:deep(.v-field--readonly ) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}


:deep(.v-field--readonly.description) {
  background-color: transparent!important;
}

:deep(.v-field--readonly.description .v-field__field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.company-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.company-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.company-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.company-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.company-list::-webkit-scrollbar {
  width: 6px;
}

.company-list::-webkit-scrollbar-track {
  background: transparent;
}

.company-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.company-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.company-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.company-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
}

.company-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

:deep(.dialog-bottom-transition-enter-active),
:deep(.dialog-bottom-transition-leave-active) {
  transition: transform 0.2s ease-in-out;
}

:deep(.dialog-bottom-transition-enter-from),
:deep(.dialog-bottom-transition-leave-to) {
  transform: translateY(100%);
}

.submit-btn {
  background-color: #1976D2 !important;
  color: #fff !important;
}

.submit-btn:hover {
  background-color: #1565C0 !important;
}

.save-btn {
  background-color: rgba(3, 169, 244, 0.6) !important;
  color: #03A9F4 !important;
  font-weight: 500;
}

.save-btn:hover {
  background-color: rgba(3, 169, 244, 0.5) !important;
}

.region-dialog {
  background-color: #2B2D33 !important;
}

.region-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.region-dialog :deep(.v-card-text) {
  padding: 16px;
}

.region-selector {
  display: flex;
  gap: 16px;
  height: 400px;
}

.province-list,
.city-list {
  flex: 1;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 8px;
}

.province-item,
.city-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.province-item:hover,
.city-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.province-item.active,
.city-item.active {
  background-color: #1976D2;
  color: #fff;
}

.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 6px;
}

.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: transparent;
}

.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}


.exchange-rate-field :deep(.v-field__append-inner) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon) {
  cursor: help;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon:hover) {
  color: #ff5252 !important;
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}

.delete-confirm-dialog {
  background-color: #2B2D33 !important;
}

.delete-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7);
  padding: 16px;
}

.delete-confirm-dialog :deep(.v-card-actions) {
  padding: 8px 16px 16px;
}

/* 隐藏quote输入框的上下箭头 */
:deep(input[type="number"])::-webkit-inner-spin-button,
:deep(input[type="number"])::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type="number"]) {
  -moz-appearance: textfield;
}

.price-show div{
  width: 200px!important;
}

.contract-btns{
  display: flex;
}

.contract-btns .ml-4{
  margin-left: 0px!important;
  margin-right: 16px!important;
}

.text-right :deep(input) {
  text-align: right!important;
}

.mdi-magnify::before{
  color: #fff!important;
}

.mdi-close:hover{
  color: #ff5252!important;
}

.company-suggestions-dialog :deep(.mdi-magnify),
.company-suggestions-dialog :deep(.mdi-magnify::before),
.company-suggestions-dialog :deep(.mdi-close::before),
.company-suggestions-dialog :deep(.mdi-close-circle),
.company-suggestions-dialog :deep(.mdi-close),
.material-suggestions-dialog :deep(.mdi-magnify),
.material-suggestions-dialog :deep(.mdi-magnify::before),
.material-suggestions-dialog :deep(.mdi-close::before),
.material-suggestions-dialog :deep(.mdi-close-circle),
.material-suggestions-dialog :deep(.mdi-close) {
  color: #fff!important;
}
   
.text-status-default{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  background-color: #414141 !important;
  color: #fff !important;
}    

.text-status-process{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}    

.text-status-waiting{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  background-color: #453F2E !important;
  color: #EAB20B !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.text-status-success{
  height: 40px !important;
  width: 70px !important;
  line-height: 40px !important;
  text-align: center !important;
  margin: 0 auto !important;
  padding: 0 !important;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

.prosee-status-wait,
.prosee-status-process,
.prosee-status-success{
  border-radius: 4px;
  min-width: 110px!important;
  height: 40px!important;
  text-align: center;
  margin-right: 16px!important;    
  line-height: 1.2;
  padding: 4px 0;
  cursor: pointer;
}

.prosee-status-error{
  min-width: 110px!important;
  height: 40px!important;
  text-align: center;
  margin-right: 16px!important;    
  line-height: 1.2;
  padding: 4px 0;
  cursor: pointer;
  background: var(--primary-gradient) !important;
  box-shadow: 0 2px 4px #D2475D !important;
  color: #fff!important;
  border-radius: 4px;
  border: none !important;
  font-weight: 500 !important;
  position: relative;
}

.prosee-status-wait{
  border-radius: 4px;
  background-color: #453F2E !important;
  color: #EAB20B !important;
  /* padding: 0!important; */
  /* line-height: 50px!important; */
}

.prosee-status-process{
  border-radius: 4px;
  background-color: #453237 !important;
  color: rgb(var(--v-theme-error)) !important;
}

.prosee-status-success{
  border-radius: 4px;
  background-color: #3B4D3E !important;
  color: #66BB6A !important;
}

.status-time{
  font-size: 12px;
  /* color: rgba(255, 255, 255, 0.7); */
}

.proseeBg,.contract-btns .v-btn{
  min-width: 110px!important;
  height: 40px!important;
  line-height: 1.2;
  padding: 4px 0;
}

.proseeBg{
  background-color: #453237 !important;
  margin-right: 16px;
  text-align: center;
  /* padding: 6px 16px; */
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.processing{
  color: rgb(var(--v-theme-error)) !important;
}
.processed{
  color: #66BB6A !important;
}

.section-title-group{
  display: flex;
  gap: 16px;
  margin-top: 40px;
  position: relative;
}

.estimate-btn{
  position: absolute;
  /* right: 28px; */
  right: 0;
  top: 0;
  width: 76px;
}

.section-title-group div{
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: 106px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.6)!important;
}

.section-title-group div.section-title{
  color: #fff!important;
}

.v-img__img--cover{
  object-fit: contain!important;
}

.text-center{
  text-align: center!important;
}

.action-confirm-dialog {
  background-color: #2B2D33 !important;
}

.action-confirm-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.action-confirm-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.7);
  padding: 16px;
}

.action-confirm-dialog :deep(.v-card-actions) {
  padding: 8px 16px 16px;
}

.seeRecord{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 30px;
  border: 1px solid #FFFFFF;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.salesman-review-refuse{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  background: #453237;
  border-radius: 4px;
  color: #DE4B63;
  margin-top: 12px;
  box-sizing: border-box;
}
.salesman-review-agree{
  width: 70%;
  text-align: center;
  margin: 0 auto;
  height: 32px;
  line-height: 32px;
  background-color: #3B4D3E;
  border-radius: 4px;
  color: #fff;
  margin-top: 12px;
  box-sizing: border-box;
}

/* 确保PDF图标能正确显示 */
:deep(.mdi-file-pdf-box),
:deep(.mdi-file-pdf) {
  font-family: "Material Design Icons" !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-size: 24px !important;
  line-height: 1 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  display: inline-block !important;
  white-space: nowrap !important;
  word-wrap: normal !important;
  direction: ltr !important;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  -webkit-font-feature-settings: "liga" !important;
  font-feature-settings: "liga" !important;
}

.status-icon {
  position: absolute;
  top: 4px;
  right: 2px;
  background-color: #2B2D33;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  color: #fff!important;
  background: transparent!important;
  border: 1px solid #fff!important;
  font-size: 14px!important;
  width: 14px!important;
  height: 14px!important;
}

.v-table--fixed-header > .v-table__wrapper > table > thead{
  background: #2B2D33 !important;
  z-index: 500;
}

/* 导入动画样式 */
.import-animation-dialog {
  background-color: rgba(43, 45, 51, 0.8) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  border-radius: 0;
}

.import-animation-dialog :deep(.v-card) {
  background: transparent !important;
  box-shadow: none !important;
}

.import-animation-dialog :deep(.v-card-text) {
  color: rgba(255, 255, 255, 0.9);
  padding: 0;
  background: transparent;
}

.import-animation-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}

.import-animation-text {
  color: #fff !important;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.import-animation-dots {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 2rem;
}

.import-animation-dots .dot {
  width: 12px;
  height: 12px;
  background-color: var(--v-theme-primary);
  border-radius: 50%;
  animation: dot-pulse 1.5s infinite ease-in-out;
}

.import-animation-dots .dot:nth-child(1) {
  animation-delay: 0s;
}

.import-animation-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.import-animation-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dot-pulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

.import-animation-dialog :deep(.v-card-text) {
  max-height: 100vh;
  overflow: hidden;
}

.material-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.material-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.material-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.material-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.material-list::-webkit-scrollbar {
  width: 6px;
}

.material-list::-webkit-scrollbar-track {
  background: transparent;
}

.material-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.material-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.material-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 16px;
}
.material-suggestion-item :deep(.v-list-item__content) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.material-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.material-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
  margin-bottom: 4px;
}

.material-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.material-suggestions-dialog :deep(.v-text-field) {
  margin-bottom: 16px;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input) {
  color: #fff !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__outline) {
  /* color: rgba(255, 255, 255, 0.12) !important; */
}

.material-suggestions-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-text-field .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-suggestions-dialog :deep(.v-btn:hover) {
  background-color: rgba(25, 118, 210, 0.1) !important;
}

.price-tip-tooltip :deep(.v-overlay__content) {
  padding: 0!important;
}

.price-tip-table {
  display: flex;
  align-items: center;
}

.title-text{
  min-width: 70px; 
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.title-text-1{
  min-width: 50px;
  color: rgba(255, 255, 255, 0.7) !important;
}

.name-input :deep(.mdi:before){
  font-size: 24px!important;
}

.product-table-container :deep(.v-field--prepended) {
  --v-field-padding-start: 4px!important;
  padding-inline-start: 4px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input),
.material-control-table :deep(input),
.material-control-table :deep(.v-field__input){
  font-size: 12px!important;
}

.product-table-container :deep(.v-field__input),
.product-table-container :deep(input){
  padding: 0 4px!important;
}
.material-control-table :deep(thead > tr > th),
.product-table-container :deep(thead > tr > th){
  padding: 0!important;
}

.product-table-container :deep(.description .v-field__input),
.material-control-table :deep(.description .v-field__input){
  font-size: 10px!important;
}

.product-table-container .price-input-group :deep(.v-field__input){
  font-size: 14px!important;
}

.local-amount-display{
  position: absolute;
  bottom: 11px;
  right: 0px;
  padding: 2px 4px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5) !important;
}

.local-amount-display2{
  position: absolute;
  bottom: -2px;
  right: 0px;
  padding: 2px 4px;
  font-size: 9px;
  color: rgba(255, 255, 255, 0.5) !important;
}

.code-input{
  margin-bottom: 16px!important;
}

.size-input,.size-input :deep(.v-field__input),.size-input :deep(.v-field){
  height: 30px!important;
  min-height: 30px!important;
  box-sizing: border-box!important;
  margin-bottom: 8px!important;
}

.priceLeft:deep(div.mb-1){
  margin-bottom: 12px!important;
}

.priceLeft :deep(.v-field__input){
  position: relative;
  /* top: -2px; */
}

.product-table-container {
  position: relative;
  z-index: 150;
}

.prosee-status-error.btn-hover :hover{
  box-shadow: #D2475D -1px 4px 14px 1px!important;
  /* box-shadow: 0px 4px 12px #D2475D!important; */
}

.estimate-dialog-content{
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
}

.estimate-dialog-content :deep(.v-field__input),
.estimate-dialog-content :deep(.v-input){
  width: 100px!important;
  text-align: right!important;
}

:deep(.mdi:before, .mdi-set){
    color: #FFFFFF;
}

.image-navigation :deep(.mdi:before, .mdi-set){
    font-size: 36px!important;
}

.zoom-controls{
  margin: 0 auto;
}

.zoom-controls button{
  width: 30px!important;
  height: 30px!important;
  background: rgba(43, 45, 51, 0.8) !important;
  border-radius: 50% !important;
}

.zoom-controls :deep(.mdi:before, .mdi-set){
    font-size: 20px!important;
}
/* 确保v-menu能正确显示 */
:deep(.v-menu) {
    z-index: 9999;
}

/* v-date-picker样式 */
:deep(.v-date-picker) {
    background-color: #2B2D33;
    border: 1px solid #404248;
}

.product-info-section {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 3px solid #D2475D;
}

:deep(.v-text-field) .v-field__input,
:deep(.v-text-field) .v-field__field,
:deep(.v-text-field) input,
:deep(.v-select) .v-field__input,
:deep(.v-select) .v-field__field,
:deep(.v-select) input,
:deep(.v-select) .v-select__selection-text,
:deep(.v-select) .v-select__selection,
:deep(.v-textarea) .v-field__input,
:deep(.v-textarea) .v-field__field,
:deep(.v-textarea) textarea {
  color: #fff !important;
}

:deep(.v-text-field) .v-field__outline,
:deep(.v-select) .v-field__outline,
:deep(.v-textarea) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.v-text-field) .v-field__input::placeholder,
:deep(.v-select) .v-field__input::placeholder,
:deep(.v-textarea) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-label,
:deep(.v-select) .v-label,
:deep(.v-textarea) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.v-text-field) .v-field__append-inner i,
:deep(.v-select) .v-field__append-inner i,
:deep(.v-textarea) .v-field__append-inner i {
  color: rgba(255, 255, 255, 0.7) !important;
}

.material-table-card {
  margin-top: 8px;
  width: 100%;
  overflow-x: auto;
}

.material-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
}

.material-table :deep(th) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
}

/* .material-table {
  color: #fff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  white-space: nowrap;
  padding: 8px;
} */

.material-control-table :deep(td) > *{
  word-break: break-all;
  white-space: pre-wrap;
}



.product-table :deep(.v-field__input) {
  padding: 0 8px;
}

.product-table-card {
  margin-top: 8px;
  width: 100%;
}

.product-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  /* max-height: 68vh; */
  /* overflow: auto; */
}

.product-images-container {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: center;
  align-items: center;
  gap: 8px;
  /* position: relative; */
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, .25);
  border-radius: 4px;
}


.delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .delete-icon {
  opacity: 1;
}

.delete-icon:hover {
  color: #ff5252;
}

.hidden-input {
  display: none;
}

/* 只读字段样式 */
:deep(.v-field--readonly ) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}


:deep(.v-field--readonly.description) {
  background-color: transparent!important;
}

:deep(.v-field--readonly.description .v-field__field) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* 优化滚动条样式 */
:deep(.table-container .v-table__wrapper)::-webkit-scrollbar,
.table-container::-webkit-scrollbar,
.company-list::-webkit-scrollbar,
.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-track,
.table-container::-webkit-scrollbar-track,
.company-list::-webkit-scrollbar-track,
.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-thumb,
.table-container::-webkit-scrollbar-thumb,
.company-list::-webkit-scrollbar-thumb,
.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;
}

:deep(.table-container .v-table__wrapper)::-webkit-scrollbar-thumb:hover,
.table-container::-webkit-scrollbar-thumb:hover,
.company-list::-webkit-scrollbar-thumb:hover,
.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestions-dialog {
  background-color: #2B2D33 !important;
}

.company-suggestions-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.company-suggestions-dialog :deep(.v-card-text) {
  padding: 16px;
}

.company-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: transparent !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.company-list::-webkit-scrollbar {
  width: 6px;
}

.company-list::-webkit-scrollbar-track {
  background: transparent;
}

.company-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.company-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.company-suggestion-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.company-suggestion-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.company-suggestion-item :deep(.v-list-item-title) {
  color: #fff;
  font-size: 14px;
}

.company-suggestion-item :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

:deep(.dialog-bottom-transition-enter-active),
:deep(.dialog-bottom-transition-leave-active) {
  transition: transform 0.2s ease-in-out;
}

:deep(.dialog-bottom-transition-enter-from),
:deep(.dialog-bottom-transition-leave-to) {
  transform: translateY(100%);
}

.submit-btn {
  background-color: #1976D2 !important;
  color: #fff !important;
}

.submit-btn:hover {
  background-color: #1565C0 !important;
}

.save-btn {
  background-color: rgba(3, 169, 244, 0.6) !important;
  color: #03A9F4 !important;
  font-weight: 500;
}

.save-btn:hover {
  background-color: rgba(3, 169, 244, 0.5) !important;
}

.region-dialog {
  background-color: #2B2D33 !important;
}

.region-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
}

.region-dialog :deep(.v-card-text) {
  padding: 16px;
}

.region-selector {
  display: flex;
  gap: 16px;
  height: 400px;
}

.province-list,
.city-list {
  flex: 1;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 8px;
}

.province-item,
.city-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.province-item:hover,
.city-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.province-item.active,
.city-item.active {
  background-color: #1976D2;
  color: #fff;
}

.province-list::-webkit-scrollbar,
.city-list::-webkit-scrollbar {
  width: 6px;
}

.province-list::-webkit-scrollbar-track,
.city-list::-webkit-scrollbar-track {
  background: transparent;
}

.province-list::-webkit-scrollbar-thumb,
.city-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.province-list::-webkit-scrollbar-thumb:hover,
.city-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.exchange-rate-field :deep(.v-field__append-inner) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon) {
  cursor: help;
}

.exchange-rate-field :deep(.v-field__append-inner .v-icon:hover) {
  color: #ff5252 !important;
}

.auto-grow-textarea :deep(.v-field__input) {
  /* min-height: 36px !important; */
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(.v-field__outline) {
  /* min-height: 36px !important; */
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

.price-input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* .priceLeft {
  float: left;
  width: 46%;
}

.priceRight {
  float: right;
  width: 46%;
} */

/* 清除浮动 */
.priceLeft::after,
.priceRight::after {
  content: '';
  display: block;
  clear: both;
}

.price-input-group :deep(.v-field) {
  /* background-color: rgba(255, 255, 255, 0.05); */
}

.price-input-group :deep(.v-field--readonly .v-field__input) {
  /* color: #ff5252 !important; */
}

.price-input-group :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.price-input-group :deep(.v-field:hover .v-field__outline) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.price-input-group :deep(.v-field--focused .v-field__outline) {
  /* color: #1976D2 !important; */
}
.contract-new-container {
  width: 100%;
  max-width: 1500px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px;
  background: #D2475D;
}

.form-card :deep(.v-card-text) {
  padding: 24px;
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.form-section {
  margin-bottom: 24px;
}

.section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

/* 产品信息固定样式 */
.product-info-section {
  transition: all 0.3s ease;
  z-index: 100;
}

.product-info-section.fixed-top {
  position: fixed;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  /* background: #1E1E1E; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  padding: 16px;
  margin: 0;
  border-radius: 0;
  width: 1380px;
  z-index: 1000;
}

.product-info-section.fixed-top .form-section {
  margin: 0;
}

.product-info-section.fixed-top .table-container {
  max-height: 80vh;
  overflow-y: auto;
}

.product-table :deep(td) .v-textarea.description .v-field__input {
  /* height: auto!important; */
  padding: 10px 4px 10px 38px !important;
  /* position: relative; */
}

/* 图片切换导航样式 */
.image-navigation {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  /* background: rgba(0, 0, 0, 0.7); */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview-item:hover .image-navigation {
  opacity: 1;
}

.nav-btn {
  width: 30px !important;
  height: 30px !important;
  background: rgba(43,45,51,0.8) !important;
  border-radius: 50% !important;
  /* transition: all 0.3s ease !important; */
}

.nav-btn:hover {
  /* transform: scale(1.1); */
}

.nav-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.top-input{
  margin-top: 16px;
}

.material-table .no-img{
  width: 80px!important;
  height: 80px!important;
  line-height: 80px!important;
}

.material-table .image-preview-item {
  width: 140px;
  height: 140px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0 auto;
}

.material-table .image-preview-item {
  width: 80px!important;
  height: 80px!important;
}
.image-preview-item .preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.image-preview-item:hover .preview-image {
  transform: scale(1.05);
}

.material-table .image-count-icon{
  width: 10px!important;
  height: 10px!important;
}

.material-table .image-count-preview{
  font-size: 10px!important;
}

.material-table td{
  padding: 0px !important;
  text-align: center;
}

.scroll-textarea{
  padding: 6px 0!important;
}

.v-btn.bg-primary.v-btn--variant-flat.seeMaterial{
  border: 1px solid #FFFFFF!important;
  background-color: transparent!important;
  background: transparent!important;
  box-shadow: none!important;
  margin-right: 4px!important;
}

.material-table[data-v-2c12aa8c], .price-table[data-v-2c12aa8c] {
  background-color: transparent;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  /* table-layout: fixed; */
  /* min-width: 1200px; */
  border-collapse: separate;
  border-spacing: 0;
}

.material-list-table{
  background-color: transparent;
  width: 100%;
  /* table-layout: fixed; */
  /* min-width: 1200px; */
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #36383D;
  color: #fff !important;
}

.material-list-table td{
  border-bottom: 1px solid rgb(54, 56, 61)!important;
}

.material-list-table th{
  color: #fff!important;
  text-align: center!important;
}

.material-list-table th .small-title{
  font-size: 12px!important;
}

:deep(.estimate-checkbox){
  width: 36px;
  height: 36px;
}

:deep(.estimate-checkbox .v-selection-control){
  width: 36px;
  height: 36px;
  min-height: 36px;
  background: #D4485E;
  border-radius: 3px 3px 3px 3px;
}

:deep(.estimate-checkbox .v-icon){
  left: -2px!important;
}
/* :deep(.estimate-checkbox .v-field__input){
  color: #fff!important;
}

:deep(.estimate-checkbox .v-field__input .v-icon){
  color: #fff!important;
} */

/* 去除按钮点击时的黑色透明圆样式 */
:deep(.v-btn:active),
:deep(.v-btn:focus),
:deep(.v-btn:focus-visible) {
  background-color: transparent !important;
  box-shadow: none !important;
}

:deep(.v-btn .v-ripple__container) {
  display: none !important;
}

:deep(.estimate-checkbox .v-checkbox:active),
:deep(.estimate-checkbox.v-checkbox:focus),
:deep(.estimate-checkbox.v-checkbox:focus-visible) {
  background-color: transparent !important;
  box-shadow: none !important;
}

:deep(.estimate-checkbox .v-checkbox .v-ripple__container) {
  display: none !important;
}

/* 去除所有按钮的ripple效果 */
:deep(.estimate-checkbox .v-ripple__container) {
  display: none !important;
}

/* 去除按钮active状态的背景色 */
:deep(.estimate-checkbox .v-btn--active) {
  background-color: transparent !important;
}

/* 去除按钮focus状态的背景色 */
:deep(.estimate-checkbox .v-btn:focus) {
  background-color: transparent !important;
}

.del-tr{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: left center;
}

.material-book-container{
  position: fixed;
  top: 80px;
  right: 18px;
  z-index: 1000;
}

.material-book-btn{
  position: fixed;
  top: 80px;
  right: 18px;
  z-index: 1000;
  width: 36px;
  /* height: 76px; */
  /* background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border-radius: 2px;
  text-align: center; */
  cursor: pointer;
  color: #000;
  /* font-size: 14px;
  line-height: 18px;
  font-weight: 500; */
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.material-book-content{
  position: fixed;
  top: 190px;
  right: 18px;
  z-index: 1000;
  width: 600px;
  max-height: 750px;
  overflow-y: auto;
  background: #36383D;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border-radius: 5px 5px 5px 5px;
  padding: 14px 14px 14px 14px;
}

.material-book-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.material-book-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.material-book-content::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.material-book-title{
  font-size: 16px;
  font-weight: 400;
  color: #D4D4D4;
}

.material-book-tip{
  font-weight: 400;
  font-size: 14px;
  color: #B6B6B6;
  margin-bottom: 10px;
}

.material-book-list{
  width: 100%;
  /* height: 390px;
  overflow-y: auto; */
}

.material-book-list img{
  width: 100%;
}

:deep(.v-field--readonly .mdi-menu-down) {
  display: none!important;
}

.common-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.common-loading-container {
  text-align: center;
  color: #fff;
}

.common-loading-spinner {
  border: 4px solid #2B2D33;
  border-top: 4px solid #D2475D;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.common-loading-text {
  margin-top: 16px;
  font-size: 14px;
}

.outsourceBtn{
  background: #36383D;
  border-radius: 2px 2px 2px 2px;
  color: #FFFFFF;
}

.yinyonghuizong :deep(.v-input__details){
  display: none!important;
}

.icon-white :deep(.v-field__append-inner .v-icon) {
  color: white !important;
  cursor: pointer;
}

.icon-white :deep(.v-field__field) {
  cursor: pointer;
}

:deep(.height-description .v-field__input) {
  max-height: 80px!important;
  overflow-y: auto!important;
  /* font-size: 12px!important; */
  margin-right: 0!important;
  word-break: break-all!important;
}

:deep(.height-description .v-field__input::-webkit-scrollbar) {
  width: 8px!important;
  height: 8px!important;
}

:deep(.height-description .v-field__input::-webkit-scrollbar-thumb) {
  background-color: rgba(255, 255, 255, 0.2)!important;
  border-radius: 4px!important;
  cursor: default;
}

:deep(.height-description .v-field__input::-webkit-scrollbar-track) {
  background-color: rgba(255, 255, 255, 0.05)!important;
  border-radius: 4px!important;
}

/* 推荐类型切换图片按钮样式 */
.recommendation-toggle-btn {
  cursor: pointer;
  transition: opacity 0.2s ease;
  height: 30px;
  width: auto;
}

.recommendation-toggle-btn:hover {
  opacity: 0.8;
}
</style>